/*! jQuery & Zepto Lazy v1.7.10 - http://jquery.eisbehr.de/lazy - MIT&GPL-2.0 license - Copyright 2012-2018 Daniel 'Eisbehr' Kern */
!function(t,e){"use strict";function r(r,a,i,u,l){function f(){L=t.devicePixelRatio>1,i=c(i),a.delay>=0&&setTimeout(function(){s(!0)},a.delay),(a.delay<0||a.combined)&&(u.e=v(a.throttle,function(t){"resize"===t.type&&(w=B=-1),s(t.all)}),u.a=function(t){t=c(t),i.push.apply(i,t)},u.g=function(){return i=n(i).filter(function(){return!n(this).data(a.loadedName)})},u.f=function(t){for(var e=0;e<t.length;e++){var r=i.filter(function(){return this===t[e]});r.length&&s(!1,r)}},s(),n(a.appendScroll).on("scroll."+l+" resize."+l,u.e))}function c(t){var i=a.defaultImage,o=a.placeholder,u=a.imageBase,l=a.srcsetAttribute,f=a.loaderAttribute,c=a._f||{};t=n(t).filter(function(){var t=n(this),r=m(this);return!t.data(a.handledName)&&(t.attr(a.attribute)||t.attr(l)||t.attr(f)||c[r]!==e)}).data("plugin_"+a.name,r);for(var s=0,d=t.length;s<d;s++){var A=n(t[s]),g=m(t[s]),h=A.attr(a.imageBaseAttribute)||u;g===N&&h&&A.attr(l)&&A.attr(l,b(A.attr(l),h)),c[g]===e||A.attr(f)||A.attr(f,c[g]),g===N&&i&&!A.attr(E)?A.attr(E,i):g===N||!o||A.css(O)&&"none"!==A.css(O)||A.css(O,"url('"+o+"')")}return t}function s(t,e){if(!i.length)return void(a.autoDestroy&&r.destroy());for(var o=e||i,u=!1,l=a.imageBase||"",f=a.srcsetAttribute,c=a.handledName,s=0;s<o.length;s++)if(t||e||A(o[s])){var g=n(o[s]),h=m(o[s]),b=g.attr(a.attribute),v=g.attr(a.imageBaseAttribute)||l,p=g.attr(a.loaderAttribute);g.data(c)||a.visibleOnly&&!g.is(":visible")||!((b||g.attr(f))&&(h===N&&(v+b!==g.attr(E)||g.attr(f)!==g.attr(F))||h!==N&&v+b!==g.css(O))||p)||(u=!0,g.data(c,!0),d(g,h,v,p))}u&&(i=n(i).filter(function(){return!n(this).data(c)}))}function d(t,e,r,i){++z;var o=function(){y("onError",t),p(),o=n.noop};y("beforeLoad",t);var u=a.attribute,l=a.srcsetAttribute,f=a.sizesAttribute,c=a.retinaAttribute,s=a.removeAttribute,d=a.loadedName,A=t.attr(c);if(i){var g=function(){s&&t.removeAttr(a.loaderAttribute),t.data(d,!0),y(T,t),setTimeout(p,1),g=n.noop};t.off(I).one(I,o).one(D,g),y(i,t,function(e){e?(t.off(D),g()):(t.off(I),o())})||t.trigger(I)}else{var h=n(new Image);h.one(I,o).one(D,function(){t.hide(),e===N?t.attr(C,h.attr(C)).attr(F,h.attr(F)).attr(E,h.attr(E)):t.css(O,"url('"+h.attr(E)+"')"),t[a.effect](a.effectTime),s&&(t.removeAttr(u+" "+l+" "+c+" "+a.imageBaseAttribute),f!==C&&t.removeAttr(f)),t.data(d,!0),y(T,t),h.remove(),p()});var m=(L&&A?A:t.attr(u))||"";h.attr(C,t.attr(f)).attr(F,t.attr(l)).attr(E,m?r+m:null),h.complete&&h.trigger(D)}}function A(t){var e=t.getBoundingClientRect(),r=a.scrollDirection,n=a.threshold,i=h()+n>e.top&&-n<e.bottom,o=g()+n>e.left&&-n<e.right;return"vertical"===r?i:"horizontal"===r?o:i&&o}function g(){return w>=0?w:w=n(t).width()}function h(){return B>=0?B:B=n(t).height()}function m(t){return t.tagName.toLowerCase()}function b(t,e){if(e){var r=t.split(",");t="";for(var a=0,n=r.length;a<n;a++)t+=e+r[a].trim()+(a!==n-1?",":"")}return t}function v(t,e){var n,i=0;return function(o,u){function l(){i=+new Date,e.call(r,o)}var f=+new Date-i;n&&clearTimeout(n),f>t||!a.enableThrottle||u?l():n=setTimeout(l,t-f)}}function p(){--z,i.length||z||y("onFinishedAll")}function y(t,e,n){return!!(t=a[t])&&(t.apply(r,[].slice.call(arguments,1)),!0)}var z=0,w=-1,B=-1,L=!1,T="afterLoad",D="load",I="error",N="img",E="src",F="srcset",C="sizes",O="background-image";"event"===a.bind||o?f():n(t).on(D+"."+l,f)}function a(a,o){var u=this,l=n.extend({},u.config,o),f={},c=l.name+"-"+ ++i;return u.config=function(t,r){return r===e?l[t]:(l[t]=r,u)},u.addItems=function(t){return f.a&&f.a("string"===n.type(t)?n(t):t),u},u.getItems=function(){return f.g?f.g():{}},u.update=function(t){return f.e&&f.e({},!t),u},u.force=function(t){return f.f&&f.f("string"===n.type(t)?n(t):t),u},u.loadAll=function(){return f.e&&f.e({all:!0},!0),u},u.destroy=function(){return n(l.appendScroll).off("."+c,f.e),n(t).off("."+c),f={},e},r(u,l,a,f,c),l.chainable?a:u}var n=t.jQuery||t.Zepto,i=0,o=!1;n.fn.Lazy=n.fn.lazy=function(t){return new a(this,t)},n.Lazy=n.lazy=function(t,r,i){if(n.isFunction(r)&&(i=r,r=[]),n.isFunction(i)){t=n.isArray(t)?t:[t],r=n.isArray(r)?r:[r];for(var o=a.prototype.config,u=o._f||(o._f={}),l=0,f=t.length;l<f;l++)(o[t[l]]===e||n.isFunction(o[t[l]]))&&(o[t[l]]=i);for(var c=0,s=r.length;c<s;c++)u[r[c]]=t[0]}},a.prototype.config={name:"lazy",chainable:!0,autoDestroy:!0,bind:"load",threshold:500,visibleOnly:!1,appendScroll:t,scrollDirection:"both",imageBase:null,defaultImage:"data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==",placeholder:null,delay:-1,combined:!1,attribute:"data-src",srcsetAttribute:"data-srcset",sizesAttribute:"data-sizes",retinaAttribute:"data-retina",loaderAttribute:"data-loader",imageBaseAttribute:"data-imagebase",removeAttribute:!0,handledName:"handled",loadedName:"loaded",effect:"show",effectTime:0,enableThrottle:!0,throttle:250,beforeLoad:e,afterLoad:e,onError:e,onFinishedAll:e},n(t).on("load",function(){o=!0})}(window);

/*============================================================================
  Image functions
==============================================================================*/

  (function() {
    var savd = XMLHttpRequest;
		 XMLHttpRequest.prototype = function() {
         this.init = function() {

           //debugger;
         };
 };
})();

  function mobileWalletPrice() {
    $(document).ready(function(){
      jQuery(".template-wallet-price").html(jQuery(".wk_desPrice").html());
      // new shogun master template - setting mobile price display to match desktop price
      jQuery(".theridge-pdp__mobile-price").html(jQuery(".theridge-pdp-v1__current-price").html());
    })
  }

  jQuery(document).ready(function() {

    const width = $(window).width();

  jQuery('.mini_cart, .theridge-nav__cartIcon, theridge-nav__cart-count').click(function(){
    if (width < 768) {
      $('body, html').addClass('no-scroll'); // stops scrolling bug via sides of minicart
      $('#minicart').addClass('scroll');  // enhances scroll experience on pop out minicart
    }
      jQuery('.mobilecls').removeClass('activenew');
      jQuery('html').removeClass('htmloverflow');
      document.querySelector('.theridge-menu__navOverlay').classList.remove('active')
    });

   jQuery('.mobile_nav').click(function(){
    document.querySelector('.theridge-menu__navOverlay').classList.remove('active')
    jQuery('.mobilecls').toggleClass('activenew');
     jQuery('html').toggleClass('htmloverflow');
     });

    jQuery('.icon-close').click(function(){
      if (width < 768){
        $('body, html').removeClass('no-scroll');
      }
     jQuery("#minicart").data('mmenu').close();
     });
     jQuery('body').on('click','.icon-closes', function(){
     jQuery("#minicart").data('mmenu').close();
    });

    // on resize, remove no-scroll class from body if present
    $(window).resize(function(){
        $('body, html').removeClass('no-scroll');
    });

   if(/Edge/.test(navigator.userAgent)){
   /**debugger;
   	setTimeout(function(){

    jQuery("#minicart").show();

    header.init();
    header.loadMegaMenu();
    utils.pageBannerCheck();
    slideshow.init();
    testimonial.init();
    gallery.init();
    videoSection.init();
    featuredPromotions.init();
    featuredCollectionSection.init();
    collectionSidebarFilter.init();
    cart.init();
    productPage.initializeQuantityBox();
   // productPage.init();
    productPage.relatedProducts();
   // productFormListeners.init();
    jQuery('.add_to_cart').removeAttr('disabled');
    }, 4000);
		*/

   }else{
   jQuery('.add_to_cart').removeAttr('disabled');
   }
   if(/Safari/.test(navigator.userAgent)){

   	setTimeout(function(){
    	if(typeof(document.querySelector('video')) != 'object'){
   			document.querySelector('video').play();
        }
    }, 4000);

	}
    if ($(window).width() <= 1024) {
    	mobileWalletPrice();
    }
 });

var imageFunctions = {
  zoom: function(zoomParent, enableTouch, magnify){
    var activateZoom = $(zoomParent).data('zoom');
    if (activateZoom){
      $(zoomParent + ' img')
          .wrap('<span style="display:inline-block"></span>')
          .css('display', 'block')
          .parent()
          .zoom({
            touch: enableTouch,
            magnify: magnify ? magnify : 1
      });
    }
  },
  linkGalleryAndCarousel: function($gallery, $carousel){


    //EVENT - click on carousel item to slide gallery
    $carousel.on( 'click', '.gallery-cell', function() {
      var index = $(this).index();
      $gallery.flickity( 'select', index );
    });

    $carousel.on('change.flickity', function() {
    $carousel.find(".gallery-cell.is-selected").trigger("click");
    });
  },
  fullWidth: function(images, imageContainer){
    $(images).each(function(){
      var $image = $(this),
          alt = $image.attr('alt'),
          src = $image.attr('src');

      if (alt.indexOf("[") >= 0){

        //remove from description
        $image.remove();

        //find shortcode values and remove from alt
        var shortcodes = alt.match(/\[(.*?)\]/ig);
        alt = alt.replace(/\[(.*?)\]/ig, '');

        //remove brackets from shortcode to be used as classes
        var captionClass = $.map( shortcodes, function( value, index ) {
            value = value.replace(/[\[\]']+/g,'');
            return value;
        });

        //markup for caption

        var caption = [
            '<div class="position-' + (captionClass.length ? captionClass : 'center') + ' caption js-caption">',
              '<div class="caption-content caption-background-false align-' + (captionClass.length ? captionClass : 'center') + '">',
                '<p class="headline">' + alt + '</p>',
              '</div>',
            '</div>'
        ].join('');

        //image attributes added
        $image.attr({
          alt: alt,
          class: 'lazyload fade-in',
          src: src,
          dataSizes: 'auto'
        });

        var image = $image.prop('outerHTML')
        var banner =  '<div class="banner">' + image + caption + '</div>'

        $(imageContainer).append(banner);
      }
    })
  },
  showSecondaryImage: function(){
    $('body').on("mouseenter", ".swap-true", function() {
      $(this).toggleClass('toggle-images');
    });

    $('body').on("mouseleave", ".swap-true", function() {
      $(this).toggleClass('toggle-images');
    });
  }
}

/*============================================================================
  Recently Viewed
==============================================================================*/

var recentlyViewed = {
  init: function(recentlyViewedContainer){

    //Find product handle
    if(!$('body').hasClass('index')) {
      if($('.recently-viewed__title').length) {
        var productHandle = $('.recently-viewed__title').data('rv-handle').toString();
      } else {
        //var productHandle = $('.product_form').data('rv-handle').toString();

		//deactivated on 11-2-17 when it started causing desc tabs to malfunction
		//on out of stock products
      }
    }

    if ($.cookie('recentlyViewed') != '') {

      var cookieValues = unescape($.cookie('recentlyViewed'));
      var cookieSplit = cookieValues.split(',');

      cookieSize = cookieSplit.length;
      shiftAmount = $('.rv-main').data('products-limit') + 1;
      rvPerAmount = $('.rv-main').data('products-per-slide');

      //Update Cookie
      for(var i = 0; i < cookieSplit.length; i++) {
        if(cookieSplit.length > shiftAmount) {
          cookieSplit.unshift();
        }
      }

      //Check if item has already been viewed
      if($.inArray(productHandle, cookieSplit) !== -1 || productHandle == null || productHandle == "null" ){
      } else {
        cookieSplit.unshift(productHandle);
      }

      //Set cookie
      if (escape(cookieSplit.join(',')) != 'null'){
        $.cookie('recentlyViewed', escape(cookieSplit.join(',')), { path: '/' }, {expires: 30});
      }

      if(cookieSplit.length && $.cookie('recentlyViewed') != '%2Cnull') {
        $(recentlyViewedContainer).removeClass('hidden');
        $(recentlyViewedContainer).find('.js-recently-viewed').removeClass('hidden');
      } else {
        $(recentlyViewedContainer).parents('.sidebar-block').remove();
      }

      if (recentlyViewedContainer) {
        recentlyViewed.getProductInformation(cookieSplit, recentlyViewedContainer, productHandle);
      }

    } else {
      $.cookie('recentlyViewed', productHandle );
    }

  },
  getProductInformation: function(cookieSplit, parent, productHandle){

    var shiftAmount = $(parent).find('.rv-element').length;

    var i = cookieSplit.indexOf('null');
    if(i != -1) {
      cookieSplit.splice(i, 1);
    }

    var i = cookieSplit.indexOf(productHandle);
    if(i != -1) {
      cookieSplit.splice(i, 1);
    }

    cookieSplit = cookieSplit.slice(0, shiftAmount);

    $.each(cookieSplit, function (index, value) {

      $.ajax({
        type: 'GET',
        url: '/products/' + value  + '?view=rv',
        success: function(data) {

          var rvProduct = $(data).find('.js-recently-viewed-product');

          $(parent + ' .rv-box-' + index ).append(rvProduct);

          //Convert pricing
          

         },
         error: function(x, t, m) {
          console.log(x);
          console.log(t);
          console.log(m);
         },
         dataType: "html"
      });

      if ($(parent).find('.rv-main').hasClass('js-rv-slider')){
        recentlyViewed.createSlider(parent, shiftAmount);
      } else {
        var indexProductsAvailable = shiftAmount;
        $('.js-rv-grid .thumbnail').eq(indexProductsAvailable).nextAll().remove();
      }
    });
  },

  createSlider: function(el, productsAvailable){

    var products_per_slide = $('.js-rv-slider').data('products-per-slide');
    var products_limit = $('.js-rv-slider').data('products-limit');
    var products_available = productsAvailable;
    var indexProductsAvailable = productsAvailable - 1;
    var cellAlign,
        draggable,
        prevNext,
        wrapAround,
        initialIndex;

    $('.js-rv-slider .gallery-cell').eq(indexProductsAvailable).nextAll().remove();

    if (products_per_slide == "2" && products_available > products_per_slide && products_limit > products_per_slide || products_per_slide == "4" && products_available > products_per_slide && products_limit > products_per_slide || products_per_slide == "6" && products_available > products_per_slide && products_limit > products_per_slide){
      cellAlign = "left";
    } else {
      cellAlign = "center";
    }

    if (products_available > products_per_slide && products_limit > products_per_slide) {
      draggable = true;
      prevNext = true;
      wrapAround = true;
    } else {
      draggable = false;
      prevNext = false;
      wrapAround = false;
    }

    if (products_per_slide == "2" && products_available > products_per_slide || products_per_slide == "4" && products_available > products_per_slide || products_per_slide == "6" && products_available > products_per_slide){
      initialIndex = 0;
    } else if (products_per_slide == "3" && products_available) {
      initialIndex = 1;
    } else if (products_per_slide == "5" && products_available) {
      initialIndex = 2;
    } else if (products_per_slide == "7" && products_available) {
      initialIndex = 3;
    }

    if ($(window).width() <= 767) {
      cellAlign = "center";
      draggable = true;
      prevNext = true;
      wrapAround = true;
      initialIndex = 1;

      $('.js-rv-slider').parents('.even-num-slides').removeClass('even-num-slides');
    }

    $('.js-rv-slider').flickity({
      "lazyLoad": 2,
      "imagesLoaded": true,
      "draggable": draggable,
      "prevNextButtons": prevNext,
      "wrapAround": wrapAround,
      "cellAlign": cellAlign,
      "pageDots": false,
      "contain": true,
      "freeScroll": true,
      "arrowShape": arrowSize,
      "initialIndex": initialIndex
    });

    $('.js-rv-slider').addClass('slider-initialized');
  }
}

/*============================================================================
  Featured collection section
==============================================================================*/

var featuredCollectionSection = {
  init: function(){
    $('.js-product-slider .products-slider').each(function (index, value) {
      var products_per_slide = $(this).data('products-per-slide');
      var products_limit = $(this).data('products-limit');
      var products_available = $(this).data('products-available');
      var cellAlign,
          draggable,
          prevNext,
          wrapAround,
          initialIndex;

      if (products_per_slide == "2" && products_available > products_per_slide && products_limit > products_per_slide || products_per_slide == "4" && products_available > products_per_slide && products_limit > products_per_slide || products_per_slide == "6" && products_available > products_per_slide && products_limit > products_per_slide){
        cellAlign = "left";
      } else {
        cellAlign = "center";
      }

      if (products_available > products_per_slide && products_limit > products_per_slide) {
        draggable = true;
        prevNext = true;
        wrapAround = true;
      } else {
        draggable = false;
        prevNext = false;
        wrapAround = false;
      }

      if (products_per_slide == "2" && products_available > products_per_slide || products_per_slide == "4" && products_available > products_per_slide || products_per_slide == "6" && products_available > products_per_slide){
        initialIndex = 0;
      } else if (products_per_slide == "3" && products_available) {
        initialIndex = 1;
      } else if (products_per_slide == "5" && products_available) {
        initialIndex = 2;
      } else if (products_per_slide == "7" && products_available) {
        initialIndex = 3;
      }

      if ($(window).width() <= 767) {
        cellAlign = "center";
        draggable = true;
        prevNext = true;
        wrapAround = true;
        initialIndex = 1;

        $(this).parents('.even-num-slides').removeClass('even-num-slides');
      }

      $(this).flickity({
        "lazyLoad": 2,
        "imagesLoaded": true,
        "draggable": draggable,
        "prevNextButtons": prevNext,
        "wrapAround": wrapAround,
        "cellAlign": cellAlign,
        "pageDots": false,
        "contain": true,
        "freeScroll": true,
        "arrowShape": arrowSize,
        "initialIndex": initialIndex
      });

      $(this).addClass('slider-initialized');
    });
  },
  unload: function($target){
    var $slider = $target.find('.js-product-slider');
    if ($slider.hasClass('flickity-enabled')){
      $slider.flickity('destroy');
    }
  }
}

var featuredPromotions = {
  init: function(){
    if ($(window).width() >= 768) {
      $('.feature-overlay').hover(function(){
        $(this).find('.feature-details').slideDown('100', function(){
          $(this).addClass('reveal-details');
        });
      }, function(){
        $(this).find('.feature-details').removeClass('reveal-details');
        $(this).find('.feature-details').slideUp('100');
      });

      $('.js-featured-promotions').each(function (index, value){
        var $promos = $(this);
        var animationStyle = $(this).data('promo-animation');

        $promos.waypoint(function() {
          $(this.element).find(".feature-section").addClass("animated " + animationStyle);
        }, { offset: '80%' });
      });
    }
  }
}

/*============================================================================
  Slideshow section
==============================================================================*/

var slideshow = {
  init: function(){

    $('.js-homepage-slideshow').each(function (index, value){
      var $homepageSlider = $(this);
      var settings = {
        slideshowSpeed: $homepageSlider.data('slideshow-speed'),
        slideshowTextAnimation: $homepageSlider.data('slideshow-text-animation')      }

      //initiate the slideshow
      if (!$homepageSlider.hasClass('flickity-enabled')){
        var arrowShow = $homepageSlider.find('.gallery-cell').length === 1 ? false : true;
        $homepageSlider.flickity({
                        wrapAround: true,
                        cellAlign: 'left',
                        imagesLoaded: true,
                        prevNextButtons: arrowShow,
                        draggable: arrowShow,
                        pageDots: false,
                        autoPlay: settings.slideshowSpeed,
                        arrowShape: arrowSize
                      });

        if (settings.slideshowTextAnimation != ''){
          var flkty = $homepageSlider.data('flickity');
          setTimeout(function() {
            $homepageSlider.find('.gallery-cell:nth-child(1) .caption-content').addClass('animated ' + settings.slideshowTextAnimation);
          }, 400);

          $homepageSlider.on( 'cellSelect', function() {
            if($homepageSlider.is(':visible')) {
              var currentSlide = flkty.selectedIndex + 1;
              setTimeout(function() {
                $homepageSlider.find('.caption-content').removeClass('animated ' + settings.slideshowTextAnimation);
                $homepageSlider.find('.gallery-cell:nth-child(' + currentSlide + ') .caption-content').addClass('animated ' + settings.slideshowTextAnimation);
              }, 400);
            }
          });
        }
      }

      if ($homepageSlider.find('.gallery-cell').length > 1) {
        $homepageSlider.addClass('multi-image');
      } else {
        $homepageSlider.addClass('single-image');
      }

      $homepageSlider.find('.gallery-cell').each(function(){
        var buttonWidth = 0;
        $(this).find('.action_button').each(function(){
          $button = $(this);
          if($(this).width() > buttonWidth){
              buttonWidth = $(this).width();
          }
        });
        $(this).find('.action_button').width(buttonWidth);
      });

    });
  },
  unload: function($target){

    var $slider = $target.find('.js-homepage-slideshow');
    $slider.flickity('destroy');

  }
}

  /*============================================================================
    Testimonial
  ==============================================================================*/

var testimonial = {
  init: function(){

    $('.js-testimonial').each(function (index, value){
      var $testimonialSlider = $(this);
      var settings = {
        slideshowSpeed: $testimonialSlider.data('slideshow-speed'),
        slideshowTextAnimation: $testimonialSlider.data('slideshow-text-animation')
      }

      if( $('.testimonial-image').length > 0){
        $('.testimonial-block').each(function(){
          if( $(this).find('.testimonial-image').length == 0){
            var theBlock = $(this).closest('.testimonial-block');
            $(theBlock).addClass('set-testimonial-height');
          }
        })
      }

      //initiate the slideshow
      if (!$testimonialSlider.hasClass('flickity-enabled')){
        var arrowShow = $testimonialSlider.find('.gallery-cell').length === 1 ? false : true;
        $testimonialSlider.flickity({
                        wrapAround: true,
                        cellAlign: 'left',
                        imagesLoaded: true,
                        prevNextButtons: arrowShow,
                        draggable: arrowShow,
                        pageDots: false,
                        autoPlay: settings.slideshowSpeed,
                        arrowShape: arrowSize
                      });

        if (settings.slideshowTextAnimation != ''){
          var flkty = $testimonialSlider.data('flickity');
          setTimeout(function() {
            $testimonialSlider.find('.gallery-cell:nth-child(1) .caption-content').addClass('animated ' + settings.slideshowTextAnimation);
          }, 400);

          $testimonialSlider.on( 'cellSelect', function() {
            if($testimonialSlider.is(':visible')) {
              var currentSlide = flkty.selectedIndex + 1;
              setTimeout(function() {
                $testimonialSlider.find('.caption-content').removeClass('animated ' + settings.slideshowTextAnimation);
                $testimonialSlider.find('.gallery-cell:nth-child(' + currentSlide + ') .caption-content').addClass('animated ' + settings.slideshowTextAnimation);
              }, 400);
            }
          });
        }
      }

      if ($testimonialSlider.find('.gallery-cell').length > 1) {
        $testimonialSlider.addClass('multi-image');
      } else {
        $testimonialSlider.addClass('single-image');
      }

      $testimonialSlider.find('.gallery-cell').each(function(){
        var buttonWidth = 0;
        $(this).find('.action_button').each(function(){
          $button = $(this);
          if($(this).width() > buttonWidth){
              buttonWidth = $(this).width();
          }
        });
        $(this).find('.action_button').width(buttonWidth);
      });

    });
  },

  unload: function($target){
    var $slider = $target.find('.js-testimonial');

    $slider.flickity('destroy');

  }
}

  /*============================================================================
    Gallery section
  ==============================================================================*/

  var gallery = {
    init: function(){

      $('.gallery-horizontal').find('.gallery-image-wrapper').each(function(){
        var wrapper = $(this);
        var images = $(this).find("img");
        var imgWidth,
            imgHeight;

       $("<img />").attr("src", $(images).attr("src")).on('load', function() {
         imgWidth = this.width;
         imgHeight = this.height;

          $(wrapper).css("flex-basis", imgWidth * 200 / imgHeight);
          $(wrapper).css("flex-grow", imgWidth * 200 / imgHeight);
          $(wrapper).find("i").css("padding-bottom", imgHeight / imgWidth * 100 + '%');
      });
    });

      //initialize lightbox
      lightboxGallery.init();

    }
  }

/*============================================================================
  Video section
==============================================================================*/

//check to see if HTML5 video is supported
var supports_video = function(){
  return !!document.createElement('video').canPlayType;
}

var videoSection = {
  init: function(){

    //Check for videos that are set to autoplay
    $('.homepage-video').each(function (index, value) {
      if ($('.homepage-video').length && supports_video()) {

        var $videoElement = $(this);

        var settings = {
          container: $videoElement,
          header: $videoElement.find('.homepage-video--media'),
          posterImage: $videoElement.find('.homepage-video--media [data-play-video]'),
          videoText: $videoElement.find('.homepage-video--media .caption'),
          videoTrigger: $videoElement.find("[data-play-video]"),
          autoPlayVideo: $videoElement.data('autoplay'),
          bannerVideoText: $videoElement.data('video-text'),
          autoloop: $videoElement.data('autoloop')
        }
        var videoDetails = videoSection.getVideoDetails(settings);

        if (settings.autoPlayVideo && !videoSection.isMobile()){
          videoSection.appendFrame(settings, videoDetails);
        }

      }
    });

    //Attach event listener for videos
    $('body').on('click', '[data-play-video]', function(e) {
      var $videoElement = $(this).parents('.homepage-video');
      var settings = {
        container: $videoElement,
        header: $videoElement.find('.homepage-video--media'),
        posterImage: $videoElement.find('.homepage-video--media [data-play-video]'),
        videoText: $videoElement.find('.homepage-video--media .caption'),
        videoTrigger: $videoElement.find("[data-play-video]"),
        autoPlayVideo: $videoElement.data('autoplay'),
        bannerVideoText: $videoElement.data('video-text'),
        autoloop: $videoElement.data('autoloop')
      }
      var videoDetails = videoSection.getVideoDetails(settings);

      videoSection.appendFrame(settings, videoDetails);
    });
  },
  getVideoDetails: function(settings){
    var videoDetails = {
        id: settings.header.attr('data-video-src'),
        aspectRatio: settings.header.attr('data-aspect-ratio').split(":"),
        provider: settings.header.attr('data-provider').toLowerCase(),
        videoMP4: settings.header.attr('data-video-mp4'),
        videoOGV: settings.header.attr('data-video-ogv')
    }
    return videoDetails;
  },
  createFrame: function(settings, videoDetails){

    if(videoDetails.provider === 'youtube') {
      if (settings.autoloop){
        var autoloop = '1&iv_load_policy=3&playlist='+videoDetails.id;
      } else {
        var autoloop = 0;
      }

      var html = '<iframe src="//www.youtube.com/embed/'+videoDetails.id+'?&autoplay=1&loop='+autoloop+'&rel=0&hd=1&showinfo=0&color=white&controls=0" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen ></iframe>';
    }
    else if(videoDetails.provider === 'vimeo') {
      if (settings.autoloop){
        var autoloop = 1;
      } else {
        var autoloop = 0;
      }
      var html = '<iframe src="//player.vimeo.com/video/'+videoDetails.id+'?loop='+autoloop+'&amp;title=0&amp;byline=0&amp;portrait=0&amp;color=3d96d2&autoplay=1" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen ></iframe>';
    }
    else if(videoDetails.provider === 'html5') {
      if (settings.autoloop){
        var autoloop = 'loop="loop"';
      }
      if(/Safari/.test(navigator.userAgent)){
      	var html = '<video muted autoplay="true" '+autoloop+' id="video"><source src="'+videoDetails.videoMP4+'" type="video/mp4"><source src="'+videoDetails.videoOGV+'" type="video/ogg" >Your browser does not support the video tag.</video>';
      }else{
      	var html = '<video autoplay="true" '+autoloop+' id="video"><source src="'+videoDetails.videoMP4+'" type="video/mp4"><source src="'+videoDetails.videoOGV+'" type="video/ogg" >Your browser does not support the video tag.</video>';
      }
      }
    return html;
  },
  appendFrame: function(settings, videoDetails){
    var addVideo = function(){
      //only add video if there are no videos already in the section
      if (settings.container.find('.mediaWrapper').length < 1 && settings.container.find('#video').length < 1){
        settings.container.append(videoSection.createFrame(settings, videoDetails));

        if (videoDetails.provider != 'html5'){
          settings.container.find('iframe').mediaWrapper({
            intrinsic: false,
            baseWidth : videoDetails.aspectRatio[0],
            baseHeight: videoDetails.aspectRatio[1]
          });
        }
      }
    }

    if(!videoSection.isMobile()) {
      addVideo();
      var mediaWrapper = settings.container.find('.mediaWrapper');
      settings.container.height(mediaWrapper.outerHeight());
      settings.container.find('img[data-play-video], div[data-play-video]').addClass('fadeOut animated delay-0s');


      if (settings.bannerVideoText){
        settings.videoText.addClass('text-on-video');
        if (settings.container.find('.video__play-button').length){
          settings.container.find('.video__play-button').addClass('allow-clickthrough');
        }
      } else {
        settings.videoText.hide();
      }

      settings.header.next().fadeIn('slow');
      if (videoDetails.provider != 'html5'){
        mediaWrapper.find('iframe').show();
      } else {
        settings.header.next().show();
        settings.container.find('.homepage-video__placeholder').hide();
        settings.container.find('.homepage-video__image').hide();
      }

      settings.videoTrigger.removeAttr('data-play-video');

    }
  },
  isMobile: function(){
   // return false; //initiate as false
    // device detection
    if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
        || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))){
			return true;

		}else{

			return false;
		}
  },
  unload: function($target){
    $target.find('[data-play-video]').off('click');
  }
}

var cart = {
  init: function(){
    if ($('#cart_form .tos_agree').length) {
      //Terms of service on cart page
      $('body').on('click', "#cart_form input[type='submit']", function() {
        if ($(this).parents('form').find('.tos_agree').is(':checked')) {
          $(this).submit();
        } else {
          var warning = '<p class="warning animated bounceIn">' + "You must agree with the terms and conditions to checkout." + '</p>';
          if ($('p.warning').length == 0) {
            $(this).before(warning);
          }
          return false;
        }
      });
    }
  }
}

/*============================================================================
  Product page
==============================================================================*/

function moneyFormatPDPV2(priceNumber, formatOption) {
  const currentURL = window.location.href;

  priceString = priceNumber += ""; // reformatting the price to be a string
  priceString = priceString.slice(0, -2); // Turns 6650 (which represents $66.50) into just '66'

  // If the priceString is greater than 3 digits, then add commas
  if(priceString.length > 3) priceString = numberWithCommas(priceString)

  let currencySymbol = CURRENCY_SYMBOL; // CURRENCY_SYMBOL is a global variable which is initialized earlier from inside mincart-smart-upsell.js.liquid file
  let currencyAbbreviation = "USD";

  // if this is the global store, then do not use decimals
  if(IS_GLOBAL_STORE){
    return `${currencySymbol}${priceString}`
  }

  if (currentURL.includes("ridgewallet.co.uk")) {
    currencySymbol = "£";
    currencyAbbreviation = "GBP";
  }
  if (currentURL.includes("ridgewallet.eu")) {
    // currencySymbol = "€";
    // currencyAbbreviation = "EUR";
  }
  if (currentURL.includes("ridgewallet.ca")) {
    currencyAbbreviation = "CAD";
  }
  if (currentURL.includes("ridgeau.com")) {
    currencyAbbreviation = "AUD";
  }

  // Option 1: $10.00
  // Option 2: $10.00 USD
  // Option 3: 10.00
  // Option 4: $10

  if(formatOption === 1) {
    return `${currencySymbol}${priceString}.00`
  }
  else if (formatOption === 2) {
    return `${currencySymbol}${priceString}.00 ${currencyAbbereviation}`
  }
  else if (formatOption === 3) {
    return `${priceString}.00`
  }
  else if (formatOption === 4) {
    return `${currencySymbol}${priceString}`
  }
}

selectCallback = function(variant, selector) {

  var $product = $('.product-' + selector.product.id);
  var $notify_form = $('.notify-form-' + selector.product.id);
  var $productForm = $('form.product_form', $product);

  //Image Variant feature
//    if (variant && variant.featured_image && $product.is(":visible")) {
//     var $sliders = $('.product_gallery', $product);
//     $sliders.each(function() {
//       var $slider = $(this);


//    //change current variant image with product main image 26-08-2019
//       var $carousel = $('.product_gallery').flickity({
//         pageDots: false
//       });

//    });
//   }

  if (variant) {
    $('.sku span', $product).text(variant.sku);

    
      for (var i=0,length=variant.options.length; i<length; i++) {
        var radioButton = $productForm.find('.swatch[data-option-index="' + escape(i) + '"] :radio[value="' + variant.options[i].replace(/\"/g,'\\"') +'"]');
        if (radioButton.length) {
          radioButton.get(0).checked = true;
          break;
        }
      }
    

    // update affirm installment price
    var affirmEl = $('.affirm-as-low-as');

    if (affirmEl.length > 0) {
      var price  = variant.price;

      affirm.ui.ready(
        function() {
            $('.affirm-as-low-as').attr('data-amount', price);
            affirm.ui.refresh();
        }
      );
    }
    // In order to make intelligems to work we need to add the data-variant-id and the class igPrice to the price element and the class igComparePrice to the compareAt element. Otherwise it will not work on PDP page.
    $(".theridge-pdp-v2__current-price").html(`<span data-variant-id="${variant.id}" class="money igPrice">${moneyFormatPDPV2(variant.price, 1)}</span>`);

    // Adding SKU & UPC for wholesale store
    let skuContainer = document.querySelector(".sku-info-container")
    if(skuContainer) {
      if(variant.sku.length > 0) $(".sku-info-container .product-sku").text(`SKU: ${variant.sku}`);
      if(variant.barcode.length > 0) $(".sku-info-container .product-upc").text(`UPC: ${variant.barcode}`);
    }
  }

  if (variant && variant.available == true) {
    $(".theridge-pdp-v2__was-price").html(`<span data-variant-id="${variant.id}" class="money igComparePrice">${moneyFormatPDPV2(variant.compare_at_price, 4)}</span>`);

    if(variant.price < variant.compare_at_price){
      // displaying a compare-at price if available, including a call for new shogun master template class
      $('.was_price', $product).html('<span class="money">' + Shopify.formatMoney(variant.compare_at_price, $productForm.data('money-format')) + '</span>');
      $(".theridge-pdp-v1__was-price").html('<span class="money">' + Shopify.formatMoney(variant.compare_at_price, $productForm.data('money-format')) + '</span>');
      $('.savings', $product).html("You Save" + ' ' + parseInt(((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price) + '% (' + '<span class="money">' + Shopify.formatMoney(variant.compare_at_price - variant.price, $productForm.data('money-format')) + '</span>)');
    } else {
      // hiding compare-at price if there is none, including a call for new shogun master template class
      $('.was_price', $product).html('');
      $(".theridge-pdp-v1__was-price").html('');
      $(".theridge-pdp-v2__was-price").html('');
      $('.savings', $product).html('');
    }

    if (variant.inventory_management && variant.inventory_quantity > 0) {
      
    } else {
      $('.items_left', $product).text('');
    }

    $('.sold_out', $product).text('');
    if (variant.price > 0) {
        // setting the current price on desktop, including new class for shogun master template
        $('.current_price', $product).html('<span class="money">' + Shopify.formatMoney(variant.price, $productForm.data('money-format')) + '</span>');
        $(".theridge-pdp-v1__current-price").html('<span class="money">' + Shopify.formatMoney(variant.price, $productForm.data('money-format')) + '</span>');

      /*Script to change price on variations on mobile screen starts*/

      if (variant.compare_at_price > 0 && variant.available == true) {
       // Showing discount price on mobile, aded new shogun master template class
        $('.mobile-discount-compare-price, .theridge-pdp__mobile-compare-price').css("display", "inline-block");
      $('.mobile-discount-compare-price, .theridge-pdp__mobile-compare-price').html('<span class="money">' + Shopify.formatMoney(variant.compare_at_price, $productForm.data('money-format')) + '</span>');
      } else {
        // clearing mobile discount price if there is no discount, including shogun master template class
         $('.mobile-discount-compare-price, .theridge-pdp__mobile-compare-price').html('');
      }
        // Updating mobile regular price on variant change, added new class for shogun master template
        $('.template-wallet-price, .theridge-pdp__mobile-price').html('<span class="money">' + Shopify.formatMoney(variant.price, $productForm.data('money-format')) + '</span>');
      $('.wk_mobPrice').html('<span class="money">' + Shopify.formatMoney(variant.price, $productForm.data('money-format')) + '</span>');
      $('.mob_addtocart_btn .imm_money').html('<span class="money">' + Shopify.formatMoney(variant.price, $productForm.data('money-format')) + '</span>');
      $('.mob_addtocart_btn .wk_mob_add_to_cart i').hide();
       /*Script to change price on variations on mobile screen ends*/
    } else {
      //setting desktop price free product text, including new class for shogun master template
      $('.current_price', $product).html("Free");
      $(".theridge-pdp-v1__current-price").html("Free");
       /*Script to change price on variations on mobile screen starts*/
       // Added class for new shogun master template so price is updated there as well
      $('.template-wallet-price, .theridge-pdp__mobile-price').html("Free");
      $('.mob_addtocart_btn .imm_money').html("Free");
      $('.mob_addtocart_btn .wk_mob_add_to_cart i').hide();
       /*Script to change price on variations on mobile screen ends*/
    }

    if(/Edge/.test(navigator.userAgent)){

        $('.add_to_cart', $product).removeClass('disabled').find('span').text($('.add_to_cart', $product).data('label'));
	  }else{

		$('.add_to_cart', $product).removeClass('disabled').removeAttr('disabled').find('span').text($('.add_to_cart', $product).data('label'));
	  }


     //$(".wkproduct_totalprice").html($(".current_price").text());

    $notify_form.hide();

    // Make bundle component available if the selected variant is in stock
    let productBundleContainer = document.querySelector(".theridge-pdp__product-bundle");
    if(productBundleContainer) {
      $(".theridge-pdp__product-bundle").css("opacity", "1")
      $(".theridge-pdp__product-bundle").css("pointer-events", "auto")
      $("#dynamic_variant_2").css("pointer-events", "auto")
      $("#dynamic_variant_2").prop("disabled", false)
    }
    // Logo plate pdp: make "Personalize This Item" clickable if in stock
    $(".vu_add_to_cart").css("pointer-events", "auto")
    $(".vu_add_to_cart").text("Personalize This Item");

  } else {
    // hiding mobile discount price, including shogun master template class
    $('.mobile-discount-compare-price, .theridge-pdp__mobile-compare-price').css("display", "none");
    var message = variant ? "Sold Out" : "Unavailable";
    // clearing out the compare-at price if there is none for the current variant, including a call for the new shogun master template class
    $('.was_price', $product).text('');
    $(".theridge-pdp-v1__was-price").text('');
    $('.savings', $product).text('');
    // hiding desktop price, including new class for shogun master template
    $('.current_price', $product).text('');
    $(".theridge-pdp-v1__current-price").text('');
    // clearing mobile price display, added new shogun master template class
    $('.template-wallet-price, .theridge-pdp__mobile-price', $product).text('');
    $('.items_left', $product).text('');
    $('.sold_out', $product).text(message);
    $('.add_to_cart', $product).addClass('disabled').attr('disabled', 'disabled').find('span').text(message);
    if (variant) {
      $notify_form.fadeIn();
    }

    // Make the bundle unavailble if the selected variant is out of stock
    let productBundleContainer = document.querySelector(".theridge-pdp__product-bundle");
    if(productBundleContainer) {
      $(".theridge-pdp__product-bundle").css("opacity", "0.5")
      $(".theridge-pdp__product-bundle").css("pointer-events", "none")
      $("#dynamic_variant_2").css("pointer-events", "none")
      $("#dynamic_variant_2").prop("disabled", true)
    }

    // Logo plate pdp: make "Personalize This Item" unclickable if OOS
    $(".vu_add_to_cart").css("pointer-events", "none")
    $(".vu_add_to_cart").text("SOLD OUT");

  }

  
};

var productPage = {
  init: function(){

    var draggable = true;
    var prevNextButtons = true;

    setTimeout(function(){
      for(var i = 0; i < $('.product_gallery').length; i ++) {
        imageFunctions.linkGalleryAndCarousel($('.product_gallery').eq(i), $('.product_gallery_nav').eq(i)); // Connect Product main image with thumbnail.
      }
    }, 1000);
    imageFunctions.zoom('.product_gallery', false);

    if($('.js-full-width-product-images').length){
      imageFunctions.fullWidth('.product-full-width-images .product_section .description img', '.js-full-width-product-images');
    }

    if ($('.product_gallery').hasClass('single-image') || jQuery( window ).width() <= 767){
      draggable = false;
      prevNextButtons = false;
    }

    //detect autoplay settings
    var autoplay = $('.product_gallery').data('autoplay');

    /***************************************************************************
    flickity slider script for single product page according to selected variant
    ***************************************************************************/
//     $(".product_gallery").flickity({
//       cellAlign: 'center',
//       contain: true,
//       lazyLoad: 'true',
//       imagesLoaded: true,
//       pageDots: false,
//       asNavFor: '.product_gallery_nav',
//       wrapAround: false,
//       arrowShape: {
//         x0: 10,
//         x1: 60, y1: 50,
//         x2: 70, y2: 40,
//         x3: 30
//       }
//     });
	/***************************************************************************
    End flickity slider script for single product page according to selected variant
    ***************************************************************************/


    $(".js-product_section .product_form").each(function() {
      //debugger;
     new Shopify.OptionSelectors($(this).data("select-id"), { product: $(this).data("product"), onVariantSelected: selectCallback });
    });

    var $notify_form = $('.notify_form .contact-form');
    $notify_form.each(function() {
      var $nf = $(this);
      $nf.on("submit", function (e) {
        if($('input[name="challenge"]', $nf).val() !== "true") {
          $.ajax({
            type: $nf.attr('method'),
            url: $nf.attr('action'),
            data: $nf.serialize(),
            success: function (data) {
              $nf.fadeOut("slow", function(){
                $nf.prev('.message').html("Thanks! We will notify you when this product becomes available!");
              });
            },
            error: function(data) {
              $('input[name="challenge"]', $nf).val('true');
              $nf.submit();
            }
          });
          e.preventDefault();
        }
      });
    });

    
      $('body').on('change', '.swatch :radio', function() {
        var optionIndex = $(this).closest('.swatch').attr('data-option-index');
        var optionValue = $(this).val();
        var parentForm = $(this).closest('.product_form');
        const isUpsellCollection = this.closest('.upsell-collection') ? true : false;
        // we need to target things differently when it comes to swatches in upsell vs everything else
        const parentElement = isUpsellCollection ? '.upsell-product' : 'form';


        if (parentForm.siblings('.notify_form').length){
          var notifyForm = parentForm.siblings('.notify_form');
        } else {
          //quick shop
          var notifyForm = $('.js-notify-form');
        }

        var option1 = parentForm.find('.swatch_options input:checked').eq(0).val();
        var option2 = parentForm.find('.swatch_options input:checked').eq(1).val() || '';
        var option3 = parentForm.find('.swatch_options input:checked').eq(2).val() || '';

        if (option1 && option2 && option3){
          var notifyMessage = option1 + ' / ' + option2 + ' / ' + option3;
        } else if (option1 && option2){
          var notifyMessage = option1 + ' / ' + option2;
        } else {
          var notifyMessage = option1;
        }


        notifyForm.find(".notify_form_message").attr("value", notifyForm.find(".notify_form_message").data('body') + " - " + notifyMessage );

        $(this)
        .closest(parentElement)
        .find('.single-option-selector')
        .eq(optionIndex)
        .val(optionValue)
        .trigger('change');

        if($(this).parent().hasClass('style_radios')){
           var variant = $(this).attr('wkswatch-id');
           history.replaceState({id:location.pathname}, null, "https://"+location.hostname+location.pathname+"?variant="+variant);
           productPage.showGallery();
       	}

      });
    

    //initialize lightbox
    lightboxGallery.init();
    this.showGallery();
  },

  showGallery: function(revealImagesTimeDelay) {
    const currentScrollPosition = document.documentElement.scrollTop;
    var sel_radios = $(".wk_boxvariant.style_radios input[type='radio']:checked");	// Get Variant selected options. This is for composing alt text.
    let swatch_text = ''; // The goal of this variable is to grab the variant's title like 'Cash Strap', 'Money Clip', 'Both', etc
    let variantText = document.querySelector(".ridge-product-swatch-v3[data-selected-variant-title]");
    let productTitle = $(".theridge-pdp__product-title").attr("data-product-title");

    if(!variantText) {
      document.arrive(".ridge-product-swatch-v3[data-selected-variant-title]", function(){
        variantText = document.querySelector(".ridge-product-swatch-v3[data-selected-variant-title]")
      })
    }

    // If the traditional box variants are not rendered, then the length will be 0
    if(sel_radios.length > 0) {
      for ( var i = 0; i < sel_radios.length; i ++ ) {
        // Filter only valid ones.
        if(sel_radios.eq(i).parent().find(".swatch-element").attr("data-value") == null || sel_radios.eq(i).parent().find(".swatch-element").attr("data-value") == 'undefined'){
          break;
        }

        if(i > 0) {
          swatch_text += '+';
        }
        swatch_text += sel_radios.eq(i).parent().find(".swatch-element").attr("data-value");  //Get Swatch Text. We need this forloop in case when product has several swatches (color, size, ...).
      }
    }
    else if(variantText) {
      swatch_text = variantText.dataset.selectedVariantTitle;
    }

    // Above this comment is the logic to fetch the string (swatch_text) that matches the current variant.
    // Below this comment is the logic to utilize the swatch_text string to show the appropriate gallery based on the variant a user is viewing.
    let activeCarousel = $(".product_gallery[data-alt='" + swatch_text + "']"); // Get the carousel that matches the selected variant.
    let activeThumbnailCarousel = $(".product_gallery_nav[data-alt='" + swatch_text + "']"); // Get the thumbnail carousel that matches the selected variant.
    // get the carousel that contains the product title as alt text. This is the default carousel.
    let defaultCarousel = $(".product_gallery[data-alt='" + $(".theridge-pdp__product-title").attr("data-product-title") + "']");
    let defaultCarouselNav = $(".product_gallery_nav[data-alt='" + $(".theridge-pdp__product-title").attr("data-product-title") + "']");

    let productType = document.querySelector(".theridge-pdp__background")?.dataset?.productType;

    /*
      This addresses the travel products where the product title can be exactly the same as the ONE of its variant's title.
      The code starting with "defaultCarousel.find..." below grabs other product images that don't have any alt tags + any alt tags that match the product title.

      We only need this to happen to rings because it uses sizes as the variant names, and we don't follow the same convention of having
      all of the product images have an alt tag the same as the variant names for rings.

      In essense, We need the rings to always use all of the supplied images. Every other product type has specified images per variant.
    */
    if(productType && productType == "Ring"){
      // if the selected variant has no images, show the default carousel.
      if(activeCarousel.length == 0) {
          activeCarousel = defaultCarousel;
          activeThumbnailCarousel = defaultCarouselNav;
      } else {
        // if the selected variant has images, append all images that has no alt text to the carousel that matches the selected variant.
        defaultCarousel.find(".gallery-cell").each(function() {
          if($(this).find("img").attr("alt") == productTitle) {
            $(this).removeClass("is-selected");
            activeCarousel.flickity('append', $(this).clone());
            activeThumbnailCarousel.flickity('append', $(this).clone());
          } else {
            $(this).remove();
          }
        });
      }
    } 
    if(activeCarousel.length == 0) {
        activeCarousel = defaultCarousel;
        activeThumbnailCarousel = defaultCarouselNav;
    } 
    // verify if activeCarousel has any duplicate images. If it does, remove the duplicate images.
    let activeCarouselSeen = {};
    activeCarousel.find(".gallery-cell").each(function() {
      let src = $(this).find("img").attr('data-src');
      if (activeCarouselSeen[src]) {
        $(this).remove();
      } else {
        activeCarouselSeen[src] = true;
      }
    });
    // verify if activeThumbnailCarousel has any duplicate images. If it does, remove the duplicate images.
    let activeThumbnailCarouselSeen = {};
    activeThumbnailCarousel.find(".gallery-cell").each(function() {
      let src = $(this).find("img").attr('data-src');
      if (activeThumbnailCarouselSeen[src]){
        $(this).remove();
      }
      else {
        activeThumbnailCarouselSeen[src] = true;
      }
    });

    if(revealImagesTimeDelay) {

      setTimeout(() => {
        $(".product_gallery").addClass("hide");
        activeCarousel.removeClass("hide");	// Hide all product_gallery divs and only show one that has the same alt text.
        activeCarousel.css({'visibility':'visible', 'opacity': '1'});
        activeCarousel.flickity('resize');		// Refresh flickity slider so images loaded properly.
        activeCarousel.flickity('reloadCells');	// Refresh flickity slider so images loaded properly.
        activeCarousel.flickity('select', 0);	// Select the first image in the carousel.

      }, revealImagesTimeDelay);

      setTimeout(() => {
        $(activeThumbnailCarousel).css({'transition' :'0.4s ease-in-out'});

        $(".product_gallery_nav").addClass("hide");
        activeThumbnailCarousel.removeClass("hide");	// Hide all product_gallery_nav divs and only show one that has the same alt text.
        activeThumbnailCarousel.css({'visibility':'visible', 'opacity': '1'});
        activeThumbnailCarousel.flickity('resize');		// Refresh flickity slider so images loaded properly.
        activeThumbnailCarousel.flickity('reloadCells');	// Refresh flickity slider so images loaded properly.
        activeThumbnailCarousel.flickity('select', 0);	// Select the first image in the carousel.

        doInterval(100, 20, () => {
          activeCarousel.flickity('resize');
          activeThumbnailCarousel.flickity('resize');
        });
        $(activeThumbnailCarousel).css({'transition' :'none'});
      }, revealImagesTimeDelay+500);

    } else {
      $(".product_gallery_nav").addClass("hide");
      activeThumbnailCarousel.removeClass("hide");	// Hide all product_gallery_nav divs and only show one that has the same alt text.
      activeThumbnailCarousel.flickity('resize');		// Refresh flickity slider so images loaded properly.
      activeThumbnailCarousel.flickity('reloadCells');	// Refresh flickity slider so images loaded properly.
      activeThumbnailCarousel.flickity('select', 0);	// Select the first image in the carousel.


      $(".product_gallery").addClass("hide");
      activeCarousel.removeClass("hide");	// Hide all product_gallery divs and only show one that has the same alt text.
      activeCarousel.flickity('resize');		// Refresh flickity slider so images loaded properly.
      activeCarousel.flickity('reloadCells');	// Refresh flickity slider so images loaded properly.
      activeCarousel.flickity('select', 0);	// Select the first image in the carousel.
    }




    // prevent flickity resize function from scrolling back to top
    document.documentElement.scrollTop = currentScrollPosition;
  },
  relatedProducts: function(){

    $('.js-related-products-slider .products-slider').each(function (index, value) {
      var products_per_slide = $(this).data('products-per-slide');
      var products_limit = $(this).data('products-limit');
      var products_available = $(this).data('products-available');
      var cellAlign,
          draggable,
          prevNext,
          wrapAround,
          initialIndex;

      if (products_per_slide == "2" && products_available > products_per_slide && products_limit > products_per_slide || products_per_slide == "4" && products_available > products_per_slide && products_limit > products_per_slide || products_per_slide == "6" && products_available > products_per_slide && products_limit > products_per_slide){
        cellAlign = "left";
      } else {
        cellAlign = "center";
      }

      if (products_available > products_per_slide && products_limit > products_per_slide) {
        draggable = true;
        prevNext = true;
        wrapAround = true;
      } else {
        draggable = false;
        prevNext = false;
        wrapAround = false;
      }

      if (products_per_slide == "2" && products_available > products_per_slide || products_per_slide == "4" && products_available > products_per_slide || products_per_slide == "6" && products_available > products_per_slide){
        initialIndex = 0;
      } else if (products_per_slide == "3" && products_available) {
        initialIndex = 1;
      } else if (products_per_slide == "5" && products_available) {
        initialIndex = 2;
      } else if (products_per_slide == "7" && products_available) {
        initialIndex = 3;
      }

      if ($(window).width() <= 767) {
        cellAlign = "center";
        draggable = true;
        prevNext = true;
        wrapAround = true;
        initialIndex = 1;

        $(this).parents('.even-num-slides').removeClass('even-num-slides');
      }

      $(this).flickity({
        "lazyLoad": 2,
        "imagesLoaded": true,
        "draggable": draggable,
        "cellAlign": cellAlign,
        "prevNextButtons": prevNext,
        "wrapAround": wrapAround,
        "pageDots": false,
        "contain": true,
        "freeScroll": true,
        "arrowShape": arrowSize,
        "initialIndex": initialIndex
      });
    });
  },
  initializeQuantityBox: function(){

    $('body').on('click', '.js-change-quantity', function() {
        var $this = $(this),
            $input = $(this).siblings('input'),
            val = parseInt($input.val()),
            valMax = 100000000000000000000000000000,
            valMin = $input.attr('min') || 0;

        if ($input.attr('max') != null){
          valMax = $input.attr('max');
        }

        if(isNaN(val) || val < valMin) {
            $input.val(valMin);
            return false;
        } else if (val > valMax) {
            $input.val(valMax);
            return false;
        }

        if($this.data('func') == 'plus') {
            if(val < valMax) $input.val(val + 1);
        } else {
            if(val > valMin) $input.val(val - 1);
            if($this.parents(".cart_item").length) {
              if (val - 1 == 0) {
                $this.closest('.cart_item').addClass('animated fadeOutUp')
              }
            }
        }
        $input.trigger('change');

    });
  },
  unload: function($target){

    var $slider = $target.find('.products-slider');
    $slider.flickity('destroy');

  }
}

/*============================================================================
  Newsletter Popup
==============================================================================*/

var newsletter_popup = {
  init: function(){
    var popup = $.cookie('popup');
    var cookie_enabled = true;

    if (cookie_enabled && popup == 'open') {
      return false;
    } else {
      newsletter_popup.open();
    }
    if (cookie_enabled) {
      $.cookie('popup', 'open', { expires: 14 });
    }
  },
  open: function(){
    if (false || $(window).width() >= 768) {
      setTimeout( function() {
        $('[data-remodal-id=newsletter]').remodal().open();
      },
      0*1000);
    }
  }
}

/*============================================================================
  Header section
==============================================================================*/

var header = {
  init: function(){
    //End cookie function for hide free shipping bar

    //Only apply on larger screen sizes
    if ($(window).width() >= 768) {
      if ($('.header').hasClass('header-fixed--true')){
        if (!$('.main_nav_wrapper').hasClass('sticky_nav')) {
          var sticky_nav = new Headhesive('.main_nav_wrapper', {
            offset: 700,
            throttle: 300,
            classes: {
              clone: 'sticky_nav',
              stick: 'sticky_nav--stick',
              unstick: 'sticky_nav--unstick'
            },
            onInit: function() {
              $(".sticky_nav .secondary_logo").hide();
              $(".sticky_nav .primary_logo").show();
              $(".sticky_nav .icon-search").show();
              $(".sticky_nav .search_container").hide();
              $(".sticky_nav .nav:last").prepend($(".header .cart_container").clone());
              
                var sticky_nav_height = $(".sticky_nav").height() + 5;
              
              $(".sticky_nav .mini_cart").css("height", $(".sticky_nav").height() + 5);
              $(".sticky_nav .cart_content").css("top", $(".sticky_nav").height());
            },
            onUnstick: function() {
              $('.cart_container').removeClass('active_link');
            }
          });
        }
      } else {
        $('.header-fixed--true').removeClass('header-fixed--true');
        if ($('.main_nav_wrapper').length > 1) {
          $('.main_nav_wrapper').first().remove();
        }
      }

      if ($('img.primary_logo:visible')){
        $('.logo img', $(".feature_image .header")).attr('src', $('.logo img').data('src-home'));
      } else {
        $('.logo img').attr('src', $('.logo img').data('src'));
      }
    } else {
      if ($('#header').hasClass('mobile_nav-fixed--true')){
        $('body').addClass('mobile_nav-fixed--true');
      } else {
        $('body').addClass('mobile_nav-fixed--false');
      }
    }

    $('#header .cart_container').append($('.cart_content').clone());

          const searchIcon = document.querySelector('.icon-search');
      const searchDropdown = document.querySelector('[data-dropdown="search"]')
      const searchBox = document.querySelector('.search-terms')
      let searchTimeout;
      const openSearch = () => {
        clearTimeout(searchTimeout)
        searchDropdown.classList.toggle('open')
        searchBox.focus()
      }

      searchIcon.addEventListener('click', e => {
        openSearch()
      })


      searchDropdown.addEventListener('mouseenter', e => {
        clearTimeout(searchTimeout)
      })

      // searchDropdown.addEventListener('mouseleave', e => {
      //   searchTimeout = setTimeout(() => {
      //     searchDropdown.classList.remove('open')
      //   }, 1000);
      // })

      const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
      if (!isTouchDevice && window.innerWidth >= 768) {
        // problem on mobile devices where the search disappears as if you clicked away from it when you touch the input field.
        window.addEventListener('scroll', e => {
          searchTimeout = setTimeout(() => {
            searchDropdown.classList.remove('open')
          }, 500);
        })
      }


      document.addEventListener('click', e => {
        if(!searchDropdown.contains(e.target) && !searchIcon.contains(e.target)) {
          searchDropdown.classList.remove('open')
        }
      })

    if ($(window).width() <= 767) {

      $('.dropdown_link').attr('data-no-instant', true);

      $('body').on('click', '.dropdown_link', function(e) {
        $('.nav a').removeClass('active_link');

        if ($('#header').is(':visible')) {
          var $dropdown = $(this).parents("#header").find('[data-dropdown="' + $(this).data("dropdown-rel") + '"]')

            if(!$(this).hasClass('mini_cart')) {
              $('.cart_container').removeClass('active_link');
            }

        } else {

          if($(this).hasClass("icon-search")) {
            window.location = $(this).attr("href");
            return false;
          }

          var $dropdown = $(this).parents(".main_nav, .mobile_nav-desktop--true").find('[data-dropdown="' + $(this).data("dropdown-rel") + '"]')
        }

        if ($dropdown.is(':visible') || $dropdown.attr('class') === undefined) {
          $dropdown.hide();
          $('body').removeClass('is-active');
        } else {
         // $('.dropdown_container').hide();
          if(!$(this).hasClass('cart_container')) {
            $('.is-absolute').parent().removeClass('feature_image');
          }
          $dropdown.show();
          $('body').addClass('is-active');
         // $('.mobile_nav').find('div').removeClass('open');
        }

        e.stopPropagation();
        return false;
      });

      $('body').on("click", '.mobile_nav', function() {
        $(this).find('div').toggleClass('open');
       // $('.mobilecls').toggleClass('activenew');
      });

      var closeDropdown = function closeSearch() {
        $('body').removeClass('is-active');
        $('.dropdown_link').removeClass('active_link');
      //  $('.dropdown_container').hide();
       $('.mobile_nav').find('div').removeClass('open');
      };

      var closeMiniCart = function closeMiniCart() {
        $('body').removeClass('is-active');
        $('.dropdown_link').toggleClass('active_link');
        $('.cart_container').removeClass('active_link');
      };

      var openMiniCart = function openMiniCart($cart_container) {
        $('.mobile_nav div').removeClass('open');
        $('.dropdown_link').removeClass('active_link');
        $cart_container.addClass('active_link');
      };

      //Click anywhere outside of dropdown to close
      $('html').on('click', function(event) {
        if (!$(event.target).closest('.cart_container').length && $('.cart_content').is(':visible')) {

          closeMiniCart();
        }

        if (!$(event.target).closest('.dropdown_container').length && $('.dropdown').is(':visible')) {

          closeDropdown();
        }

      });

      //Toggle mini-cart with menu icon
      $(".mini_cart").on("click", function(e) {
        var $cart_container = $(this).parent();
        if($cart_container.hasClass('active_link')) {
          closeMiniCart();
        } else {
          openMiniCart($cart_container);
        }
      });

      $('.cart_content__continue-shopping').on('click', function(e){
        closeMiniCart();
      })

    } else {

      $(".nav a, .logo a, .mobile_nav-desktop--true a").not(".cart_content a,.search_link_new a").on("mouseenter", function() {
        if(!$(this).hasClass("active_link")) {
          $('.dropdown_container').fadeOut();
          $('.active_link').removeClass('active_link');
          $('.is-absolute').parent().addClass('feature_image');
        }
        if(!$('.active_search').hasClass('active_link')){
          $('.active_search').addClass('active_link');
        }

      });

      $('.main_nav, .top_bar, .cart_container, .mobile_nav-desktop--true').click( function(event) {
        $('.dropdown_container').fadeOut();
        $('.active_link').removeClass('active_link');
        $('.is-absolute').parent().addClass('feature_image');
        if(!$('.active_search').hasClass('active_link')){
          $('.active_search').addClass('active_link');
        }
      });

      $('.dropdown_link').on('mouseenter', function() {
        if(!$(this).hasClass('active_link')) {
          $('.dropdown_container').fadeOut();
          $(this).parents('.main_nav, .mobile_nav-desktop--true').find('[data-dropdown="' + $(this).data('dropdown-rel') + '"]').show();

          if($(this).hasClass('mini_cart')) {
            $(this).parent('.cart_container').addClass('active_link');
          } else {
            $(this).addClass('active_link');
            $('.is-absolute').parent().removeClass('feature_image');
          }
        }
      });
	  $(window).scroll(function () {
      // $('.dropdown_container').fadeOut();
		     $('.active_search').removeClass('active_link');
	    	 $('.active_search').removeClass('active_search');
			 $('.dropdown_container_new').hide();
	  })
	  $('.dropdown_link_new').on('click', function() {
        if(!$(this).hasClass('active_search')) {
            $('.dropdown_container_new').hide();
		    $(this).parents('.main_nav, .mobile_nav-desktop--true').find('[data-dropdown-new="' + $(this).data('dropdown-new-rel') + '"]').show();
            $(this).addClass('active_search');
			 $(this).addClass('active_link');
		}else{
			 $(this).removeClass('active_link');
			 $(this).removeClass('active_search');
			 $('.dropdown_container_new').hide();
		}

	});

      $('.dropdown_link--vertical').on('mouseover', function() {
        if ($(this).find('.mega-menu-parent').length){
          $(this).find('.vertical-menu_submenu').remove();
        } else {
          $('.active_link').removeClass('active_link');
          if(!$(this).hasClass('active_link')) {
          //  $('.dropdown_container').hide();

            $(this).children('a').addClass('active_link');
            $('.is-absolute').parent().removeClass('feature_image');
          }
        }
      });

    }

  },
  removeDataAttributes: function(target){
    if($(target).length){
      var i,
          $target = $(target),
          attrName,
          dataAttrsToDelete = [],
          dataAttrs = $target.get(0).attributes,
          dataAttrsLen = dataAttrs.length;

      for (i=0; i<dataAttrsLen; i++) {
        if ( 'data-' === dataAttrs[i].name.substring(0,5) ) {
          dataAttrsToDelete.push(dataAttrs[i].name);
        }
      }
      $.each( dataAttrsToDelete, function( index, attrName ) {
        $target.removeAttr( attrName );
      })
    }
  },
  loadMegaMenu: function(){

    //Remove old mega-menus so that theme-editor works properly
    $('.sticky_nav .mega-menu').remove();
    $('.header .mega-menu').remove();

    //Clone the mega menu from section into sticky_nav
    $('.mega-menu-container .mega-menu').clone().appendTo('.sticky_nav .main_nav');
    //Remove theme-editor data-attributes
    header.removeDataAttributes('.sticky_nav .mega-menu.dropdown_container .dropdown_column');

    //Loop through mega-menus to add arrow to parent
    $('.mega-menu-container .mega-menu').each(function(index){
      $('[data-dropdown-rel="' + $(this).data("dropdown") + '"]').find('span').remove();
      $('[data-dropdown-rel="' + $(this).data("dropdown") + '"]').append(' <span class="icon-down-arrow"></span>').addClass('mega-menu-parent').addClass('dropdown_link').removeClass('top_link');
      $('[data-dropdown="' + $(this).data("dropdown") + '"]').each(function(index){
        if (!$(this).hasClass('mega-menu')) {
          $(this).remove();
        }
      });
      $(this).clone().appendTo('.header .main_nav');
    });

    $('.mega-menu-parent').on('mouseenter', function() {

      if(!$(this).hasClass('active_link')) {
      //  $('.dropdown_container').hide();
        $(this).parents('.main_nav').find('[data-dropdown="' + $(this).data('dropdown-rel') + '"]').toggle();

        $(this).addClass('active_link');
        $('.is-absolute').parent().removeClass('feature_image');

      }
    });

    //Remove theme-editor data-attributes
    header.removeDataAttributes('.header .mega-menu.dropdown_container .dropdown_column');

    header.loadMobileMegaMenu();
  },
  loadMobileMegaMenu: function() {
    //Loop through mega menus and add to mobile menu
    $('.mega-menu-container .mobile-mega-menu').each(function(index){
      $('[data-mobile-dropdown-rel="' + $(this).data("mobile-dropdown") + '"]').find('span').remove();
      $('[data-mobile-dropdown-rel="' + $(this).data("mobile-dropdown") + '"] > a').append(' <span class="right icon-plus"></span>').attr('data-no-instant', 'true');
      $('[data-mobile-dropdown-rel="' + $(this).data("mobile-dropdown") + '"]').addClass('mobile-mega-menu-parent sublink seperator');
      $('[data-mobile-dropdown-rel="' + $(this).data("mobile-dropdown") + '"]').append(this);
      $('[data-mobile-dropdown-rel="' + $(this).data("mobile-dropdown") + '"] > ul').each(function(index){
        if (!$(this).hasClass('mobile-mega-menu')) {
          $(this).remove();
        }
      });
    });
  },
  unloadMegaMenu: function(){
    $('.header .mega-menu').remove();
    $('.mega-menu-container .mega-menu').each(function(index){
      var menuParent = $(this).data('dropdown');
      $('.mega-menu-parent[data-dropdown-rel="' + $(this).data("dropdown") + '"]').find('.icon-down-arrow').remove();
    });
  },
  unload: function() {
    $('body').off("click", '.mobile_nav');
    $('body').off('click', '.dropdown_link');
    $('html').off('click');
    $('.mini_cart').off('click');
    $('.cart_content__continue-shopping').off('click');
  }
}

/*============================================================================
  Load More Products
==============================================================================*/

var enableLoadMoreProducts = function(){
  $('body').on('click', '.js-load-more a', function(e){
    enableInfiniteScroll();
    e.stopPropagation();
    return false;
  });
}

var enableInfiniteScroll = function(){
  var infiniteScroll = new Waypoint.Infinite({
    element: $('.collection-matrix')[0],
    items: '.collection-matrix',
    more: '.load-more__btn',
    loadingClass: 'loading-in-progress',
    onBeforePageLoad: function(){
      $('.js-load-more').hide();
    },
    onAfterPageLoad: function(data){
      
      
    }
  })
}

/*============================================================================
  Filter Products with AJAX
==============================================================================*/

Shopify.queryParams = {};
if (location.search.length) {
 for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
    aKeyValue = aCouples[i].split('=');
    if (aKeyValue.length > 1) {
     Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
    }
  }
}

var quickFilter = {
  init: function(){
    var selectedOptions = [],
        query = '',
        currentTags = '',
        siteUrl = 'https://' + $.url('hostname'),
        url1 = $.url('1') ? '/' + $.url('1') + '/' : '',
        url2 = $.url('2') ? $.url('2') + '/' : '',
        url3 = $.url('3'),
        path = url1 + url2;

    //Handle dropdowns if they exist
    if ($('#sort-by').length){
      query = $('#sort-by').val();
    } else {
      query = url('?sort_by');
    }

    if ($('#tag_filter').length){

      if ($('#tag_filter').data('default-collection') != $('#tag_filter').val()){
        urlTag = $('#tag_filter').val().substr($('#tag_filter').val().lastIndexOf('/') + 1);

        if (urlTag != 'all'){
          if ($.inArray( urlTag, selectedOptions ) > -1){
            //Do nothing
          } else {
            selectedOptions.unshift(urlTag);
          }
        }
      }
    }

    //Add all checkbox values to array
    $('[data-option-filter] input:checked').each(function (){
      selectedOptions.push($(this).val());
    });
    selectedOptions = $.makeArray(selectedOptions);

    //Loop through tags to create string to update page url
    $.each(selectedOptions, function(i, value){

      if (i != selectedOptions.length - 1) {
        currentTags += selectedOptions[i] + '+';
      } else {
        currentTags += selectedOptions[i];
      }

    });

    Shopify.queryParams.sort_by = query;
    query = '?' + $.param(Shopify.queryParams);

    quickFilter.processUrl(path, currentTags, query);
  },
  updateView: function(filterURL) {

    $.ajax({
       type: 'GET',
       url: filterURL,
       beforeSend: function() {
          $(".collection-matrix").addClass('fadeOut animated loading-in-progress');
          $(".sort-by-dropdown").removeClass("is-open");
          Waypoint.destroyAll()
       },
       success: function(data) {
          $(".collection-matrix").removeClass('loading-in-progress');
        //  var filteredBreadcrumb = $(data).find('.breadcrumb_text').html();
        //  $('.breadcrumb_text').html(filteredBreadcrumb);

          var filteredPagination = $(data).find('.paginate').html();
          $('.paginate').html(filteredPagination);

          var filteredSidebar = $(data).find('.sidebar').html();
          $('.sidebar').html(filteredSidebar);

          var filteredPageLinks = $(data).find('.paginate').html();
          $('.paginate').empty();
          $('.paginate').html(filteredPageLinks);

          var filteredData = $(data).find('.collection-matrix');
          $('.collection-matrix').remove();
          filteredData.insertBefore( $('.load-more__icon') );

          window.history && window.history.pushState && window.history.pushState("", "", filterURL);

          if ($('.sidebar__collection-filter').length){
            collectionSidebarFilter.init();
          }

          

          
       },
       error: function(x, t, m) {
        console.log(x);
        console.log(t);
        console.log(m);
        location.replace(location.protocol + '//' + location.host + filterURL);

       },
       dataType: "html"
    });
  },
  processUrl: function(path, tags, query){

    var query = query.replace(/\page=(\w+)&/, ''),
        urlString = '';

    urlString = path + tags + query;

    quickFilter.updateView(urlString);

  }
}

$('#sort-by').val($('#sort-by').data('default-sort'));

$('body')
  .on('change', '#tag_filter, #sort-by', function() {
    quickFilter.init();
});

$('body')
  .on('change', '#blog_filter', function() {
    var url = $(this).val();
    window.location = url;
});

$('input, select, textarea').on('focus blur', function(event) {
  $('meta[name=viewport]').attr('content', 'width=device-width,initial-scale=1,maximum-scale=' + (event.type == 'blur' ? 10 : 1));
});

/*============================================================================
  Sidebar filter on collection pages
==============================================================================*/

var collectionSidebarFilter = {
  init: function(){

    $('.filter-active-tag input:checked').parents('.filter-active-tag').siblings('.filter-all-tags').hide();
    $('.toggle-all--true .toggle_list .filter-active-tag input:checked').parents('ul.toggle_list').prev().click();

    //Hide filters if types or vendors is in URL (can't be combined)
    if ($.url(2) === 'types' || $.url(2) === 'vendors'){
      $('.sidebar__collection-filter').remove();
    }

    $('.sidebar-block:empty').prev().css('border-bottom', 'none');

  },
  clearAllFilters: function(){
    $('[data-option-filter] input').attr('checked', false);
    $('[data-option-filter] input').trigger('change');
  },
  clearSelectedFilter: function(optionFilter){
    optionFilter.find('[data-option-filter] input').attr('checked', false);
    optionFilter.find('[data-option-filter] input').trigger('change');
  }
}

//Check the checkbox values
$('body').on('change', '[data-option-filter] input', function(){
  quickFilter.init();
})

$('body').on('click', '[data-reset-filters]', function(){
  collectionSidebarFilter.clearAllFilters();
});

$('body').on('click', '[data-clear-filter]', function(){
  var selectedOption = $(this).parents('.filter-active-tag');
  collectionSidebarFilter.clearSelectedFilter(selectedOption);
});

/*============================================================================
  Utilities
==============================================================================*/


  var arrowSize = {
    x0: 10,
    x1: 60, y1: 50,
    x2: 62, y2: 40,
    x3: 22
  }


//compatibility with gallery using remodal
var lightboxGallery = {
  init: function(){
    //compatibility with gallery using remodal
    if ($('.lightbox img').length) {
      var currentSlide;
      var $lightboxImages = $('a.lightbox');
      var groups = [];

      //get all lightbox images and divide into groups based on rel attribute
      $lightboxImages.each(function(index){
        groups.push($(this).attr('rel'));
        groups = groups.filter(function(item, i, ar){ return ar.indexOf(item) === i; });
      })

      //loop through gallery groups and create modals
      $.each(groups, function(index, value){

        //Loop through images and add link to remodal
        $('.lightbox[rel=' + value + ']').attr('data-remodal-target', 'lightbox-id-' + index );

        var lightboxModal = [
          '<div class="remodal remodal-lightbox js-remodal-lightbox js-lightbox-' + index + '" data-rel="' + value + '" data-remodal-id="lightbox-id-' + index + '" data-remodal-options="hashTracking: false">',
            '<a data-remodal-action="close" class="remodal-close"></a>',
            '<div class="lightbox-gallery"></div>',
          '</div>'
        ].join('');

        //Add modal lightbox to page to be populated by lightboxImageGallery
        $('body').append(lightboxModal);

        $('.lightbox[rel=' + value + ']').each(function(index){
          $(this).attr('data-image-id', index);
          $(this).attr('data-no-instant', '');
        });

      });

    }
  }
}

var utils = {
  createAccordion: function(container, tab, content) {
    var $container = $(container);
    var $tab = $(container).find(tab);
    var $content = $(container).find(content);
    var specificTab = container + ' ' + tab;

    //Check to see if need to rearrange product tabs to create accordion (backwards compatible)
    if (container.indexOf(".accordion-tabs") >= 0){
      var rearrangedTabs = $.map($tab, function(v, i) { return [v, $content[i]]; });
      $container.empty();

      $.each(rearrangedTabs, function (index, value) {
        $container.append(this);
      });

      $content.removeClass('active');
      $container.find('.active').next().slideToggle();

      tab = container + '> a';
    }

    $(container).children('a').each(function(i, tab) {
      var tab = $(this);
      var tabValue = tab.attr('href'); //get tab id
      tab.attr('data-tab-value', tabValue); //set tab id in data attribute
      tab.removeAttr("href"); //remove href (to prevent url hash update)
    });

    $(container).find(tab + '.active').next().slideToggle();
    $('body').on('click', specificTab, function(e){
      e.preventDefault();
      $(this).toggleClass('active');
      $(this).next().slideToggle();
    });
  },
  mobileAccordion: function(container, tab, content){
    $container = $(container);
    $tab = $(container).find(tab);
    $content = $(container).find(content);

    $(tab + '.active').next().slideToggle();

    $('body').on('click', tab, function(e){
      e.preventDefault();
      $(this).toggleClass('active');
      $(this).next().slideToggle();
    });
  },
  mobileParentActiveAccordion: function(container, tab, content){
    $container = $(container);
    $tab = $(container).find(tab);
    $content = $(container).find(content);

    $(tab + '.active').parent().next().slideToggle();

    $('body').on('click', tab, function(e){
      e.preventDefault();
      $(this).toggleClass('active');
      $(this).parent().next().slideToggle();
    });
  },
  initializeTabs: function(){
    $('body').on('click', 'ul.tabs > li > a', function(e) {
      e.preventDefault();
      var contentLocation = $(this).attr('href');
      if(contentLocation.charAt(0)=="#") {
        $('ul.tabs > li > a.active').removeClass('active');
        $(this).addClass('active');
        $(this).parents('ul.tabs').next().find(contentLocation).show().css({'display': 'block'}).addClass('active').siblings().hide().removeClass('active');
      }
    });
  },
  pageBannerCheck: function(){
    //check for header banner
    if (!$('.page_banner').length > 0 || $('.header').hasClass('header-background--solid')) {
      $('.feature_image').removeClass('feature_image');
      $('.header.is-absolute').removeClass('is-absolute');
      //hide secondary logo
      $('.secondary_logo--true').find('.secondary_logo').hide();
      $('.secondary_logo--true').find('.primary_logo').show();
    } else {
      $('.header').parent().addClass('feature_image');
      $('.header').addClass('is-absolute');
      //check for secondary logo
      if ($('header.feature_image').hasClass('secondary_logo--true')){
        $('.secondary_logo--true').find('.secondary_logo').show();
        $('.secondary_logo--true').find('.primary_logo').hide();
      }
    }

    //check for section that uses header banner on home page
    if ($('.index-sections').children().first().hasClass('under-menu')) {
      if (!$('.header').hasClass('header-background--solid')) {
        $('.index .header').parent().addClass('feature_image');
        $('.index .header').addClass('is-absolute');
      }
      //check for secondary logo
      if ($('header.feature_image').hasClass('secondary_logo--true')){
        $('.secondary_logo--true').find('.secondary_logo').show();
        $('.secondary_logo--true').find('.primary_logo').hide();
      }
    } else {
      $('.index .feature_image').removeClass('feature_image');
      $('.index .header.is-absolute').removeClass('is-absolute');
      //hide secondary logo
      if (!$('header.feature_image').hasClass('secondary_logo--true')){
        $('.secondary_logo--true').find('.secondary_logo').hide();
        $('.secondary_logo--true').find('.primary_logo').show();
      }
    }

    //check for section that uses header banner on the page details template
    if ($('.detail-sections').children().first().hasClass('under-menu')) {
      if (!$('.header').hasClass('header-background--solid')) {
        $('[class^="page-details"] .header').parent().addClass('feature_image');
        $('[class^="page-details"] .header').addClass('is-absolute');
      }

      //check for secondary logo
      if ($('header.feature_image').hasClass('secondary_logo--true')){
        $('.secondary_logo--true').find('.secondary_logo').show();
        $('.secondary_logo--true').find('.primary_logo').hide();
      }
    } else {
      $('[class^="page-details"] .feature_image').removeClass('feature_image');
      $('[class^="page-details"] .header.is-absolute').removeClass('is-absolute');

      //hide secondary logo
      if (!$('header.feature_image').hasClass('secondary_logo--true')){
        $('.secondary_logo--true').find('.secondary_logo').hide();
        $('.secondary_logo--true').find('.primary_logo').show();
      }
    }
  },
  resizeActionButtons: function(){
    $('.js-caption:visible').each(function(){
      var buttonWidth = 0;
      $(this).find('.action_button').each(function(){
        $button = $(this);
        if($(this).width() > buttonWidth){
            buttonWidth = $(this).width() + 1;
        }
      });
      $(this).find('.action_button').width(buttonWidth);
    });
  }
}

var sliderBlock = {
  select: function(blockId, $parentSection){
    var $blocks = $parentSection.find('.gallery-cell');
    var blockIdsArray = $blocks.map(function() {
      return String($(this).data('block-id'));
    });
    var $slider = $parentSection.find('.js-homepage-slideshow');
    var settings = {
      slideshowTextAnimation: $slider.data('slideshow-text-animation')
    }
    var flkty = $slider.data('flickity');

    $slider.flickity('pausePlayer');

    for(var i = 0; i < blockIdsArray.length; i++){
      if(blockIdsArray[i] === blockId){
        var currentSlide = i;
        if (currentSlide !== flkty.selectedIndex){
          $slider.flickity( 'select', parseInt(currentSlide), false, true);
        }
      }
    }
  },
  deselect: function($parentSection){
    var $slider = $parentSection.find('.flexslider').data('flexslider');
    if($slider) {
      $slider.flickity('unpausePlayer');
    }
  }
}

async function fetchProductColorway(productHandle){
  let query = `
    query {
      product(handle: "${productHandle}") {
        metafields(identifiers: [
          {key: "colorway", namespace: "accentuate"},
        ]){
          key
          value
        }
      }
    }
  `
  let productObject;
  await $.ajax({
    type: "POST",
    url: GRAPHQL_URL_VERSION,
    headers: graphqlHeadersObj,
    data: query,
    success: function(res) {
      if(res.data.product) {
        productObject = res.data.product;
      }
    },
    error: function (status) {
      console.log("AJAX error in query: ", status);
    },
  });

  return productObject;
}

async function fetchMetafieldsForCartItems(cart) {
  try {
    // Create an array to store the promises for each fetch operation
    const fetchPromises = cart.items.map((item, index) => {
      // Fetch colorway for the current item and return the promise
      return fetchProductColorway(item.handle).then((resColorway) => {
        // Set metafields on the cart.items object
        cart.items[index].colorwayMetafield = resColorway?.metafields[0]?.value;
      });
    });

    // Wait for all promises to resolve before returning the modified cart
    await Promise.all(fetchPromises);

    // Return the modified cart
    return cart;
  } catch (error) {
    console.error("Error fetching metafields:", error);
    // If an error occurs, return the original cart
    return cart;
  }
}

function removeAutoAddPairFromLocalStorage(variantId) {
  // Helper function to remove auto-add pair from localStorage when item is removed from cart
  // ensure variantId is valid before proceeding
  if (!variantId || typeof variantId === 'undefined') {
    return;
  }

  // Convert variantId to string for consistent comparison
  const variantIdStr = String(variantId);

  // Check if the removed item matches the stored auto-add pair variant ID
  const storedVariantId = localStorage.getItem('autoAddPairId');
  if (storedVariantId && storedVariantId === variantIdStr) {
    localStorage.removeItem('autoAddPairId');
  }
}

function extractVariantIdFromSerializedFormIntoArray(serializedString, customRecipeID) {
  const params = serializedString.split('&');
  const products = [];
  let currentProduct = {};

  params.forEach(param => {
    const [key, value] = decodeURIComponent(param).split('=');
    
    // Addons look like items[1][id], the regular product looks like id=12345
    if (key === 'id') {
      if(customRecipeID) {
        currentProduct = { id: parseInt(value), quantity: 1, properties: {"RecipeID": customRecipeID} };
      } else {
        currentProduct = { id: parseInt(value), quantity: 1 };
      }
      products.push(currentProduct);
    } else if (key.startsWith('items[') && key.endsWith('[id]')) {
      currentProduct = { id: parseInt(value), quantity: 1 };
      products.push(currentProduct);
    } 
  });

  return products;
}

function adjustPdpDiscountHandleBasedOnTestingFlag() {
  const pdpBackground = document.querySelector('.theridge-pdp__background');

  // If the window.testingPrimaryMinicartDiscount is false or if it doesn't exist, then we're not in testing mode
  // so if ACF fields are toggled on AND we're on a duplicate theme (even just for development), we should make sure the data attribute is
  // pointing to the defaultHandle
  if((pdpBackground && window.testingPrimaryMinicartDiscount === false) || typeof window.testingPrimaryMinicartDiscount === 'undefined') {
    const defaultHandle = pdpBackground.dataset.discountHandleDefault;
    const currentHandle = pdpBackground.dataset.discountHandle;

    // Only override if a default handle exists and it's different from the current one
    if (defaultHandle && defaultHandle !== currentHandle) {
      pdpBackground.dataset.discountHandle = defaultHandle;
    }
  } 
}
async function pdpAddToCart(e, form){
  e.preventDefault();
  
  // Disable all add-to-cart buttons to prevent multiple clicks
  if (typeof disableAllAddToCartButtons === 'function') {
    disableAllAddToCartButtons();
  }

  const pdpBackground = document.querySelector(".theridge-pdp__background");
  let isAutoAddPairToggled = pdpBackground?.dataset.toggleAutoaddProductPair;
  let autoAddProductPairVariantId = pdpBackground?.dataset.autoaddProductPairVariantId;
  let autoAddProductPairInStock = pdpBackground?.dataset.autoaddProductPairInStock;
  let autoAddValid = pdpBackground?.dataset.autoaddValid;

  var $addToCartForm = $(form);
  var $addToCartBtn = $addToCartForm.find('.add_to_cart');
  let ridgeSwatchFormV3 = document.querySelector(".ridge-product-swatch-v3")
  let addItemData = "";
  let customRecipeId = document.querySelector(".theridge-pdp__background[data-custom-recipeid]")?.dataset.customRecipeid; // undefined if not set in ACF
  let productsToAdd = extractVariantIdFromSerializedFormIntoArray($addToCartForm.serialize(), customRecipeId);
  let didAutoAddPair = false; // Flag to track if we're adding the auto-add pair

  let discountCodeStr = form.getAttribute("data-pdpmod16-discount-codes");
  let discountCodesArr = [];
  // turn discountCodeStr to array
  if(discountCodeStr && discountCodeStr.length > 0) {
    discountCodesArr = discountCodeStr.split(",");
  }
  // remove duplicates in discountCodesArr
  if(discountCodeStr && discountCodeStr.length > 0) {
    discountCodesArr = [...new Set(discountCodesArr)];
  }

  // Determine if we should attempt to auto-add a pair with thorough checks
  const shouldAutoAddPair = autoAddValid === "true"
    && isAutoAddPairToggled === "true"
    && autoAddProductPairVariantId
    && typeof autoAddProductPairVariantId === 'string'
    && autoAddProductPairVariantId.trim().length > 0
    && autoAddProductPairInStock === "true";

  // Log warning if auto-add is toggled on but configuration is invalid
  if(isAutoAddPairToggled === "true" && autoAddValid !== "true") {
    console.warn("Auto-add product pair is toggled ON but configuration is invalid. Check that the product handle in ACF exists and the product is published.");
  }

  // Check if ANY auto-add pair is already in the cart (only 1 auto-add allowed total)
  const autoAddPairInCart = localStorage.getItem('autoAddPairId');
  const canAutoAddPair = shouldAutoAddPair && (!autoAddPairInCart || autoAddPairInCart === '');

  // Build the items array based on what needs to be added
  if(customRecipeId && customRecipeId.length > 0) {
    // Custom recipe products exist - use productsToAdd array

    if(canAutoAddPair) {
      // BOTH custom recipe AND auto-add pair
      let autoAddItem = {
        'id': Number(autoAddProductPairVariantId),
        'quantity': 1
      };

      let itemData = {
        'items': [...productsToAdd, autoAddItem]
      };

      addItemData = itemData;
      didAutoAddPair = true; // Set flag to true so we can set localStorage on success
    } else {
      // ONLY custom recipe (no auto-add pair, or already have one in cart)
      let itemData = {
        'items': productsToAdd
      };

      addItemData = itemData;
    }

  } else if(canAutoAddPair) {
    // NO custom recipe, but CAN auto-add pair
    let autoAddItem = {
      'id': Number(autoAddProductPairVariantId),
      'quantity': 1
    };

    let itemData = {
      'items': [...productsToAdd, autoAddItem]
    };

    addItemData = itemData;
    didAutoAddPair = true; // Set flag to true so we can set localStorage on success

  } else {
    // NO custom recipe, NO auto-add (or already have one) - standard single product add
    addItemData = $addToCartForm.serialize();
  }

  // add discount codes to the cart
  await applyDiscountCode(discountCodesArr);

  console.log("[DEBUG] addItemData: ", addItemData);

  await $.ajax({
    url: '/cart/add.js',
    dataType: 'json',
    cache: false,
    type: 'post',
    data: addItemData,
    beforeSend: function() {
      $addToCartBtn.attr('disabled', 'disabled').addClass('disabled');
      $addToCartBtn.find('span').removeClass("fadeInDown").addClass('animated zoomOut');
      // sessionStorage.removeItem('defaultgridupsell');

    },
    success: function(itemData) {

      console.log("[DEBUG] after successful add.js: ", itemData);

      adjustPdpDiscountHandleBasedOnTestingFlag(); // for primary discount minicart testing, this is to force the default discount handle on the PDP if the testing flag is set to false

      // If we successfully added the auto-add pair, store the variant ID in localStorage
      // This prevents any other auto-add from happening (only 1 auto-add allowed per cart)
      if(didAutoAddPair) {
        localStorage.setItem('autoAddPairId', autoAddProductPairVariantId);
      }

      $addToCartBtn.find('.checkmark').addClass('checkmark-active');
      window.setTimeout(function(){
        $addToCartBtn.removeAttr('disabled').removeClass('disabled');
        $addToCartBtn.find('.checkmark').removeClass('checkmark-active');
        $addToCartBtn.find('span').removeClass('zoomOut').addClass('fadeInDown');
        window.setTimeout(function(){
          // These classes would stay on the button, which causes stickyATC (stickyATC.js.liquid) to
          // constantly animate when the button went in and out.
          // On page lod of PDP, these classes are originally not there, so this sets it back to original state
          $addToCartBtn.find('span').removeClass('animated');
          $addToCartBtn.find('span').removeClass('fadeInDown');

        },1000)
      }, 1000);

      let discountProductHandle = document.querySelector(".theridge-pdp__background").dataset.discountHandle;
      let currentProductHandle = document.querySelector(".theridge-pdp__background").dataset.productHandle;

      if(discountProductHandle && currentProductHandle) {
        let newDiscountStackObj = {};
        newDiscountStackObj[currentProductHandle] = discountProductHandle;

        if(!sessionStorage.getItem(DISCOUNT_STACK_SESSION_STORAGE_KEY)){
          sessionStorage.setItem(DISCOUNT_STACK_SESSION_STORAGE_KEY, JSON.stringify([newDiscountStackObj]))
          let currentDiscountSessionStorage = JSON.parse(sessionStorage.getItem(DISCOUNT_STACK_SESSION_STORAGE_KEY));
        } else {
          let newObj = {};
          newObj[currentProductHandle] = discountProductHandle;
          let currentDiscountSessionStorage = JSON.parse(sessionStorage.getItem(DISCOUNT_STACK_SESSION_STORAGE_KEY));
          if(!currentDiscountSessionStorage.some(obj => obj.hasOwnProperty(currentProductHandle))){
            currentDiscountSessionStorage.push(newObj);
            sessionStorage.setItem(DISCOUNT_STACK_SESSION_STORAGE_KEY, JSON.stringify(currentDiscountSessionStorage));
          }
        }
      }

      $.ajax({
        url: '/cart.js',
        dataType: "json",
        cache: false,
        success: function(cart) {

          // add lastAddedTocartItemTitle to session storage
          fetchProductColorway(cart.items[0].handle).then((res) => sessionStorage.setItem('lastAddedTocartItemTitle', res.metafields[0]?.value));
          fetchProductArchetype(cart.items[0].handle).then((productArchetype) => {
            sessionStorage.setItem('lastAddedTocartProductArchetype', productArchetype);
          } )


         // used to be settimeout'd but removed on 12-5-23
            console.log("[DEBUG] after successful add.js CALLING REFRESH MINICART!!", cart);
            refreshMiniCart(cart, true, true);

          // don't think these fake click things are needed anymore because of the new true param passed to refreshMiniCart that toggles the minicart.
          // this is the old hacky way of doing it and I don't think it is needed anymore
          if($('html').hasClass("remodal-is-locked")) {
            $('.remodal-close').click();
          }

          if($('#header').is(':visible')) {
            $('#header .cart_container').addClass('active_link');
          } else if ($('.sticky_nav--stick').length) {
            $('.sticky_nav .cart_container').addClass('active_link');
          } else {
            $('.top_bar .cart_container').addClass('active_link');
          }
        }
      });
    },
    // this is triggered when there is an error thrown on the add to cart operation
    // an example is when the entire remaining stock of an item is in the cart and no further quantity can be added to cart
    error: function(XMLHttpRequest) {
      var response = eval('(' + XMLHttpRequest.responseText + ')');
      response = response.description;
      $('.warning').remove();

      var warning = '<p class="warning animated bounceIn">' + response.replace('All 1 ', 'All ') + '</p>';
      $addToCartForm.after(warning);
      $addToCartBtn.removeAttr('disabled').removeClass('disabled');
      
      // Re-enable all add-to-cart buttons on error
      if (typeof enableAllAddToCartButtons === 'function') {
        enableAllAddToCartButtons();
      }

      // this main div element should also have the class name of 'shogun wallet-style-new'
      // when on the Shogun-Wallet-Style-New template only
      var mainDiv = $('.product-template .main');

      if (mainDiv) { // check that element exists
        let addToCartText = "Add To Cart";
        if (mainDiv.hasClass('shogun-wallet-style-new')) { // if contains the trigger class name, then render the alternative ATC text
          $addToCartBtn.find('span').text(addToCartText).removeClass('zoomOut').addClass('zoomIn');
        } else { // else render the standard ATC text
          $addToCartBtn.find('span').text(addToCartText).removeClass('zoomOut').addClass('zoomIn');
        }
      } else { // if element doesn't exist, fall back to standard ATC text
        $addToCartBtn.find('span').text(addToCartText).removeClass('zoomOut').addClass('zoomIn');
      }
    }
  });

  return false;
}

//document ready
jQuery(document).ready(function() {
  var oldFlickityCreate = window.Flickity.prototype._create;

  window.Flickity.prototype._create = function(){
    var that = this;
    if(this.element.addEventListener){
      this.element.addEventListener('load', function(){
        that.onresize();
      }, true);
    }
    this._create = oldFlickityCreate;
    return oldFlickityCreate.apply(this, arguments);
  };

 if(/Edge/.test(navigator.userAgent) || videoSection.isMobile() == true){

  // setTimeout(function(){ // I don't know where this settimeout terminates

  // PDP's ADD TO CART FUNCTION for MOBILE ATC buttons
  
    $('body').on('submit', ".product_form", function(e) {
      e.preventDefault();
      pdpAddToCart(e, this);
    });
  
    header.init();
    header.loadMegaMenu();
    utils.pageBannerCheck();
    slideshow.init();
    testimonial.init();
    gallery.init();
    videoSection.init();
    featuredPromotions.init();
    featuredCollectionSection.init();
    collectionSidebarFilter.init();
    productFormListeners.init();
    cart.init();
	productPage.initializeQuantityBox();
    productPage.init();
    productPage.relatedProducts();
    jQuery('.add_to_cart').removeAttr('disabled');
   // }, 1000);

   }else{

  // PDP's ADD TO CART FUNCTION for DESKTOP ATC buttons
  
    $('body').on('submit', ".product_form", function(e) {
      e.preventDefault();
      pdpAddToCart(e, this);
    });
  
    header.init();
    header.loadMegaMenu();
    utils.pageBannerCheck();
    slideshow.init();
    testimonial.init();
    gallery.init();
    videoSection.init();
    featuredPromotions.init();
    featuredCollectionSection.init();
    collectionSidebarFilter.init();
    productFormListeners.init();
    cart.init();

    productPage.initializeQuantityBox();
    productPage.init();
    productPage.relatedProducts();
    jQuery('.add_to_cart').removeAttr('disabled');
   }


  //Initiate recently viewed below product
  if ($('.js-recently-viewed .rv-main').length) {
    recentlyViewed.init('.js-recently-viewed');
  } else if ($('.product-template').length) {
    recentlyViewed.init();
  }

  if ($('.sidebar .js-sidebar-recently-viewed').length) {
    if ($.cookie('recentlyViewed') != ''){
      recentlyViewed.init('.sidebar .js-sidebar-recently-viewed');
    } else {
      $('.js-sidebar-recently-viewed.hidden').parents('.sidebar-block').remove();
    }
  }

  //Set current slide
  $('body').on('click', '.lightbox', function(){
    currentSlide = $(this).data('image-id');
  });

  //detect when a remodal lightbox is opened
  $('body').on('opened', '.js-remodal-lightbox', function () {

    var $currentLightbox = $(this);
    var $currentLightboxGallery = $currentLightbox.find('.lightbox-gallery');
    var $currentLightboxImages = $currentLightbox.find('.lightbox-image');
    var activate_zoom = $('body').find('.product_gallery').data('zoom');
    var arrowShow = $currentLightboxImages.length === 1 ? false : true;
    var group = $(this).data('rel');
    var draggable = true;

    $currentLightbox.attr('data-zoom', activate_zoom);

    if (activate_zoom && $(window).width() <= 767) {
      draggable = false;
    } else {
      draggable = $currentLightboxImages.length === 1 ? false : true;
    }

    //Add gallery when lightbox opens
    if (!$currentLightboxGallery.hasClass('flickity-enabled')){
      var $lightboxGallery = $currentLightboxGallery.flickity({
        "wrapAround": "true",
        "cellAlign": "left",
        "contain": true,
        "imagesLoaded": true,
        "lazyLoad": 2,
        "pageDots": false,
        "draggable": draggable,
        "prevNextButtons": arrowShow,
        "selectedAttraction": 0.01,
        "friction": 0.15,
        "arrowShape": arrowSize
      });
    }

    $groupImages = $('.lightbox[rel=' + group + ']');

    var $cellElems;

    $groupImages.each(function(index){
      var imagePath = $(this).attr('href');
      $cellElems = $('<div class="gallery-cell"><img src="'+ imagePath +'" class="lightbox-image"></div>');

      if ($groupImages.length > $currentLightboxGallery.find('.gallery-cell').length){
        $currentLightboxGallery.flickity( 'append', $cellElems );
      }

      $currentLightboxGallery.flickity( 'select', currentSlide, false, true ).focus();
      $currentLightbox.find('.lightbox-image').css('opacity', '1');
    });

    //add zoom to product images
    if (activate_zoom && $(window).width() <= 767) {
      imageFunctions.zoom('.js-remodal-lightbox', true, 1.8);
    }

    setTimeout(function(){
		$lightboxGallery.flickity('resize');
    }, 2000);

  });

  $('body').on('closed', '.js-remodal-lightbox', function () {
    var $currentLightbox = $(this);
    $currentLightbox.find('.lightbox-image').css('opacity', '0');
  });

  

  if(window.location.pathname.indexOf('/comments') != -1) {
    $('html,body').animate({scrollTop: $("#new-comment").offset().top-140},'slow');
  }

  $('body').on('mouseenter', '.icon-search', function() {
    $('.search-terms').focus();
  });

  $('body').on('click', '.search-submit', function() {
    $(this).parent().submit();
  });

  if ($(window).width() >= 768) {
    $(".animate_right").waypoint(function() {
      $(this.element).addClass("animated fadeInRight");
    }, { offset: '70%' });
    $(".animate_left").waypoint(function() {
      $(this.element).addClass("animated fadeInLeft");
    }, { offset: '70%' });
    $(".animate_up").waypoint(function() {
      $(this.element).addClass("animated fadeInUp");
    }, { offset: '70%' });
    $(".animate_down").waypoint(function() {
      $(this.element).addClass("animated fadeInDown");
    }, { offset: '70%' });
  }

  //backwards compatibility with flexslider
  $('.slider, .flexslider').find('li').unwrap();
  $('.slider, .flexslider').flickity({
    pageDots: false,
    imagesLoaded: true,
    lazyLoad: 2
  });

  utils.createAccordion('.toggle-all--true', 'h4.toggle', 'ul.toggle_list');
  utils.createAccordion('.footer_menu', 'h6', 'ul');
  utils.createAccordion('.footer_content', 'h6', 'div.toggle_content');
  utils.createAccordion('.product_section .accordion-tabs', '.tabs li > a', '.tabs-content li');

  utils.mobileParentActiveAccordion('#mobile_menu', 'li.sublink > a.parent-link--true span', 'li.sublink ul');
  utils.mobileAccordion('#mobile_menu', 'li.sublink > a.parent-link--false', 'li.sublink ul');

  utils.initializeTabs();
  utils.resizeActionButtons();

  $(window).on('resize', function() {
    utils.resizeActionButtons();
  });

  //Sidebar toggle check
  if ($(window).width() >= 768) {
    $('.toggle-all--true .toggle_list .active').parents('ul.toggle_list').prev().click();
    $('.toggle-all--true .toggle_list .filter-active-tag input:checked').parents('ul.toggle_list').prev().click();
  } else {
    utils.createAccordion('.toggle-all--false', 'h4.toggle', 'ul.toggle_list');
  }

  if ($('.shopify-section.page-details-section').length){
    // Don't apply mediaWrapper
  } else if ($('body').hasClass('index')) {
    $('.featured-products-section iframe[src*=youtube], .featured-products-section iframe[src*=vimeo]').mediaWrapper({
      intrinsic: true
    });
  } else {
    $('iframe[src*=youtube]:not(.shogun-video-embed), iframe[src*=vimeo]:not(.shogun-video-embed)').mediaWrapper({
      intrinsic: true
    });
  }

  if ($(window).width() >= 959) {
    var modal_width = '870px';
    if($(window).width() >= 1200 || $('html').hasClass('ie')) {
      modal_width = '1110px'
    }
  }

  

  //Terms of service settings for minicart
  

  


  
    imageFunctions.showSecondaryImage();
  

  var $contact_form = $('.newsletter .contact-form');
  $contact_form.each(function() {
    var $cf = $(this);
    $cf.on('submit', function (e) {
      if($('input[name="challenge"]', $cf).val() !== "true") {
        $.ajax({
          type: $cf.attr('method'),
          url: $cf.attr('action'),
          data: $cf.serialize(),
          success: function (data) {

            $cf.fadeOut("slow", function(){
              $cf.prev('.message').html("Thank you for joining our mailing list!");
            });
          },
          error: function(data) {
            $('input[name="challenge"]', $cf).val('true');
            $cf.submit();
          }
        });
        e.preventDefault();
      }
    });
  });

  $('.maps').click(function () {
    $('.maps iframe').css("pointer-events", "auto");
  });

  
    enableLoadMoreProducts();
  

  



  /*============================================================================
    Quick Shop
  ==============================================================================*/

  var globalQuickShopProduct;

  $('body').on('change', '.currencies', function(e) {
      $('[data-initial-modal-price]').attr('data-initial-modal-price', '');
  });

  $('body').on('change', '.js-quick-shop select', function(e) {
    var currentVariant = $('.js-quick-shop select[name="id"]').val();
    if (currentVariant && globalQuickShopProduct){
      quickShop.updateVariant(currentVariant);
    }
  });

  var quickShop = {
    init: function(){
      //Quick-shop variables
      var productData;
      var productForm;
      var notifyForm;

      //EVENT - click on quick-shop
      $('body').on('click', '.js-quick-shop-link', function(e){
        e.preventDefault();

        //split image info into two arrays
        var arr = $(this).data('images').trim('||').split('||');
        var imageIds = [];
        var imageAlts = [];
        for (var i = 0; i < arr.length; i += 2) {
            imageIds.push(arr[i]);
            arr[i+1] && imageAlts.push(arr[i + 1]);
        }

        //Set productData based on data attributes
        productData = {
          handle: $(this).data('handle'),
          product_id: $(this).data('id'),
          id_num: $(this).attr('data-id'),
          formatted_price: $(this).attr('data-price'),
          formatted_compare_at_price: $(this).attr('data-compare-price'),
          product_in_collection_url: $(this).data('url'),
          escaped_title: $(this).data('title'),
          details_text: $(this).data('details-text'),
          full_description: $(this).data('full-description'),
          regular_description: $(this).data('regular-description'),
          image_ids: imageIds.filter(function(v){return v!==''}),
          image_alts: imageAlts,
          collection_handles: $(this).data('collection-handles').trim(',').split(','),
          money_format: $(this).data('money-format')
        }

        if (!$('.js-gallery-modal').hasClass('flickity-enabled')){
          $('.js-gallery-modal').flickity({
            "wrapAround": "true",
            "cellAlign": "left",
            "contain": true,
            "imagesLoaded": true,
            "lazyLoad": 2,
            "pageDots": false,
            "prevNextButtons": true,
            "autoPlay": autoplay,
            "selectedAttraction": 0.01,
            "friction": 0.15,
            "arrowShape": arrowSize
          });
        }

        //Find current product and notify forms
        notifyForm = $(this).next('.js-forms').find('.notify_form');
        productForm = $(this).next('.js-forms').find('.product_form');
        //Add Product Ids to parent container so form will work
        $('.quick-shop .container').attr('class', 'container section product-' + productData.product_id);
        $('.quick-shop .container').attr('id', 'product-' + productData.product_id);
        $('.quick-shop .container').attr('data-id', productData.product_id);
        //Function to send attribute data to API
        quickShop.retrieveProductInfo(productData);

      });

      //EVENT - modal is open
      $('body').on('opened', '.js-quick-shop', function () {

        //Copy form data to modal
        $('.remodal.quick-shop .js-product-form').html(productForm);
        $('.remodal.quick-shop .js-notify-form').html(notifyForm);

        //Initiate selectCallback
        if($(productForm).hasClass("product_form_options") && !$(productForm).hasClass("viewed")) {
          new Shopify.OptionSelectors($(productForm).data("select-id"), { product: $(productForm).data("product"), onVariantSelected: selectCallback, enableHistoryState: $(productForm).data("enable-state") });
        } else {
          
        }

        
          var JSONData = $(productForm).data("product");
          var swatchOptions = $(productForm).find('.swatch_options .swatch');
          if (swatchOptions.length > 1){

         // variation issue. Delayed script to execute by 2 seconds
         setTimeout(function(){
                  Shopify.linkOptionSelectors(JSONData, '.js-quick-shop');
   		 },2000);
          }
        

        utils.initializeTabs();
        $('.js-quick-shop select[name="id"]').trigger('change');

      });

      //EVENT - modal is closed
      $('body').on('closed', '.js-quick-shop', function (e) {

        var insertedProductForm = $('.js-quick-shop .product_form');
        var insertedNotifyForm = $('.js-quick-shop .notify_form');

        //Copy form data back to product loop and add .viewed
        $('.form-holder-'+ productData.product_id).append(insertedProductForm);
        $('.form-holder-'+ productData.product_id).append(insertedNotifyForm);
        $('.form-holder-'+ productData.product_id +' .product_form').addClass('viewed');
        $('.form-holder-'+ productData.product_id +' .notify_form').addClass('viewed');
        var variantPrice = $('.js-current-price .money').text();
        $('.js-quick-shop-link[data-id=' + productData.product_id + ']').attr('data-initial-modal-price', variantPrice);
        $('.js-current-price, .js-was-price, .js-savings').empty();
      });

    },
    retrieveProductInfo: function(productData){
      //Call to API to retrieve product JSON
      var jqxhr = $.getJSON( '/products/' + productData.handle + '.js')
      .done(function(product) {
        var product = $.extend({}, product, productData); //Create new object combining info
        quickShop.populateGallery(product);

        globalQuickShopProduct = product;

        if (product.variants.length == 1){
          quickShop.updateVariant(product.id.toString());
        } else {
          quickShop.updateVariant();
        }
      })

    },
    updateVariant: function(variant){
      $('.js-sale-banner, .js-sold-out, .js-current-price, .js-was-price, .js-savings, .js-new-banner, .js-pre-order-banner').empty();

      if (globalQuickShopProduct != 'undefined'){
        var product = globalQuickShopProduct;

        $('.modal_price, .js-notify-form').show();

        //Title and Vendor
        $('.js-product-title').html('<a href="'+ product.product_in_collection_url +'" title="'+ product.escaped_title +'">'+ product.metafields.accentuate.colorway +'</a>');
        $('.js-product-vendor')
        .html('<a href="/collections/vendors?q=' + product.vendor +'">' + product.vendor + '</a>');

        //Product Description
        $('.js-full-description').html(product.full_description);
        $('.js-regular-description').html(product.regular_description);
        var productDetails = '<a href="'+ product.product_in_collection_url +'" class="secondary_button" title="'+ product.escaped_title +' Details">'+ product.details_text +'</a>';
        $('.js-product-details').html(productDetails);

        //Collection banners
        $.each( product.collection_handles, function( value, index ) {
          if (this.toString() == 'new'){
            $('.js-new-banner').html("New");
          }
          if (this.toString() == 'pre-order'){
            $('.js-pre-order-banner').html("Pre-Order");
          }
        });

        if (product.variants.length == 1){
        //No variants
          //Sale Banner
          
            if (product.compare_at_price > product.price){
             $('.js-sale-banner').html("Sale");
            }
          

          //Sale
          if (product.compare_at_price > product.price) {
            $('.js-current-price').addClass('sale');
          } else {
            $('.js-current-price').removeClass('sale');
          }

          //Availability
          if (product.available == false){
            $('.js-sold-out').html("Sold Out");
          }

          //Price
          if (product.available == true) {

            if (product.compare_at_price > product.price) {
              $('.js-was-price').html('<span class="money">' + Shopify.formatMoney(product.compare_at_price, product.money_format)  + '</span>');
              $('.js-savings').html("You Save" + ' ' + parseInt(((product.compare_at_price - product.price) * 100) / product.compare_at_price) + '% (' + '<span class="money">' + Shopify.formatMoney(product.compare_at_price - product.price, product.money_format) + '</span>)');
            }

            if (product.price == "Coming Soon"){
              $('.js-current-price').html("Coming Soon");
            } else if (product.price) {
              $('.js-current-price').html('<span class="money">' + Shopify.formatMoney(product.price, product.money_format) + '</span>');
            } else {
              $('.js-current-price').html('Free');
            }
          }
        } else {
          //Variant loop
          for (var i = 0; i < product.variants.length; i++) {
            if (variant == product.variants[i].id.toString()){
              //Sale Banner
              
                if (product.variants[i].compare_at_price > product.variants[i].price){
                 $('.js-sale-banner').html("Sale");
                }
              

              //Sale
              if (product.variants[i].compare_at_price > product.variants[i].price) {
                $('.js-current-price').addClass('sale');
              } else {
                $('.js-current-price').removeClass('sale');
              }

              //Availability
              if (product.variants[i].available == false){
                $('.js-sold-out').html("Sold Out");
              }

              //Price
              if (product.variants[i].available == true) {

                if (product.variants[i].compare_at_price > product.variants[i].price) {
                  $('.js-was-price').html('<span class="money">' + Shopify.formatMoney(product.variants[i].compare_at_price, product.money_format) + '</span>');
                  $('.js-savings').html("You Save" + ' ' + parseInt(((product.variants[i].compare_at_price - product.variants[i].price) * 100) / product.variants[i].compare_at_price) + '% (' + '<span class="money">' + Shopify.formatMoney(product.variants[i].compare_at_price - product.variants[i].price, product.money_format) + '</span>)');
                }

                if (product.variants[i].price == "Coming Soon"){
                  $('.js-current-price').html("Coming Soon");
                } else if (product.variants[i].price) {
                  $('.js-current-price').html('<span class="money">' + Shopify.formatMoney(product.variants[i].price, product.money_format) + '</span>');
                } else {
                  $('.js-current-price').html('Free');
                }
              }
            }
          }
        }
      }

      

      $('.js-quick-shop iframe[src*=youtube], .js-quick-shop iframe[src*=vimeo]').mediaWrapper({
        intrinsic: true
      });

    },
    populateGallery: function(product){

      //Find gallery and carousel
      var $gallery = $('.js-gallery-modal');
      var $carousel = $('.js-gallery-carousel');

      //EVENT - modal closed
      $(document).on('closed', '.js-quick-shop', function (e) {
        $gallery.flickity( 'remove', $('.js-gallery-modal .gallery-cell') );
        $carousel.empty();
      });

      //Add gallery images based on product info from API
      function addMainGalleryImages(multiImage){

        $.each( product.images, function( i, imgPath ){

          var imgGrande = imgPath.replace(/(\.[^.]*)$/, "_grande$1").replace('http:', '');
          var img1024x1024 = imgPath.replace(/(\.[^.]*)$/, "_1024x1024$1").replace('http:', '');
          var img2048x2048 = imgPath.replace(/(\.[^.]*)$/, "_2048x2048$1").replace('http:', '');
          var alt = product.image_alts[i];
          var cellContent;

          if (alt.indexOf("youtube") >= 0){
            cellContent = '<div class="video-container youtube"><div>' + alt + '</div></div>';
          } else if (alt.indexOf("vimeo") >= 0) {
            cellContent = '<div class="video-container vimeo"><div>' + alt + '</div></div>';
          } else {
            cellContent = '<img src="'+ imgGrande + '" data-src="' + img1024x1024 + '" alt="' + alt + '" data-image-id="' + product.image_ids[i].trim() + '" data-index="' + i + '" srcset="' + imgGrande + ' 600w, ' + img1024x1024 + ' 1024w, ' + img2048x2048 + ' 2048w" sizes="(min-width: 800px) 50vw, 100vw"/>';
          }

          var $cellElems = $('<div class="gallery-cell">'+ cellContent +'</div>');
          $gallery.flickity( 'append', $cellElems );
        });

        $gallery.removeClass('single-image multi-image').addClass(multiImage ? 'multi-image' : 'single-image');

      }

      //Add carousel images based on product info from API
      function addCarouselGalleryImages(){
        $.each( product.images, function( i, imgPath ){
          var carouselSizedImg = imgPath.replace(/(\.[^.]*)$/, "_grande$1").replace('http:', '');

          var img = '<img src="'+ carouselSizedImg + '" alt="' + product.escaped_title + '" />';
          var $carouselCellElems = $('<div class="gallery-cell">'+ img +'</div>');
          $carousel.append($carouselCellElems);
        });

        imageFunctions.linkGalleryAndCarousel($gallery, $carousel);

      }

      //Check how many images are returned from API - addMainGalleryImages() takes true or false based on whether gallery slider is multi-image (shows prev/next arrows)
      var multiImage;

      if(product.images.length > 1){
        multiImage = true;
        addMainGalleryImages(multiImage);
        addCarouselGalleryImages();
      } else {
        multiImage = false;
        addMainGalleryImages(multiImage);
      }

      imageFunctions.zoom('.js-gallery-modal', false);

    }
  }

  

  /*============================================================================
    Start of cart-related functionality
  ==============================================================================*/

  function ajaxSubmitCart(cart) {
    $cart = cart;
    $.ajax({
      url: '/cart/update.js',
      dataType: 'json',
      cache: false,
      type: 'post',
      data: $cart.serialize(),
      success: function (data) {
       // refreshMiniCart(data);
      }
    });
  }

  function ajaxUpdateCart(lineID, quantity, parent) {
    $.ajax({
      url: '/cart/change.js',
      dataType: 'json',
      cache: false,
      type: 'post',
      data: { quantity: quantity, line: lineID },
      success: function (data) {
        refreshMiniCart(data, false, false);

        var lineIDIndex = lineID - 1;

        //check to see if there are correct amount of products in array
        if (typeof data.items[lineIDIndex] === "undefined"){
          var updated_quantity = 0;
        } else {
          var updated_quantity = data.items[lineIDIndex].quantity;
        }

        if(quantity > 0 && quantity != updated_quantity) {
          if (updated_quantity == 1) {
            items_left_text = "item left";
          } else {
            items_left_text = "items left";
          }

          $('.warning--quantity').remove();

          var warning = '<p class="warning warning--quantity animated bounceIn">' + updated_quantity + ' ' + items_left_text + '</p>';
          parent.find("input[data-line-id='" + lineID + "']").parent().after(warning);
          parent.find("input[data-line-id='" + lineID + "']").val(updated_quantity);
        } else if (parent.is('#cart_form')) {
          $("#cart_form").submit();
        }
      }
    });
  }

  function refreshCart(cart) {
    $cartBtn = $(".cart_count");
    var value = $cartBtn.text() || '0';
    var cart_items_html = "";
    var cart_action_html = "";
    var cart_savings_html = "";
    var $cart = $(".cart_content form");
    var discounted_price_total = 0;
    var total_savings = 0;

    $cartBtn.text(value.replace(/[0-9]+/,cart.item_count));

    if (cart.item_count == 0) {
      $('.js-empty-cart__message').removeClass('hidden');
      $('.js-cart_content__form').addClass('hidden');
    } else {
      $('.js-empty-cart__message').addClass('hidden');
      $('.js-cart_content__form').removeClass('hidden');

      $.each(cart.items, function(index, item) {
        var line_id = index + 1;
        cart_items_html += '<li class="cart_item clearfix">' +
          '<a href="' + item.url +'">';
        if (item.image) {
          cart_items_html += '<div class="cart_image">' +
              '<img src="' + item.image.replace(/(\.[^.]*)$/, "_compact$1").replace('http:', '') + '" alt="' + htmlEncode(item.title) + '" />' +
            '</div>';
        }

        cart_items_html += '<strong class="right price">';

        

        cart_items_html += '<span class="money">' + Shopify.formatMoney(item.price, $cart.data('money-format')) + '</span></strong>' +
          '<div class="item_title">' + item.title;

        if(item.properties) {
          $.each(item.properties, function(title, value) {
            if (value) {
              cart_items_html += '<div class="line-item">' + title +': ' + value + '</div>';
            }
          });
        }

        cart_items_html += '</div></a>';

        cart_items_html += '<div class="left product-quantity-box">' +
            '<span class="ss-icon product-minus js-change-quantity" data-func="minus"><span class="icon-minus"></span></span>' +
            '<input type="number" min="0" class="quantity" name="updates[]" id="updates_' + item.id + '" value="' + item.quantity +'" data-line-id="' + line_id +'" />' +
            '<span class="ss-icon product-plus js-change-quantity" data-func="plus"><span class="icon-plus"></span></span>' +
          '</div>' +
        '</li>';


      });

      cart_action_html += '<span class="right"><span class="money">' + Shopify.formatMoney(NEW_TOTAL_PRICE, $cart.data('money-format')) + '</span></span>' +
          '<span>Subtotal</span>';

      if(total_savings > 0 ) {
        cart_savings_html = '<span class="right"><span class="money">' + Shopify.formatMoney(total_savings - discounted_price_total, $cart.data('money-format')) + '</span></span>' +
            '<span>Total Savings</span>';
      } else {
        cart_savings_html = "";
      }
    }

    $('.js-cart_items').html(cart_items_html);
    $('.js-cart_subtotal').html(cart_action_html);
    $('.js-cart_savings').html(cart_savings_html);

    
  }
  $('body').on("change", "#cart_form input.quantity", function() {
    const quantity = parseInt($(this).val());
    const inputId = $(this).attr('id');

    // Defensive check: ensure input has an ID before processing
    if (!inputId) return;

    const variantId = inputId.replace('updates_', '');

    // Check if quantity is being set to 0 and if it matches the auto-add pair
    if(quantity === 0 && variantId) {
      removeAutoAddPairFromLocalStorage(variantId);
    }

    ajaxUpdateCart($(this).data('line-id'), $(this).val(), $(this).parents('#cart_form'));
  });

  $('body').on("change", ".cart_content input.quantity", function() {
    const quantity = parseInt($(this).val());
    const inputId = $(this).attr('id');

    // Defensive check: ensure input has an ID before processing
    if (!inputId) return;

    const variantId = inputId.replace('updates_', '');

    // Check if quantity is being set to 0 and if it matches the auto-add pair
    if(quantity === 0 && variantId) {
      removeAutoAddPairFromLocalStorage(variantId);
    }

    ajaxUpdateCart($(this).data('line-id'), $(this).val(), $(this).parents('.cart_content'));
  });
  //Swatches linked with selected options
  
    if ($('.js-product_section').length){
      var $productForms = $('.js-product_section').find('.product_form');

      //Loop through each product and set the initial option value state
      $productForms.each(function(){
        var JSONData = $(this).data('product');
        var productID = $(this).data('product-id');
        var productSection = '.product-' + productID + ' .js-product_section';
        var swatchOptions = $(this).find('.swatch_options .swatch');
        if (swatchOptions.length > 1){
          // variation issue. Delayed script to execute by 2 seconds
          setTimeout(function(){
            Shopify.linkOptionSelectors(JSONData, productSection);
          },2000);
        }
      });
    }

    //Add click event when there is more than one product on the page (eg. Collection in Detail)
    if ($('.js-product_section').length > 1){
      $('body').on('click', '.swatch-element', function(){
        var swatchValue = $(this).data('value');

        $(this)
        .siblings('input[value="'+ swatchValue.replace(/\"/g,'\\"') +'"]')
        .prop("checked", true)
        .trigger("change");

        var JSONData = $(this).parents('.product_form').data('product');
        var productID = $(this).parents('.product_form').data('product-id');
        var productSection = '.product-' + productID + ' .js-product_section';
        var swatchOptions = $(this).parents('.product_form').find('.swatch_options .swatch');
        if (swatchOptions.length > 1){

         // variation issue. Delayed script to execute by 2 seconds
         setTimeout(function(){
                  Shopify.linkOptionSelectors(JSONData, productSection);
   		 },2000);

        }
      })
    }
  

});

/*============================================================================
  Swatch options - second and third swatch 'sold-out' will update based on availability of previous options selected
==============================================================================*/

Shopify.updateOptionsInSelector = function(selectorIndex, parent) {

  switch (selectorIndex) {
    case 0:
      var key = 'root';
      var selector = $(parent + ' .single-option-selector:eq(0)');
      break;
    case 1:
      var key = $(parent + ' .single-option-selector:eq(0)').val();
      var selector = $(parent + ' .single-option-selector:eq(1)');
      break;
    case 2:
      var key = $(parent + ' .single-option-selector:eq(0)').val();
      key += ' / ' + $(parent + ' .single-option-selector:eq(1)').val();
      var selector = $(parent + ' .single-option-selector:eq(2)');
  }

  var availableOptions = Shopify.optionsMap[key];

  $(parent + ' .swatch[data-option-index="' + selectorIndex + '"] .swatch-element').each(function() {

    if ($.inArray($(this).attr('data-value'), availableOptions) !== -1) {
      $(this).removeClass('soldout').find(':radio').removeAttr('disabled','disabled').removeAttr('checked');
    }
    else {
      $(this).addClass('soldout').find(':radio').removeAttr('checked').attr('disabled','disabled');
    }
  });

  $(parent + ' .swatch[data-option-index="' + selectorIndex + '"] select option').each(function() {
   // debugger;
    if ($("."+this.value).parent('div').hasClass('soldout')) {
      	$(this).html($("."+this.value).html()+'-Sold Out');
    }
    else {
      	$(this).html($("."+this.value).html());
    }
  });

  selector.trigger('change');

};

Shopify.linkOptionSelectors = function(product, parent) {
    // Building our mapping object.
    Shopify.optionsMap = {};
    for (var i=0; i<product.variants.length; i++) {
      var variant = product.variants[i];
      if (variant.available) {
        // Gathering values for the 1st drop-down.
        Shopify.optionsMap['root'] = Shopify.optionsMap['root'] || [];
        Shopify.optionsMap['root'].push(variant.option1);
        Shopify.optionsMap['root'] = Shopify.uniq(Shopify.optionsMap['root']);
        // Gathering values for the 2nd drop-down.
        if (product.options.length > 1) {
          var key = variant.option1;
          Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
          Shopify.optionsMap[key].push(variant.option2);
          Shopify.optionsMap[key] = Shopify.uniq(Shopify.optionsMap[key]);
        }
        // Gathering values for the 3rd drop-down.
        if (product.options.length === 3) {
          var key = variant.option1 + ' / ' + variant.option2;
          Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
          Shopify.optionsMap[key].push(variant.option3);
          Shopify.optionsMap[key] = Shopify.uniq(Shopify.optionsMap[key]);
        }
      }
    }
    // Update options right away.
    Shopify.updateOptionsInSelector(0, parent);
    if (product.options.length > 1) Shopify.updateOptionsInSelector(1, parent);
    if (product.options.length === 3) Shopify.updateOptionsInSelector(2, parent);
    // When there is an update in the first dropdown.
    $(parent + " .single-option-selector:eq(0)").change(function() {
      Shopify.updateOptionsInSelector(1, parent);1
      if (product.options.length === 3) Shopify.updateOptionsInSelector(2, parent);
      return true;
    });
    // When there is an update in the second dropdown.
    $(parent + " .single-option-selector:eq(1)").change(function() {
      if (product.options.length === 3) Shopify.updateOptionsInSelector(2, parent);
      return true;
    });
};

//Used for cart functionality
function htmlEncode(value){
    if (value) {
        return $('<div/>').text(value).html();
    } else {
        return '';
    }
}

//Check if device is touch-enabled
function is_touch_device() {
  return 'ontouchstart' in window || navigator.maxTouchPoints;
};

/* option_selection.js */
function floatToString(t,e){var o=t.toFixed(e).toString();return o.match(/^\.\d+/)?"0"+o:o}if("undefined"==typeof Shopify)var Shopify={};Shopify.each=function(t,e){for(var o=0;o<t.length;o++)e(t[o],o)},Shopify.map=function(t,e){for(var o=[],i=0;i<t.length;i++)o.push(e(t[i],i));return o},Shopify.arrayIncludes=function(t,e){for(var o=0;o<t.length;o++)if(t[o]==e)return!0;return!1},Shopify.uniq=function(t){for(var e=[],o=0;o<t.length;o++)Shopify.arrayIncludes(e,t[o])||e.push(t[o]);return e},Shopify.isDefined=function(t){return"undefined"==typeof t?!1:!0},Shopify.getClass=function(t){return Object.prototype.toString.call(t).slice(8,-1)},Shopify.extend=function(t,e){function o(){}o.prototype=e.prototype,t.prototype=new o,t.prototype.constructor=t,t.baseConstructor=e,t.superClass=e.prototype},Shopify.locationSearch=function(){return window.location.search},Shopify.locationHash=function(){return window.location.hash},Shopify.replaceState=function(t){window.history.replaceState({},document.title,t)},Shopify.urlParam=function(t){var e=RegExp("[?&]"+t+"=([^&#]*)").exec(Shopify.locationSearch());return e&&decodeURIComponent(e[1].replace(/\+/g," "))},Shopify.newState=function(t,e){var o;return o=Shopify.urlParam(t)?Shopify.locationSearch().replace(RegExp("("+t+"=)[^&#]+"),"$1"+e):""===Shopify.locationSearch()?"?"+t+"="+e:Shopify.locationSearch()+"&"+t+"="+e,o+Shopify.locationHash()},Shopify.setParam=function(t,e){Shopify.replaceState(Shopify.newState(t,e))},Shopify.Product=function(t){Shopify.isDefined(t)&&this.update(t)},Shopify.Product.prototype.update=function(t){for(property in t)this[property]=t[property]},Shopify.Product.prototype.optionNames=function(){return"Array"==Shopify.getClass(this.options)?this.options:[]},Shopify.Product.prototype.optionValues=function(t){if(!Shopify.isDefined(this.variants))return null;var e=Shopify.map(this.variants,function(e){var o="option"+(t+1);return void 0==e[o]?null:e[o]});return null==e[0]?null:Shopify.uniq(e)},Shopify.Product.prototype.getVariant=function(t){var e=null;return t.length!=this.options.length?e:(Shopify.each(this.variants,function(o){for(var i=!0,r=0;r<t.length;r++){var n="option"+(r+1);o[n]!=t[r]&&(i=!1)}return 1==i?void(e=o):void 0}),e)},Shopify.Product.prototype.getVariantById=function(t){for(var e=0;e<this.variants.length;e++){var o=this.variants[e];if(t==o.id)return o}return null},Shopify.money_format="$",Shopify.formatMoney=function(t,e){function o(t,e){return"undefined"==typeof t?e:t}function i(t,e,i,r){if(e=o(e,2),i=o(i,","),r=o(r,"."),isNaN(t)||null==t)return 0;t=(t/100).toFixed(e);var n=t.split("."),a=n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g,"$1"+i),s=n[1]?r+n[1]:"";return a+s}"string"==typeof t&&(t=t.replace(".",""));var r="",n=/\{\{\s*(\w+)\s*\}\}/,a=e||this.money_format;switch(a.match(n)[1]){case"amount":r=i(t,2);break;case"amount_no_decimals":r=i(t,0);break;case"amount_with_comma_separator":r=i(t,2,".",",");break;case"amount_no_decimals_with_comma_separator":r=i(t,0,".",",")}return a.replace(n,r)},Shopify.OptionSelectors=function(t,e){return this.selectorDivClass="selector-wrapper",this.selectorClass="single-option-selector",this.variantIdFieldIdSuffix="-variant-id",this.variantIdField=null,this.historyState=null,this.selectors=[],this.domIdPrefix=t,this.product=new Shopify.Product(e.product),this.onVariantSelected=Shopify.isDefined(e.onVariantSelected)?e.onVariantSelected:function(){},this.replaceSelector(t),this.initDropdown(),e.enableHistoryState&&(this.historyState=new Shopify.OptionSelectors.HistoryState(this)),!0},Shopify.OptionSelectors.prototype.initDropdown=function(){var t={initialLoad:!0},e=this.selectVariantFromDropdown(t);if(!e){var o=this;setTimeout(function(){o.selectVariantFromParams(t)||o.fireOnChangeForFirstDropdown.call(o,t)})}},Shopify.OptionSelectors.prototype.fireOnChangeForFirstDropdown=function(t){this.selectors[0].element.onchange(t)},Shopify.OptionSelectors.prototype.selectVariantFromParamsOrDropdown=function(t){var e=this.selectVariantFromParams(t);e||this.selectVariantFromDropdown(t)},Shopify.OptionSelectors.prototype.replaceSelector=function(t){var e=document.getElementById(t),o=e.parentNode;Shopify.each(this.buildSelectors(),function(t){o.insertBefore(t,e)}),e.style.display="none",this.variantIdField=e},Shopify.OptionSelectors.prototype.selectVariantFromDropdown=function(t){var e=document.getElementById(this.domIdPrefix).querySelector("[selected]");if(e||(e=document.getElementById(this.domIdPrefix).querySelector('[selected="selected"]')),!e)return!1;var o=e.value;return this.selectVariant(o,t)},Shopify.OptionSelectors.prototype.selectVariantFromParams=function(t){var e=Shopify.urlParam("variant");return this.selectVariant(e,t)},Shopify.OptionSelectors.prototype.selectVariant=function(t,e){var o=this.product.getVariantById(t);if(null==o)return!1;for(var i=0;i<this.selectors.length;i++){var r=this.selectors[i].element,n=r.getAttribute("data-option"),a=o[n];null!=a&&this.optionExistInSelect(r,a)&&(r.value=a)}return"undefined"!=typeof jQuery?jQuery(this.selectors[0].element).trigger("change",e):this.selectors[0].element.onchange(e),!0},Shopify.OptionSelectors.prototype.optionExistInSelect=function(t,e){for(var o=0;o<t.options.length;o++)if(t.options[o].value==e)return!0},Shopify.OptionSelectors.prototype.insertSelectors=function(t,e){Shopify.isDefined(e)&&this.setMessageElement(e),this.domIdPrefix="product-"+this.product.id+"-variant-selector";var o=document.getElementById(t);Shopify.each(this.buildSelectors(),function(t){o.appendChild(t)})},Shopify.OptionSelectors.prototype.buildSelectors=function(){for(var t=0;t<this.product.optionNames().length;t++){var e=new Shopify.SingleOptionSelector(this,t,this.product.optionNames()[t],this.product.optionValues(t));e.element.disabled=!1,this.selectors.push(e)}var o=this.selectorDivClass,i=this.product.optionNames(),r=Shopify.map(this.selectors,function(t){var e=document.createElement("div");if(e.setAttribute("class",o),i.length>1){var r=document.createElement("label");r.htmlFor=t.element.id,r.innerHTML=t.name,e.appendChild(r)}return e.appendChild(t.element),e});return r},Shopify.OptionSelectors.prototype.selectedValues=function(){for(var t=[],e=0;e<this.selectors.length;e++){var o=this.selectors[e].element.value;t.push(o)}return t},Shopify.OptionSelectors.prototype.updateSelectors=function(t,e){var o=this.selectedValues(),i=this.product.getVariant(o);i?(this.variantIdField.disabled=!1,this.variantIdField.value=i.id):this.variantIdField.disabled=!0,this.onVariantSelected(i,this,e),null!=this.historyState&&this.historyState.onVariantChange(i,this,e)},Shopify.OptionSelectorsFromDOM=function(t,e){var o=e.optionNames||[],i=e.priceFieldExists||!0,r=e.delimiter||"/",n=this.createProductFromSelector(t,o,i,r);e.product=n,Shopify.OptionSelectorsFromDOM.baseConstructor.call(this,t,e)},Shopify.extend(Shopify.OptionSelectorsFromDOM,Shopify.OptionSelectors),Shopify.OptionSelectorsFromDOM.prototype.createProductFromSelector=function(t,e,o,i){if(!Shopify.isDefined(o))var o=!0;if(!Shopify.isDefined(i))var i="/";var r=document.getElementById(t),n=r.childNodes,a=(r.parentNode,e.length),s=[];Shopify.each(n,function(t,r){if(1==t.nodeType&&"option"==t.tagName.toLowerCase()){var n=t.innerHTML.split(new RegExp("\\s*\\"+i+"\\s*"));0==e.length&&(a=n.length-(o?1:0));var p=n.slice(0,a),l=o?n[a]:"",c=(t.getAttribute("value"),{available:t.disabled?!1:!0,id:parseFloat(t.value),price:l,option1:p[0],option2:p[1],option3:p[2]});s.push(c)}});var p={variants:s};if(0==e.length){p.options=[];for(var l=0;a>l;l++)p.options[l]="option "+(l+1)}else p.options=e;return p},Shopify.SingleOptionSelector=function(t,e,o,i){this.multiSelector=t,this.values=i,this.index=e,this.name=o,this.element=document.createElement("select");for(var r=0;r<i.length;r++){var n=document.createElement("option");n.value=i[r],n.innerHTML=i[r],this.element.appendChild(n)}return this.element.setAttribute("class",this.multiSelector.selectorClass),this.element.setAttribute("data-option","option"+(e+1)),this.element.id=t.domIdPrefix+"-option-"+e,this.element.onchange=function(o,i){i=i||{},t.updateSelectors(e,i)},!0},Shopify.Image={preload:function(t,e){for(var o=0;o<t.length;o++){var i=t[o];this.loadImage(this.getSizedImageUrl(i,e))}},loadImage:function(t){(new Image).src=t},switchImage:function(t,e,o){if(t&&e){var i=this.imageSize(e.src),r=this.getSizedImageUrl(t.src,i);o?o(r,t,e):e.src=r}},imageSize:function(t){var e=t.match(/_(1024x1024|2048x2048|pico|icon|thumb|small|compact|medium|large|grande)\./);return null!=e?e[1]:null},getSizedImageUrl:function(t,e){if(null==e)return t;if("master"==e)return this.removeProtocol(t);var o=t.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);if(null!=o){var i=t.split(o[0]),r=o[0];return this.removeProtocol(i[0]+"_"+e+r)}return null},removeProtocol:function(t){return t.replace(/http(s)?:/,"")}},Shopify.OptionSelectors.HistoryState=function(t){this.browserSupports()&&this.register(t)},Shopify.OptionSelectors.HistoryState.prototype.register=function(t){window.addEventListener("popstate",function(e){t.selectVariantFromParamsOrDropdown({popStateCall:!0})})},Shopify.OptionSelectors.HistoryState.prototype.onVariantChange=function(t,e,o){this.browserSupports()&&(!t||o.initialLoad||o.popStateCall||Shopify.setParam("variant",t.id))},Shopify.OptionSelectors.HistoryState.prototype.browserSupports=function(){return window.history&&window.history.replaceState};

/*!
  Zoom 1.7.15
  license: MIT
  http://www.jacklmoore.com/zoom
*/
(function($){var defaults={url:false,callback:false,target:false,duration:120,on:"mouseover",touch:true,onZoomIn:false,onZoomOut:false,magnify:1};$.zoom=function(target,source,img,magnify){var targetHeight,targetWidth,sourceHeight,sourceWidth,xRatio,yRatio,offset,$target=$(target),position=$target.css("position"),$source=$(source);$target.css("position",/(absolute|fixed)/.test(position)?position:"relative");$target.css("overflow","hidden");img.style.width=img.style.height="";$(img).addClass("zoomImg").css({position:"absolute",top:0,left:0,opacity:0,width:img.width*magnify,height:img.height*magnify,border:"none",maxWidth:"none",maxHeight:"none"}).appendTo(target);return{init:function(){targetWidth=$target.outerWidth();targetHeight=$target.outerHeight();if(source===$target[0]){sourceWidth=targetWidth;sourceHeight=targetHeight}else{sourceWidth=$source.outerWidth();sourceHeight=$source.outerHeight()}xRatio=(img.width-targetWidth)/sourceWidth;yRatio=(img.height-targetHeight)/sourceHeight;offset=$source.offset()},move:function(e){var left=e.pageX-offset.left,top=e.pageY-offset.top;top=Math.max(Math.min(top,sourceHeight),0);left=Math.max(Math.min(left,sourceWidth),0);img.style.left=left*-xRatio+"px";img.style.top=top*-yRatio+"px"}}};$.fn.zoom=function(options){return this.each(function(){var settings=$.extend({},defaults,options||{}),target=settings.target||this,source=this,$source=$(source),$target=$(target),img=document.createElement("img"),$img=$(img),mousemove="mousemove.zoom",clicked=false,touched=false,$urlElement;if(!settings.url){$urlElement=$source.find("img");if($urlElement[0]){settings.url=$urlElement.data("src")||$urlElement.attr("src")}if(!settings.url){return}}(function(){var position=$target.css("position");var overflow=$target.css("overflow");$source.one("zoom.destroy",function(){$source.off(".zoom");$target.css("position",position);$target.css("overflow",overflow);$img.remove()})})();img.onload=function(){var zoom=$.zoom(target,source,img,settings.magnify);function start(e){zoom.init();zoom.move(e);$img.stop().fadeTo($.support.opacity?settings.duration:0,1,$.isFunction(settings.onZoomIn)?settings.onZoomIn.call(img):false)}function stop(){$img.stop().fadeTo(settings.duration,0,$.isFunction(settings.onZoomOut)?settings.onZoomOut.call(img):false)}if(settings.on==="grab"){$source.on("mousedown.zoom",function(e){if(e.which===1){$(document).one("mouseup.zoom",function(){stop();$(document).off(mousemove,zoom.move)});start(e);$(document).on(mousemove,zoom.move);e.preventDefault()}})}else if(settings.on==="click"){$source.on("click.zoom",function(e){if(clicked){return}else{clicked=true;start(e);$(document).on(mousemove,zoom.move);$(document).one("click.zoom",function(){stop();clicked=false;$(document).off(mousemove,zoom.move)});return false}})}else if(settings.on==="toggle"){$source.on("click.zoom",function(e){if(clicked){stop()}else{start(e)}clicked=!clicked})}else if(settings.on==="mouseover"){zoom.init();$source.on("mouseenter.zoom",start).on("mouseleave.zoom",stop).on(mousemove,zoom.move)}if(settings.touch){$source.on("touchstart.zoom",function(e){e.preventDefault();if(touched){touched=false;stop()}else{touched=true;start(e.originalEvent.touches[0]||e.originalEvent.changedTouches[0])}}).on("touchmove.zoom",function(e){e.preventDefault();zoom.move(e.originalEvent.touches[0]||e.originalEvent.changedTouches[0])}).on("touchend.zoom",function(e){e.preventDefault();if(touched){touched=false;stop()}})}if($.isFunction(settings.callback)){settings.callback.call(img)}};img.src=settings.url})};$.fn.zoom.defaults=defaults})(window.jQuery);

/*
 *  Remodal - v1.1.0
 *  Responsive, lightweight, fast, synchronized with CSS animations, fully customizable modal window plugin with declarative configuration and hash tracking.
 *  http://vodkabears.github.io/remodal/
 *
 *  Made by Ilya Makarov
 *  Under MIT License
 */

!function(a,b){"function"==typeof define&&define.amd?define(["jquery"],function(c){return b(a,c)}):"object"==typeof exports?b(a,require("jquery")):b(a,a.jQuery||a.Zepto)}(this,function(a,b){"use strict";function c(a){if(w&&"none"===a.css("animation-name")&&"none"===a.css("-webkit-animation-name")&&"none"===a.css("-moz-animation-name")&&"none"===a.css("-o-animation-name")&&"none"===a.css("-ms-animation-name"))return 0;var b,c,d,e,f=a.css("animation-duration")||a.css("-webkit-animation-duration")||a.css("-moz-animation-duration")||a.css("-o-animation-duration")||a.css("-ms-animation-duration")||"0s",g=a.css("animation-delay")||a.css("-webkit-animation-delay")||a.css("-moz-animation-delay")||a.css("-o-animation-delay")||a.css("-ms-animation-delay")||"0s",h=a.css("animation-iteration-count")||a.css("-webkit-animation-iteration-count")||a.css("-moz-animation-iteration-count")||a.css("-o-animation-iteration-count")||a.css("-ms-animation-iteration-count")||"1";for(f=f.split(", "),g=g.split(", "),h=h.split(", "),e=0,c=f.length,b=Number.NEGATIVE_INFINITY;e<c;e++)d=parseFloat(f[e])*parseInt(h[e],10)+parseFloat(g[e]),d>b&&(b=d);return b}function d(){if(b(document.body).height()<=b(window).height())return 0;var a,c,d=document.createElement("div"),e=document.createElement("div");return d.style.visibility="hidden",d.style.width="100px",document.body.appendChild(d),a=d.offsetWidth,d.style.overflow="scroll",e.style.width="100%",d.appendChild(e),c=e.offsetWidth,d.parentNode.removeChild(d),a-c}function e(){if(!x){var a,c,e=b("html"),f=k("is-locked");e.hasClass(f)||(c=b(document.body),a=parseInt(c.css("padding-right"),10)+d(),c.css("padding-right",a+"px"),e.addClass(f))}}function f(){if(!x){var a,c,e=b("html"),f=k("is-locked");e.hasClass(f)&&(c=b(document.body),a=parseInt(c.css("padding-right"),10)-d(),c.css("padding-right",a+"px"),e.removeClass(f))}}function g(a,b,c,d){var e=k("is",b),f=[k("is",u.CLOSING),k("is",u.OPENING),k("is",u.CLOSED),k("is",u.OPENED)].join(" ");a.$bg.removeClass(f).addClass(e),a.$overlay.removeClass(f).addClass(e),a.$wrapper.removeClass(f).addClass(e),a.$modal.removeClass(f).addClass(e),a.state=b,!c&&a.$modal.trigger({type:b,reason:d},[{reason:d}])}function h(a,d,e){var f=0,g=function(a){a.target===this&&f++},h=function(a){a.target===this&&0===--f&&(b.each(["$bg","$overlay","$wrapper","$modal"],function(a,b){e[b].off(r+" "+s)}),d())};b.each(["$bg","$overlay","$wrapper","$modal"],function(a,b){e[b].on(r,g).on(s,h)}),a(),0===c(e.$bg)&&0===c(e.$overlay)&&0===c(e.$wrapper)&&0===c(e.$modal)&&(b.each(["$bg","$overlay","$wrapper","$modal"],function(a,b){e[b].off(r+" "+s)}),d())}function i(a){a.state!==u.CLOSED&&(b.each(["$bg","$overlay","$wrapper","$modal"],function(b,c){a[c].off(r+" "+s)}),a.$bg.removeClass(a.settings.modifier),a.$overlay.removeClass(a.settings.modifier).hide(),a.$wrapper.hide(),f(),g(a,u.CLOSED,!0))}function j(a){var b,c,d,e,f={};for(a=a.replace(/\s*:\s*/g,":").replace(/\s*,\s*/g,","),b=a.split(","),e=0,c=b.length;e<c;e++)b[e]=b[e].split(":"),d=b[e][1],("string"==typeof d||d instanceof String)&&(d="true"===d||"false"!==d&&d),("string"==typeof d||d instanceof String)&&(d=isNaN(d)?d:+d),f[b[e][0]]=d;return f}function k(){for(var a=q,b=0;b<arguments.length;++b)a+="-"+arguments[b];return a}function l(){var a,c,d=location.hash.replace("#","");if(d){try{c=b('[data-remodal-id="'+d+'"]')}catch(e){}c&&c.length&&(a=b[p].lookup[c.data(p)],a&&a.settings.hashTracking&&a.open())}else n&&n.state===u.OPENED&&n.settings.hashTracking&&n.close()}function m(a,c){var d=b(document.body),e=d,f=this;f.settings=b.extend({},t,c),f.index=b[p].lookup.push(f)-1,f.state=u.CLOSED,f.$overlay=b("."+k("overlay")),null!==f.settings.appendTo&&f.settings.appendTo.length&&(e=b(f.settings.appendTo)),f.$overlay.length||(f.$overlay=b("<div>").addClass(k("overlay")+" "+k("is",u.CLOSED)).hide(),e.append(f.$overlay)),f.$bg=b("."+k("bg")).addClass(k("is",u.CLOSED)),f.$modal=a.addClass(q+" "+k("is-initialized")+" "+f.settings.modifier+" "+k("is",u.CLOSED)).attr("tabindex","-1"),f.$wrapper=b("<div>").addClass(k("wrapper")+" "+f.settings.modifier+" "+k("is",u.CLOSED)).hide().append(f.$modal),e.append(f.$wrapper),f.$wrapper.on("click."+q,'[data-remodal-action="close"]',function(a){a.preventDefault(),f.close()}),f.$wrapper.on("click."+q,'[data-remodal-action="cancel"]',function(a){a.preventDefault(),f.$modal.trigger(v.CANCELLATION),f.settings.closeOnCancel&&f.close(v.CANCELLATION)}),f.$wrapper.on("click."+q,'[data-remodal-action="confirm"]',function(a){a.preventDefault(),f.$modal.trigger(v.CONFIRMATION),f.settings.closeOnConfirm&&f.close(v.CONFIRMATION)}),f.$wrapper.on("click."+q,function(a){var c=b(a.target);c.hasClass(k("wrapper"))&&f.settings.closeOnOutsideClick&&f.close()})}var n,o,p="remodal",q=a.REMODAL_GLOBALS&&a.REMODAL_GLOBALS.NAMESPACE||p,r=b.map(["animationstart","webkitAnimationStart","MSAnimationStart","oAnimationStart"],function(a){return a+"."+q}).join(" "),s=b.map(["animationend","webkitAnimationEnd","MSAnimationEnd","oAnimationEnd"],function(a){return a+"."+q}).join(" "),t=b.extend({hashTracking:!0,closeOnConfirm:!0,closeOnCancel:!0,closeOnEscape:!0,closeOnOutsideClick:!0,modifier:"",appendTo:null},a.REMODAL_GLOBALS&&a.REMODAL_GLOBALS.DEFAULTS),u={CLOSING:"closing",CLOSED:"closed",OPENING:"opening",OPENED:"opened"},v={CONFIRMATION:"confirmation",CANCELLATION:"cancellation"},w=function(){var a=document.createElement("div").style;return void 0!==a.animationName||void 0!==a.WebkitAnimationName||void 0!==a.MozAnimationName||void 0!==a.msAnimationName||void 0!==a.OAnimationName}(),x=/iPad|iPhone|iPod/.test(navigator.platform);m.prototype.open=function(){var a,c=this;c.state!==u.OPENING&&c.state!==u.CLOSING&&(a=c.$modal.attr("data-remodal-id"),a&&c.settings.hashTracking&&(o=b(window).scrollTop(),location.hash=a),n&&n!==c&&i(n),n=c,e(),c.$bg.addClass(c.settings.modifier),c.$overlay.addClass(c.settings.modifier).show(),c.$wrapper.show().scrollTop(0),c.$modal.focus(),h(function(){g(c,u.OPENING)},function(){g(c,u.OPENED)},c))},m.prototype.close=function(a){var c=this;c.state!==u.OPENING&&c.state!==u.CLOSING&&(c.settings.hashTracking&&c.$modal.attr("data-remodal-id")===location.hash.substr(1)&&(location.hash="",b(window).scrollTop(o)),h(function(){g(c,u.CLOSING,!1,a)},function(){c.$bg.removeClass(c.settings.modifier),c.$overlay.removeClass(c.settings.modifier).hide(),c.$wrapper.hide(),f(),g(c,u.CLOSED,!1,a)},c))},m.prototype.getState=function(){return this.state},m.prototype.destroy=function(){var a,c=b[p].lookup;i(this),this.$wrapper.remove(),delete c[this.index],a=b.grep(c,function(a){return!!a}).length,0===a&&(this.$overlay.remove(),this.$bg.removeClass(k("is",u.CLOSING)+" "+k("is",u.OPENING)+" "+k("is",u.CLOSED)+" "+k("is",u.OPENED)))},b[p]={lookup:[]},b.fn[p]=function(a){var c,d;return this.each(function(e,f){d=b(f),null==d.data(p)?(c=new m(d,a),d.data(p,c.index),c.settings.hashTracking&&d.attr("data-remodal-id")===location.hash.substr(1)&&c.open()):c=b[p].lookup[d.data(p)]}),c},b(document).ready(function(){b('body').on("click","[data-remodal-target]",function(a){a.preventDefault();var c=a.currentTarget,d=c.getAttribute("data-remodal-target"),e=b('[data-remodal-id="'+d+'"]');b[p].lookup[e.data(p)].open()}),b('body').find("."+q).each(function(a,c){var d=b(c),e=d.data("remodal-options");e?("string"==typeof e||e instanceof String)&&(e=j(e)):e={},d[p](e)}),b('body').on("keydown."+q,function(a){n&&n.settings.closeOnEscape&&n.state===u.OPENED&&27===a.keyCode&&n.close()}),b(window).on("hashchange."+q,l)})});

/*
 * Cookie plugin
 *
 * Copyright (c) 2006 Klaus Hartl (stilbuero.de)
 * Dual licensed under the MIT and GPL licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl.html
 *
 */

jQuery.cookie=function(b,j,m){if(typeof j!="undefined"){m=m||{};if(j===null){j="";m.expires=-1}var e="";if(m.expires&&(typeof m.expires=="number"||m.expires.toUTCString)){var f;if(typeof m.expires=="number"){f=new Date();f.setTime(f.getTime()+(m.expires*24*60*60*1000))}else{f=m.expires}e="; expires="+f.toUTCString()}var l=m.path?"; path="+(m.path):"";var g=m.domain?"; domain="+(m.domain):"";var a=m.secure?"; secure":"";document.cookie=[b,"=",encodeURIComponent(j),e,l,g,a].join("")}else{var d=null;if(document.cookie&&document.cookie!=""){var k=document.cookie.split(";");for(var h=0;h<k.length;h++){var c=jQuery.trim(k[h]);if(c.substring(0,b.length+1)==(b+"=")){d=decodeURIComponent(c.substring(b.length+1));break}}}return d}};

/*============================================================================
 Cookie function for hide free shipping bar
==============================================================================*/
jQuery.cookieNew=function(b,j,m){if(typeof j!="undefined"){m=m||{};if(j===null){j="";m.expires=-1}var e="";if(m.expires&&(typeof m.expires=="number"||m.expires.toUTCString)){var f;if(typeof m.expires=="number"){f=new Date();f.setTime(f.getTime()+(m.expires*24*60*60*1000))}else{f=m.expires}e="; expires="+f.toUTCString()}/*var l=m.path?"; path="+(m.path):"path="+"/";*/var g=m.domain?"; domain="+(m.domain):"";var a=m.secure?"; secure":"";document.cookie=b+"="+encodeURIComponent(j)+";path=/";}else{var d=null;if(document.cookie&&document.cookie!=""){var k=document.cookie.split(";");for(var h=0;h<k.length;h++){var c=jQuery.trim(k[h]);if(c.substring(0,b.length+1)==(b+"=")){d=decodeURIComponent(c.substring(b.length+1));break}}}return d}};

/*!
Waypoints - 4.0.0
Copyright © 2011-2015 Caleb Troughton
Licensed under the MIT license.
https://github.com/imakewebthings/waypoints/blob/master/licenses.txt
*/
!function(){"use strict";function t(o){if(!o)throw new Error("No options passed to Waypoint constructor");if(!o.element)throw new Error("No element option passed to Waypoint constructor");if(!o.handler)throw new Error("No handler option passed to Waypoint constructor");this.key="waypoint-"+e,this.options=t.Adapter.extend({},t.defaults,o),this.element=this.options.element,this.adapter=new t.Adapter(this.element),this.callback=o.handler,this.axis=this.options.horizontal?"horizontal":"vertical",this.enabled=this.options.enabled,this.triggerPoint=null,this.group=t.Group.findOrCreate({name:this.options.group,axis:this.axis}),this.context=t.Context.findOrCreateByElement(this.options.context),t.offsetAliases[this.options.offset]&&(this.options.offset=t.offsetAliases[this.options.offset]),this.group.add(this),this.context.add(this),i[this.key]=this,e+=1}var e=0,i={};t.prototype.queueTrigger=function(t){this.group.queueTrigger(this,t)},t.prototype.trigger=function(t){this.enabled&&this.callback&&this.callback.apply(this,t)},t.prototype.destroy=function(){this.context.remove(this),this.group.remove(this),delete i[this.key]},t.prototype.disable=function(){return this.enabled=!1,this},t.prototype.enable=function(){return this.context.refresh(),this.enabled=!0,this},t.prototype.next=function(){return this.group.next(this)},t.prototype.previous=function(){return this.group.previous(this)},t.invokeAll=function(t){var e=[];for(var o in i)e.push(i[o]);for(var n=0,r=e.length;r>n;n++)e[n][t]()},t.destroyAll=function(){t.invokeAll("destroy")},t.disableAll=function(){t.invokeAll("disable")},t.enableAll=function(){t.invokeAll("enable")},t.refreshAll=function(){t.Context.refreshAll()},t.viewportHeight=function(){return window.innerHeight||document.documentElement.clientHeight},t.viewportWidth=function(){return document.documentElement.clientWidth},t.adapters=[],t.defaults={context:window,continuous:!0,enabled:!0,group:"default",horizontal:!1,offset:0},t.offsetAliases={"bottom-in-view":function(){return this.context.innerHeight()-this.adapter.outerHeight()},"right-in-view":function(){return this.context.innerWidth()-this.adapter.outerWidth()}},window.Waypoint=t}(),function(){"use strict";function t(t){window.setTimeout(t,1e3/60)}function e(t){this.element=t,this.Adapter=n.Adapter,this.adapter=new this.Adapter(t),this.key="waypoint-context-"+i,this.didScroll=!1,this.didResize=!1,this.oldScroll={x:this.adapter.scrollLeft(),y:this.adapter.scrollTop()},this.waypoints={vertical:{},horizontal:{}},t.waypointContextKey=this.key,o[t.waypointContextKey]=this,i+=1,this.createThrottledScrollHandler(),this.createThrottledResizeHandler()}var i=0,o={},n=window.Waypoint,r=window.onload;e.prototype.add=function(t){var e=t.options.horizontal?"horizontal":"vertical";this.waypoints[e][t.key]=t,this.refresh()},e.prototype.checkEmpty=function(){var t=this.Adapter.isEmptyObject(this.waypoints.horizontal),e=this.Adapter.isEmptyObject(this.waypoints.vertical);t&&e&&(this.adapter.off(".waypoints"),delete o[this.key])},e.prototype.createThrottledResizeHandler=function(){function t(){e.handleResize(),e.didResize=!1}var e=this;this.adapter.on("resize.waypoints",function(){e.didResize||(e.didResize=!0,n.requestAnimationFrame(t))})},e.prototype.createThrottledScrollHandler=function(){function t(){e.handleScroll(),e.didScroll=!1}var e=this;this.adapter.on("scroll.waypoints",function(){(!e.didScroll||n.isTouch)&&(e.didScroll=!0,n.requestAnimationFrame(t))})},e.prototype.handleResize=function(){n.Context.refreshAll()},e.prototype.handleScroll=function(){var t={},e={horizontal:{newScroll:this.adapter.scrollLeft(),oldScroll:this.oldScroll.x,forward:"right",backward:"left"},vertical:{newScroll:this.adapter.scrollTop(),oldScroll:this.oldScroll.y,forward:"down",backward:"up"}};for(var i in e){var o=e[i],n=o.newScroll>o.oldScroll,r=n?o.forward:o.backward;for(var s in this.waypoints[i]){var a=this.waypoints[i][s],l=o.oldScroll<a.triggerPoint,h=o.newScroll>=a.triggerPoint,p=l&&h,u=!l&&!h;(p||u)&&(a.queueTrigger(r),t[a.group.id]=a.group)}}for(var c in t)t[c].flushTriggers();this.oldScroll={x:e.horizontal.newScroll,y:e.vertical.newScroll}},e.prototype.innerHeight=function(){return this.element==this.element.window?n.viewportHeight():this.adapter.innerHeight()},e.prototype.remove=function(t){delete this.waypoints[t.axis][t.key],this.checkEmpty()},e.prototype.innerWidth=function(){return this.element==this.element.window?n.viewportWidth():this.adapter.innerWidth()},e.prototype.destroy=function(){var t=[];for(var e in this.waypoints)for(var i in this.waypoints[e])t.push(this.waypoints[e][i]);for(var o=0,n=t.length;n>o;o++)t[o].destroy()},e.prototype.refresh=function(){var t,e=this.element==this.element.window,i=e?void 0:this.adapter.offset(),o={};this.handleScroll(),t={horizontal:{contextOffset:e?0:i.left,contextScroll:e?0:this.oldScroll.x,contextDimension:this.innerWidth(),oldScroll:this.oldScroll.x,forward:"right",backward:"left",offsetProp:"left"},vertical:{contextOffset:e?0:i.top,contextScroll:e?0:this.oldScroll.y,contextDimension:this.innerHeight(),oldScroll:this.oldScroll.y,forward:"down",backward:"up",offsetProp:"top"}};for(var r in t){var s=t[r];for(var a in this.waypoints[r]){var l,h,p,u,c,d=this.waypoints[r][a],f=d.options.offset,w=d.triggerPoint,y=0,g=null==w;d.element!==d.element.window&&(y=d.adapter.offset()[s.offsetProp]),"function"==typeof f?f=f.apply(d):"string"==typeof f&&(f=parseFloat(f),d.options.offset.indexOf("%")>-1&&(f=Math.ceil(s.contextDimension*f/100))),l=s.contextScroll-s.contextOffset,d.triggerPoint=y+l-f,h=w<s.oldScroll,p=d.triggerPoint>=s.oldScroll,u=h&&p,c=!h&&!p,!g&&u?(d.queueTrigger(s.backward),o[d.group.id]=d.group):!g&&c?(d.queueTrigger(s.forward),o[d.group.id]=d.group):g&&s.oldScroll>=d.triggerPoint&&(d.queueTrigger(s.forward),o[d.group.id]=d.group)}}return n.requestAnimationFrame(function(){for(var t in o)o[t].flushTriggers()}),this},e.findOrCreateByElement=function(t){return e.findByElement(t)||new e(t)},e.refreshAll=function(){for(var t in o)o[t].refresh()},e.findByElement=function(t){return o[t.waypointContextKey]},window.onload=function(){r&&r(),e.refreshAll()},n.requestAnimationFrame=function(e){var i=window.requestAnimationFrame||window.mozRequestAnimationFrame||window.webkitRequestAnimationFrame||t;i.call(window,e)},n.Context=e}(),function(){"use strict";function t(t,e){return t.triggerPoint-e.triggerPoint}function e(t,e){return e.triggerPoint-t.triggerPoint}function i(t){this.name=t.name,this.axis=t.axis,this.id=this.name+"-"+this.axis,this.waypoints=[],this.clearTriggerQueues(),o[this.axis][this.name]=this}var o={vertical:{},horizontal:{}},n=window.Waypoint;i.prototype.add=function(t){this.waypoints.push(t)},i.prototype.clearTriggerQueues=function(){this.triggerQueues={up:[],down:[],left:[],right:[]}},i.prototype.flushTriggers=function(){for(var i in this.triggerQueues){var o=this.triggerQueues[i],n="up"===i||"left"===i;o.sort(n?e:t);for(var r=0,s=o.length;s>r;r+=1){var a=o[r];(a.options.continuous||r===o.length-1)&&a.trigger([i])}}this.clearTriggerQueues()},i.prototype.next=function(e){this.waypoints.sort(t);var i=n.Adapter.inArray(e,this.waypoints),o=i===this.waypoints.length-1;return o?null:this.waypoints[i+1]},i.prototype.previous=function(e){this.waypoints.sort(t);var i=n.Adapter.inArray(e,this.waypoints);return i?this.waypoints[i-1]:null},i.prototype.queueTrigger=function(t,e){this.triggerQueues[e].push(t)},i.prototype.remove=function(t){var e=n.Adapter.inArray(t,this.waypoints);e>-1&&this.waypoints.splice(e,1)},i.prototype.first=function(){return this.waypoints[0]},i.prototype.last=function(){return this.waypoints[this.waypoints.length-1]},i.findOrCreate=function(t){return o[t.axis][t.name]||new i(t)},n.Group=i}(),function(){"use strict";function t(t){this.$element=e(t)}var e=window.jQuery,i=window.Waypoint;e.each(["innerHeight","innerWidth","off","offset","on","outerHeight","outerWidth","scrollLeft","scrollTop"],function(e,i){t.prototype[i]=function(){var t=Array.prototype.slice.call(arguments);return this.$element[i].apply(this.$element,t)}}),e.each(["extend","inArray","isEmptyObject"],function(i,o){t[o]=e[o]}),i.adapters.push({name:"jquery",Adapter:t}),i.Adapter=t}(),function(){"use strict";function t(t){return function(){var i=[],o=arguments[0];return t.isFunction(arguments[0])&&(o=t.extend({},arguments[1]),o.handler=arguments[0]),this.each(function(){var n=t.extend({},o,{element:this});"string"==typeof n.context&&(n.context=t(this).closest(n.context)[0]),i.push(new e(n))}),i}}var e=window.Waypoint;window.jQuery&&(window.jQuery.fn.waypoint=t(window.jQuery)),window.Zepto&&(window.Zepto.fn.waypoint=t(window.Zepto))}();

/*!
Waypoints Infinite Scroll Shortcut - 4.0.0
Copyright © 2011-2015 Caleb Troughton
Licensed under the MIT license.
https://github.com/imakewebthings/waypoints/blob/master/licenses.txt
*/
!function(){"use strict";function t(n){this.options=i.extend({},t.defaults,n),this.container=this.options.element,"auto"!==this.options.container&&(this.container=this.options.container),this.$container=i(this.container),this.$more=i(this.options.more),this.$more.length&&(this.setupHandler(),this.waypoint=new o(this.options))}var i=window.jQuery,o=window.Waypoint;t.prototype.setupHandler=function(){this.options.handler=i.proxy(function(){this.options.onBeforePageLoad(),this.destroy(),this.$container.addClass(this.options.loadingClass),i.get(i(this.options.more).attr("href"),i.proxy(function(t){var n=i(i.parseHTML(t)),e=n.find(this.options.more),s=n.find(this.options.items);s.length||(s=n.filter(this.options.items)),this.$container.append(s),this.$container.removeClass(this.options.loadingClass),e.length||(e=n.filter(this.options.more)),e.length?(this.$more.replaceWith(e),this.$more=e,this.waypoint=new o(this.options)):this.$more.remove(),this.options.onAfterPageLoad(s)},this))},this)},t.prototype.destroy=function(){this.waypoint&&this.waypoint.destroy()},t.defaults={container:"auto",items:".infinite-item",more:".infinite-more-link",offset:"bottom-in-view",loadingClass:"infinite-loading",onBeforePageLoad:i.noop,onAfterPageLoad:i.noop},o.Infinite=t}();

// mediaWrapper.js: Simple responsive iframes
// MIT license http://www.opensource.org/licenses/mit-license.php/
// @author Matthew A. K. Smith http://www.akselkreis.com

!function(t){t.fn.mediaWrapper=function(i){var e=t.extend({intrinsic:!0,baseWidth:16,baseHeight:9},i);return this.each(function(){var i="";i=1==e.intrinsic&&""!==t(this).attr("width")&&""!==t(this).attr("height")?t(this).attr("height")/t(this).attr("width")*100:e.baseHeight/e.baseWidth*100,t(this).wrap('<div class="mediaWrapper" style="position: relative; width: 100%; height: 0; padding: '+i+'% 0 0 0; " />').css({position:"absolute",width:"100%",height:"100%",top:"0",left:"0"})})}}(jQuery);

/*
 * Pointer Events Polyfill: Adds support for the style attribute "pointer-events: none" to browsers without this feature (namely, IE).
 * (c) 2013, Kent Mewhort, licensed under BSD. See LICENSE.txt for details.
 */

function PointerEventsPolyfill(t){if(this.options={selector:"*",mouseEvents:["click","dblclick","mousedown","mouseup"],usePolyfillIf:function(){if("Microsoft Internet Explorer"==navigator.appName){var t=navigator.userAgent;if(null!=t.match(/MSIE ([0-9]{1,}[\.0-9]{0,})/)){var e=parseFloat(RegExp.$1);if(11>e)return!0}}return!1}},t){var e=this;$.each(t,function(t,n){e.options[t]=n})}this.options.usePolyfillIf()&&this.register_mouse_events()}PointerEventsPolyfill.initialize=function(t){return null==PointerEventsPolyfill.singleton&&(PointerEventsPolyfill.singleton=new PointerEventsPolyfill(t)),PointerEventsPolyfill.singleton},PointerEventsPolyfill.prototype.register_mouse_events=function(){$(document).on(this.options.mouseEvents.join(" "),this.options.selector,function(t){if("none"==$(this).css("pointer-events")){var e=$(this).css("display");$(this).css("display","none");var n=document.elementFromPoint(t.clientX,t.clientY);return e?$(this).css("display",e):$(this).css("display",""),t.target=n,$(n).trigger(t),!1}return!0})};

/*! modernizr 3.3.1 (Custom Build) | MIT *
 * https://modernizr.com/download/?-touchevents-setclasses !*/
!function(e,n,t){function o(e,n){return typeof e===n}function s(){var e,n,t,s,a,i,r;for(var l in c)if(c.hasOwnProperty(l)){if(e=[],n=c[l],n.name&&(e.push(n.name.toLowerCase()),n.options&&n.options.aliases&&n.options.aliases.length))for(t=0;t<n.options.aliases.length;t++)e.push(n.options.aliases[t].toLowerCase());for(s=o(n.fn,"function")?n.fn():n.fn,a=0;a<e.length;a++)i=e[a],r=i.split("."),1===r.length?Modernizr[r[0]]=s:(!Modernizr[r[0]]||Modernizr[r[0]]instanceof Boolean||(Modernizr[r[0]]=new Boolean(Modernizr[r[0]])),Modernizr[r[0]][r[1]]=s),f.push((s?"":"no-")+r.join("-"))}}function a(e){var n=u.className,t=Modernizr._config.classPrefix||"";if(p&&(n=n.baseVal),Modernizr._config.enableJSClass){var o=new RegExp("(^|\\s)"+t+"no-js(\\s|$)");n=n.replace(o,"$1"+t+"js$2")}Modernizr._config.enableClasses&&(n+=" "+t+e.join(" "+t),p?u.className.baseVal=n:u.className=n)}function i(){return"function"!=typeof n.createElement?n.createElement(arguments[0]):p?n.createElementNS.call(n,"http://www.w3.org/2000/svg",arguments[0]):n.createElement.apply(n,arguments)}function r(){var e=n.body;return e||(e=i(p?"svg":"body"),e.fake=!0),e}function l(e,t,o,s){var a,l,f,c,d="modernizr",p=i("div"),h=r();if(parseInt(o,10))for(;o--;)f=i("div"),f.id=s?s[o]:d+(o+1),p.appendChild(f);return a=i("style"),a.type="text/css",a.id="s"+d,(h.fake?h:p).appendChild(a),h.appendChild(p),a.styleSheet?a.styleSheet.cssText=e:a.appendChild(n.createTextNode(e)),p.id=d,h.fake&&(h.style.background="",h.style.overflow="hidden",c=u.style.overflow,u.style.overflow="hidden",u.appendChild(h)),l=t(p,e),h.fake?(h.parentNode.removeChild(h),u.style.overflow=c,u.offsetHeight):p.parentNode.removeChild(p),!!l}var f=[],c=[],d={_version:"3.3.1",_config:{classPrefix:"",enableClasses:!0,enableJSClass:!0,usePrefixes:!0},_q:[],on:function(e,n){var t=this;setTimeout(function(){n(t[e])},0)},addTest:function(e,n,t){c.push({name:e,fn:n,options:t})},addAsyncTest:function(e){c.push({name:null,fn:e})}},Modernizr=function(){};Modernizr.prototype=d,Modernizr=new Modernizr;var u=n.documentElement,p="svg"===u.nodeName.toLowerCase(),h=d._config.usePrefixes?" -webkit- -moz- -o- -ms- ".split(" "):["",""];d._prefixes=h;var m=d.testStyles=l;Modernizr.addTest("touchevents",function(){var t;if("ontouchstart"in e||e.DocumentTouch&&n instanceof DocumentTouch)t=!0;else{var o=["@media (",h.join("touch-enabled),("),"heartz",")","{#modernizr{top:9px;position:absolute}}"].join("");m(o,function(e){t=9===e.offsetTop})}return t}),s(),a(f),delete d.addTest,delete d.addAsyncTest;for(var v=0;v<Modernizr._q.length;v++)Modernizr._q[v]();e.Modernizr=Modernizr}(window,document);

/*!
 * Headhesive.js v1.2.3 - An on-demand sticky header
 * Author: Copyright (c) Mark Goodyear <@markgdyr> <http://markgoodyear.com>
 * Url: http://markgoodyear.com/labs/headhesive
 * License: MIT
 */
!function(t,e){"function"==typeof define&&define.amd?define([],function(){return e()}):"object"==typeof exports?module.exports=e():t.Headhesive=e()}(this,function(){"use strict";var t=function(e,s){for(var o in s)s.hasOwnProperty(o)&&(e[o]="object"==typeof s[o]?t(e[o],s[o]):s[o]);return e},e=function(t,e){var s,o,i,n=Date.now||function(){return(new Date).getTime()},l=null,c=0,r=function(){c=n(),l=null,i=t.apply(s,o),s=o=null};return function(){var f=n(),h=e-(f-c);return s=this,o=arguments,0>=h?(clearTimeout(l),l=null,c=f,i=t.apply(s,o),s=o=null):l||(l=setTimeout(r,h)),i}},s=function(){return void 0!==window.pageYOffset?window.pageYOffset:(document.documentElement||document.body.parentNode||document.body).scrollTop},o=function(t,e){for(var s=0,o=t.offsetHeight;t;)s+=t.offsetTop,t=t.offsetParent;return"bottom"===e&&(s+=o),s},i=function(e,s){"querySelector"in document&&"addEventListener"in window&&(this.visible=!1,this.options={offset:300,offsetSide:"top",classes:{clone:"headhesive",stick:"headhesive--stick",unstick:"headhesive--unstick"},throttle:250,onInit:function(){},onStick:function(){},onUnstick:function(){},onDestroy:function(){}},this.elem="string"==typeof e?document.querySelector(e):e,this.options=t(this.options,s),this.init())};return i.prototype={constructor:i,init:function(){if(this.clonedElem=this.elem.cloneNode(!0),this.clonedElem.className+=" "+this.options.classes.clone,document.body.insertBefore(this.clonedElem,document.body.firstChild),"number"==typeof this.options.offset)this.scrollOffset=this.options.offset;else{if("string"!=typeof this.options.offset)throw new Error("Invalid offset: "+this.options.offset);this._setScrollOffset()}this._throttleUpdate=e(this.update.bind(this),this.options.throttle),this._throttleScrollOffset=e(this._setScrollOffset.bind(this),this.options.throttle),window.addEventListener("scroll",this._throttleUpdate,!1),window.addEventListener("resize",this._throttleScrollOffset,!1),this.options.onInit.call(this)},_setScrollOffset:function(){"string"==typeof this.options.offset&&(this.scrollOffset=o(document.querySelector(this.options.offset),this.options.offsetSide))},destroy:function(){document.body.removeChild(this.clonedElem),window.removeEventListener("scroll",this._throttleUpdate),window.removeEventListener("resize",this._throttleScrollOffset),this.options.onDestroy.call(this)},stick:function(){this.visible||(this.clonedElem.className=this.clonedElem.className.replace(new RegExp("(^|\\s)*"+this.options.classes.unstick+"(\\s|$)*","g"),""),this.clonedElem.className+=" "+this.options.classes.stick,this.visible=!0,this.options.onStick.call(this))},unstick:function(){this.visible&&(this.clonedElem.className=this.clonedElem.className.replace(new RegExp("(^|\\s)*"+this.options.classes.stick+"(\\s|$)*","g"),""),this.clonedElem.className+=" "+this.options.classes.unstick,this.visible=!1,this.options.onUnstick.call(this))},update:function(){s()>this.scrollOffset?this.stick():this.unstick()}},i});

  /*! js-url - v2.5.0 - 2017-04-22 */
  !function(){var a=function(){function a(){}function b(a){return decodeURIComponent(a.replace(/\+/g," "))}function c(a,b){var c=a.charAt(0),d=b.split(c);return c===a?d:(a=parseInt(a.substring(1),10),d[a<0?d.length+a:a-1])}function d(a,c){for(var d=a.charAt(0),e=c.split("&"),f=[],g={},h=[],i=a.substring(1),j=0,k=e.length;j<k;j++)if(f=e[j].match(/(.*?)=(.*)/),f||(f=[e[j],e[j],""]),""!==f[1].replace(/\s/g,"")){if(f[2]=b(f[2]||""),i===f[1])return f[2];h=f[1].match(/(.*)\[([0-9]+)\]/),h?(g[h[1]]=g[h[1]]||[],g[h[1]][h[2]]=f[2]):g[f[1]]=f[2]}return d===a?g:g[i]}return function(b,e){var f,g={};if("tld?"===b)return a();if(e=e||window.location.toString(),!b)return e;if(b=b.toString(),f=e.match(/^mailto:([^\/].+)/))g.protocol="mailto",g.email=f[1];else{if((f=e.match(/(.*?)\/#\!(.*)/))&&(e=f[1]+f[2]),(f=e.match(/(.*?)#(.*)/))&&(g.hash=f[2],e=f[1]),g.hash&&b.match(/^#/))return d(b,g.hash);if((f=e.match(/(.*?)\?(.*)/))&&(g.query=f[2],e=f[1]),g.query&&b.match(/^\?/))return d(b,g.query);if((f=e.match(/(.*?)\:?\/\/(.*)/))&&(g.protocol=f[1].toLowerCase(),e=f[2]),(f=e.match(/(.*?)(\/.*)/))&&(g.path=f[2],e=f[1]),g.path=(g.path||"").replace(/^([^\/])/,"/$1"),b.match(/^[\-0-9]+$/)&&(b=b.replace(/^([^\/])/,"/$1")),b.match(/^\//))return c(b,g.path.substring(1));if(f=c("/-1",g.path.substring(1)),f&&(f=f.match(/(.*?)\.(.*)/))&&(g.file=f[0],g.filename=f[1],g.fileext=f[2]),(f=e.match(/(.*)\:([0-9]+)$/))&&(g.port=f[2],e=f[1]),(f=e.match(/(.*?)@(.*)/))&&(g.auth=f[1],e=f[2]),g.auth&&(f=g.auth.match(/(.*)\:(.*)/),g.user=f?f[1]:g.auth,g.pass=f?f[2]:void 0),g.hostname=e.toLowerCase(),"."===b.charAt(0))return c(b,g.hostname);a()&&(f=g.hostname.match(a()),f&&(g.tld=f[3],g.domain=f[2]?f[2]+"."+f[3]:void 0,g.sub=f[1]||void 0)),g.port=g.port||("https"===g.protocol?"443":"80"),g.protocol=g.protocol||("443"===g.port?"https":"http")}return b in g?g[b]:"{}"===b?g:void 0}}();"function"==typeof window.define&&window.define.amd?window.define("js-url",[],function(){return a}):("undefined"!=typeof window.jQuery&&window.jQuery.extend({url:function(a,b){return window.url(a,b)}}),window.url=a)}();


  /*============================================================================
    Home page - social media
  ==============================================================================*/

  var social = {
    twitter: function(){
      if (!window.twttr){
        //Initialize twitter feed
        window.twttr = (function (d,s,id) {
        var t, js, fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) return; js=d.createElement(s); js.id=id;
        js.src="https://platform.twitter.com/widgets.js";
        fjs.parentNode.insertBefore(js, fjs);
        return window.twttr || (t = { _e: [], ready: function(f){ t._e.push(f) } });
        }(document, "script", "twitter-wjs"));
      }

      if (window.twttr) {
        window.twttr.ready(function (twttr) {
          twttr.widgets.load(
            document.getElementById("twitter-timeline")
          );
        });
      }
    },
    unload: function(){

    }
  }

  var instagram = {
    loadContent: function(s){
      if(s.clientID) {
        var url = 'https://api.instagram.com/v1/users/self/media/recent/?access_token='+s.clientID;

        $.ajax({
          type: 'GET',
          url: url,
          dataType: 'jsonp',
          success: function(data) {
            if(data.meta.code === 200 && data.data.length) {
              var data = data.data;
              var count = 0;
              s.el.empty();

              for(var i = 0; i < data.length; i++) {
                var thisMedia = data[i], item;

                if(!thisMedia.images.low_resolution.url.indexOf("null") > -1) {
                  item = '<img class="il-photo__img" src="'+thisMedia.images.low_resolution.url+'" data-filter="'+thisMedia.filter+'" />';
                  item = '<a href="'+thisMedia.link+'" target="_blank">'+item+'</a>';
                }

                if(thisMedia.videos) {
                  var src;

                  if(thisMedia.videos.standard_resolution) {
                    src = thisMedia.videos.standard_resolution.url;
                  } else if(thisMedia.videos.low_resolution) {
                    src = thisMedia.videos.low_resolution.url;
                  } else if(thisMedia.videos.low_bandwidth) {
                    src = thisMedia.videos.low_bandwidth.url;
                  }

                  item = '<video poster="'+thisMedia.images.low_resolution.url+'" controls>';
                  item += '<source src="'+src+'" type="video/mp4;"></source>';
                  item += '</video>';
                }
                if(item) {
                  item = '<div class="four columns">'+item+'</div>';
                }
                if(item !== '') {
                  s.el.append(item);
                  count++;
                }
                if(count == s.limit) {
                  break;
                }
              }
            }
          },
          error: function() {
          }
        });
      }
    }
  }

  $('.social-feeds-wrap').each(function (index, value) {

    social.twitter();

    var $target = $(this).find(".js-instafeed");
    instagram.loadContent({
      el: $target,
      clientID: $target.data('client-id'),
      limit: $target.data('count')
    });
  });
$(document)
  .on('shopify:block:select', function(e){

    var blockId = e.detail.blockId;
    var $parentSection = $('#shopify-section-' + e.detail.sectionId);

    if ($parentSection.hasClass('slideshow-section') || $parentSection.hasClass('testimonial-section')){
      sliderBlock.select(blockId, $parentSection);
    }

    utils.resizeActionButtons();

});

$(document)
  .on('shopify:block:deselect', function(e){

    var $parentSection = $('#shopify-section-' + e.detail.sectionId);

    if ($parentSection.hasClass('slideshow-section') || $parentSection.hasClass('testimonial-section')){
      sliderBlock.deselect($parentSection)
    }

});

$(document)
  .on('shopify:section:reorder', function(e){

    utils.pageBannerCheck();

});

$(document)
  .on('shopify:section:load', function(e){

    var $parentSection = $('#shopify-section-' + e.detail.sectionId);

    utils.pageBannerCheck();

    

    if ($parentSection.hasClass('social-feeds-section')){
      $('.social-feeds-wrap').each(function (index, value) {

        social.twitter();

        var $target = $(this).find(".js-instafeed");
        instagram.loadContent({
          el: $target,
          clientID: $target.data('client-id'),
          limit: $target.data('count')
        });
      });
    }

    if ($parentSection.hasClass('cart-section')){
      productFormListeners.init();
      cart.init();
    }

    if ($parentSection.hasClass('featured-promotions-section')){
      featuredPromotions.init();
    }

    if ($parentSection.hasClass('slideshow-section')){
      slideshow.init();
    }

    if ($parentSection.hasClass('testimonial-section')){
      testimonial.init();
    }

    if ($parentSection.hasClass('image-gallery-section')){
      gallery.init();
    }

    if ($parentSection.hasClass('featured-products-section')){
      productPage.initializeQuantityBox();
      productPage.init();
    }

    if ($parentSection.hasClass('featured-collection-section')){
      featuredCollectionSection.init();
    }

    if ($parentSection.hasClass('video-section')){
      videoSection.init();
    }

    if ($parentSection.hasClass('recently-viewed')){
      recentlyViewed.init('.js-recently-viewed');
    }

    if ($parentSection.hasClass('product-template')){
      productPage.init();
      productPage.relatedProducts();

      //Initiate recently viewed below product
      if ($('.js-recently-viewed .rv-main').length) {
        recentlyViewed.init('.js-recently-viewed');
      } else if ($('.product-template').length) {
        recentlyViewed.init();
      }

      if ($('.sidebar .js-sidebar-recently-viewed').length) {
        if ($.cookie('recentlyViewed') != ''){
          recentlyViewed.init('.sidebar .js-sidebar-recently-viewed');
        } else {
          $('.js-sidebar-recently-viewed.hidden').parents('.sidebar-block').remove();
        }
      }


    }

    if ($parentSection.hasClass('article-template-section')){
      if(window.location.pathname.indexOf('/comments') != -1) {
        $('html,body').animate({scrollTop: $("#new-comment").offset().top-140},'slow');
      }
    }

    if ($parentSection.hasClass('collection-template-section')){
      collectionSidebarFilter.init();
    }

    if ($parentSection.hasClass('search-template-section')){
      collection.init();
    }

    if ($parentSection.hasClass('header-section')){
      header.init();
      header.loadMegaMenu();
    }

    if ($parentSection.hasClass('mega-menu-section')){
      header.loadMegaMenu();
    }

    if ($parentSection.hasClass('page-details-section')) {
      featuredCollectionSection.init();
      videoSection.init();
    }
});


$(document)
  .on('shopify:section:unload', function(e){

    var $target = $(e.target);
    var $parentSection = $('#shopify-section-' + e.detail.sectionId);

    if ($parentSection.hasClass('header-section')){
      header.unload($target);
      header.unloadMegaMenu();
    }

    if ($parentSection.hasClass('slideshow-section')){
      slideshow.unload($target);
    }

    if ($parentSection.hasClass('testimonial-section')){
      testimonial.unload($target);
    }

    if ($parentSection.hasClass('video-section')){
      videoSection.unload($target);
    }

    if ($parentSection.hasClass('product-template')){
      productPage.unload($target);
    }

    if ($parentSection.hasClass('mega-menu-section')){
      header.unloadMegaMenu();
    }

    if ($parentSection.hasClass('page-details-section')) {
      videoSection.unload($target);
    }

});

$(document)
  .on('shopify:section:select', function(e){

    var $parentSection = $('#shopify-section-' + e.detail.sectionId);

    if ($parentSection.hasClass('social-feeds-section')){
      $('.social-feeds-wrap').each(function (index, value) {
        social.twitter();
      });
    }

    if ($parentSection.hasClass('mega-menu-section')){
      var megaMenuParent = $('.header .' + e.detail.sectionId).data('dropdown');
      setTimeout(function() {
        $('a.mega-menu-parent[data-dropdown-rel="' + megaMenuParent + '"]').trigger('mouseenter');
        $('a.mega-menu-parent[data-dropdown-rel="' + megaMenuParent + '"]').parents('header').addClass('editor-hover--true');
        header.removeDataAttributes('.header .mega-menu.dropdown_container .dropdown_column');
      }, 10);
    }

    if ($parentSection.hasClass('featured-collection-section')){
      featuredCollectionSection.unload($parentSection);
      featuredCollectionSection.init();
    }

    //Sidebar toggle check
    if ($(window).width() >= 768 && $('.sidebar').length) {
      $('.toggle-all--true .toggle_list .active').parents('ul.toggle_list').prev().click();
    }

    utils.pageBannerCheck();
    var evt = document.createEvent('UIEvents');
    evt.initUIEvent('resize', true, false, window, 0);
    window.dispatchEvent(evt);
});

$(document)
  .on('shopify:section:deselect', function(e){

    var $parentSection = $('#shopify-section-' + e.detail.sectionId);

    if ($parentSection.hasClass('mega-menu-section')){
      var megaMenuParent = $('.header .' + e.detail.sectionId).data('dropdown');
      $('a.mega-menu-parent[data-dropdown-rel="' + megaMenuParent + '"]').trigger('mouseout');
      $('a.mega-menu-parent[data-dropdown-rel="' + megaMenuParent + '"]').parents('header').removeClass('editor-hover--true');
    }

});

//custom
/*
$( document ).ready(function() {
  var mailSubBlock = '<h6 class="newsletter-edit">Newsletter<span class="right icon-down-arrow"></span></h6><div id="shopify-section-1489285367207" class="shopify-section newsletter-section"> <div class="newsletter_section newsletter-both-names--false newsletter-bgr-true text-align--center lazyload fade-in"> <div class="container container-edit five columns" style="padding: 13px 0px;"> <div class="section_form" style="padding: 0px 20px;"> <div class="newsletter-text"> </div> <div class="newsletter"> <span class="message"></span> <form method="post" action="https://www.ridgewallet.com/contact#contact_form" id="contact_form" class="contact-form" style="text-align: left;" accept-charset="UTF-8"> <input type="hidden" value="customer" name="form_type"> <input type="hidden" name="utf8" value="✓"> <input type="hidden" name="contact[tags]" value="prospect,newsletter"> <input type="hidden" name="challenge" value="false"> <input type="email" class="contact_email" name="contact[email]" required="" placeholder="Enter your email address..."> <input type="submit" class="action_button sign_up" value="Sign Up"></form></div></div></div></div></div>';
    $('.empty-column')
    .append(mailSubBlock);
});
*/
function InstaRedirectShop(){
	jQuery(".fs-normal-timeline.fs-desktop.fs-prepended-detail.fs-wrapper").hide();
    jQuery(".fs-narrow-timeline.fs-mobile.fs-prepended-detail.fs-wrapper").hide();
  	location='pages/shop-insta';
}

function hidestickybar(){
	jQuery(".sticky_nav").removeClass('sticky_nav--stick');
    jQuery(".sticky_nav").addClass('sticky_nav--unstick');
}


/* MMenu */


/*
 * jQuery mmenu v5.7.8
 * @requires jQuery 1.7.0 or later
 *
 * mmenu.frebsite.nl
 *
 * Copyright (c) Fred Heusschen
 * www.frebsite.nl
 *
 * License: CC-BY-NC-4.0
 * http://creativecommons.org/licenses/by-nc/4.0/
 */
!function(e){function n(){e[t].glbl||(r={$wndw:e(window),$docu:e(document),$html:e("html"),$body:e("body")},s={},a={},o={},e.each([s,a,o],function(e,n){n.add=function(e){e=e.split(" ");for(var t=0,i=e.length;t<i;t++)n[e[t]]=n.mm(e[t])}}),s.mm=function(e){return"mm-"+e},s.add("wrapper menu panels panel nopanel current highest opened subopened navbar hasnavbar title btn prev next listview nolistview inset vertical selected divider spacer hidden fullsubopen"),s.umm=function(e){return"mm-"==e.slice(0,3)&&(e=e.slice(3)),e},a.mm=function(e){return"mm-"+e},a.add("parent child"),o.mm=function(e){return e+".mm"},o.add("transitionend webkitTransitionEnd click scroll keydown mousedown mouseup touchstart touchmove touchend orientationchange"),e[t]._c=s,e[t]._d=a,e[t]._e=o,e[t].glbl=r)}var t="mmenu",i="5.7.8";if(!(e[t]&&e[t].version>i)){e[t]=function(e,n,t){this.$menu=e,this._api=["bind","getInstance","update","initPanels","openPanel","closePanel","closeAllPanels","setSelected"],this.opts=n,this.conf=t,this.vars={},this.cbck={},"function"==typeof this.___deprecated&&this.___deprecated(),this._initMenu(),this._initAnchors();var i=this.$pnls.children();return this._initAddons(),this.initPanels(i),"function"==typeof this.___debug&&this.___debug(),this},e[t].version=i,e[t].addons={},e[t].uniqueId=0,e[t].defaults={extensions:[],initMenu:function(){},initPanels:function(){},navbar:{add:!0,title:"Menu",titleLink:"panel"},onClick:{setSelected:!0},slidingSubmenus:!0},e[t].configuration={classNames:{divider:"Divider",inset:"Inset",panel:"Panel",selected:"Selected",spacer:"Spacer",vertical:"Vertical"},clone:!1,openingInterval:25,panelNodetype:"ul, ol, div",transitionDuration:400},e[t].prototype={init:function(e){this.initPanels(e)},getInstance:function(){return this},update:function(){this.trigger("update")},initPanels:function(e){e=e.not("."+s.nopanel),e=this._initPanels(e),this.opts.initPanels.call(this,e),this.trigger("initPanels",e),this.trigger("update")},openPanel:function(n){var i=n.parent(),a=this;if(i.hasClass(s.vertical)){var o=i.parents("."+s.subopened);if(o.length)return void this.openPanel(o.first());i.addClass(s.opened),this.trigger("openPanel",n),this.trigger("openingPanel",n),this.trigger("openedPanel",n)}else{if(n.hasClass(s.current))return;var r=this.$pnls.children("."+s.panel),l=r.filter("."+s.current);r.removeClass(s.highest).removeClass(s.current).not(n).not(l).not("."+s.vertical).addClass(s.hidden),e[t].support.csstransitions||l.addClass(s.hidden),n.hasClass(s.opened)?n.nextAll("."+s.opened).addClass(s.highest).removeClass(s.opened).removeClass(s.subopened):(n.addClass(s.highest),l.addClass(s.subopened)),n.removeClass(s.hidden).addClass(s.current),a.trigger("openPanel",n),setTimeout(function(){n.removeClass(s.subopened).addClass(s.opened),a.trigger("openingPanel",n),a.__transitionend(n,function(){a.trigger("openedPanel",n)},a.conf.transitionDuration)},this.conf.openingInterval)}},closePanel:function(e){var n=e.parent();n.hasClass(s.vertical)&&(n.removeClass(s.opened),this.trigger("closePanel",e),this.trigger("closingPanel",e),this.trigger("closedPanel",e))},closeAllPanels:function(){this.$menu.find("."+s.listview).children().removeClass(s.selected).filter("."+s.vertical).removeClass(s.opened);var e=this.$pnls.children("."+s.panel),n=e.first();this.$pnls.children("."+s.panel).not(n).removeClass(s.subopened).removeClass(s.opened).removeClass(s.current).removeClass(s.highest).addClass(s.hidden),this.openPanel(n)},togglePanel:function(e){var n=e.parent();n.hasClass(s.vertical)&&this[n.hasClass(s.opened)?"closePanel":"openPanel"](e)},setSelected:function(e){this.$menu.find("."+s.listview).children("."+s.selected).removeClass(s.selected),e.addClass(s.selected),this.trigger("setSelected",e)},bind:function(e,n){e="init"==e?"initPanels":e,this.cbck[e]=this.cbck[e]||[],this.cbck[e].push(n)},trigger:function(){var e=this,n=Array.prototype.slice.call(arguments),t=n.shift();if(t="init"==t?"initPanels":t,this.cbck[t])for(var i=0,s=this.cbck[t].length;i<s;i++)this.cbck[t][i].apply(e,n)},_initMenu:function(){this.conf.clone&&(this.$orig=this.$menu,this.$menu=this.$orig.clone(!0),this.$menu.add(this.$menu.find("[id]")).filter("[id]").each(function(){e(this).attr("id",s.mm(e(this).attr("id")))})),this.opts.initMenu.call(this,this.$menu,this.$orig),this.$menu.attr("id",this.$menu.attr("id")||this.__getUniqueId()),this.$pnls=e('<div class="'+s.panels+'" />').append(this.$menu.children(this.conf.panelNodetype)).prependTo(this.$menu),this.$menu.parent().addClass(s.wrapper);var n=[s.menu];this.opts.slidingSubmenus||n.push(s.vertical),this.opts.extensions=this.opts.extensions.length?"mm-"+this.opts.extensions.join(" mm-"):"",this.opts.extensions&&n.push(this.opts.extensions),this.$menu.addClass(n.join(" ")),this.trigger("_initMenu")},_initPanels:function(n){var i=this,o=this.__findAddBack(n,"ul, ol");this.__refactorClass(o,this.conf.classNames.inset,"inset").addClass(s.nolistview+" "+s.nopanel),o.not("."+s.nolistview).addClass(s.listview);var r=this.__findAddBack(n,"."+s.listview).children();this.__refactorClass(r,this.conf.classNames.selected,"selected"),this.__refactorClass(r,this.conf.classNames.divider,"divider"),this.__refactorClass(r,this.conf.classNames.spacer,"spacer"),this.__refactorClass(this.__findAddBack(n,"."+this.conf.classNames.panel),this.conf.classNames.panel,"panel");var l=e(),d=n.add(n.find("."+s.panel)).add(this.__findAddBack(n,"."+s.listview).children().children(this.conf.panelNodetype)).not("."+s.nopanel);this.__refactorClass(d,this.conf.classNames.vertical,"vertical"),this.opts.slidingSubmenus||d.addClass(s.vertical),d.each(function(){var n=e(this),t=n;n.is("ul, ol")?(n.wrap('<div class="'+s.panel+'" />'),t=n.parent()):t.addClass(s.panel);var a=n.attr("id");n.removeAttr("id"),t.attr("id",a||i.__getUniqueId()),n.hasClass(s.vertical)&&(n.removeClass(i.conf.classNames.vertical),t.add(t.parent()).addClass(s.vertical)),l=l.add(t)});var c=e("."+s.panel,this.$menu);l.each(function(n){var o,r,l=e(this),d=l.parent(),c=d.children("a, span").first();if(d.is("."+s.panels)||(d.data(a.child,l),l.data(a.parent,d)),d.children("."+s.next).length||d.parent().is("."+s.listview)&&(o=l.attr("id"),r=e('<a class="'+s.next+'" href="#'+o+'" data-target="#'+o+'" />').insertBefore(c),c.is("span")&&r.addClass(s.fullsubopen)),!l.children("."+s.navbar).length&&!d.hasClass(s.vertical)){d.parent().is("."+s.listview)?d=d.closest("."+s.panel):(c=d.closest("."+s.panel).find('a[href="#'+l.attr("id")+'"]').first(),d=c.closest("."+s.panel));var h=!1,u=e('<div class="'+s.navbar+'" />');if(i.opts.navbar.add&&l.addClass(s.hasnavbar),d.length){switch(o=d.attr("id"),i.opts.navbar.titleLink){case"anchor":h=c.attr("href");break;case"panel":case"parent":h="#"+o;break;default:h=!1}u.append('<a class="'+s.btn+" "+s.prev+'" href="#'+o+'" data-target="#'+o+'" />').append(e('<a class="'+s.title+'"'+(h?' href="'+h+'"':"")+" />").text(c.text())).prependTo(l)}else i.opts.navbar.title&&u.append('<a class="'+s.title+'">'+e[t].i18n(i.opts.navbar.title)+"</a>").prependTo(l)}});var h=this.__findAddBack(n,"."+s.listview).children("."+s.selected).removeClass(s.selected).last().addClass(s.selected);h.add(h.parentsUntil("."+s.menu,"li")).filter("."+s.vertical).addClass(s.opened).end().each(function(){e(this).parentsUntil("."+s.menu,"."+s.panel).not("."+s.vertical).first().addClass(s.opened).parentsUntil("."+s.menu,"."+s.panel).not("."+s.vertical).first().addClass(s.opened).addClass(s.subopened)}),h.children("."+s.panel).not("."+s.vertical).addClass(s.opened).parentsUntil("."+s.menu,"."+s.panel).not("."+s.vertical).first().addClass(s.opened).addClass(s.subopened);var u=c.filter("."+s.opened);return u.length||(u=l.first()),u.addClass(s.opened).last().addClass(s.current),l.not("."+s.vertical).not(u.last()).addClass(s.hidden).end().filter(function(){return!e(this).parent().hasClass(s.panels)}).appendTo(this.$pnls),this.trigger("_initPanels",l),l},_initAnchors:function(){var n=this;r.$body.on(o.click+"-oncanvas","a[href]",function(i){var a=e(this),o=!1,r=n.$menu.find(a).length;for(var l in e[t].addons)if(e[t].addons[l].clickAnchor.call(n,a,r)){o=!0;break}var d=a.attr("href");if(!o&&r&&d.length>1&&"#"==d.slice(0,1))try{var c=e(d,n.$menu);c.is("."+s.panel)&&(o=!0,n[a.parent().hasClass(s.vertical)?"togglePanel":"openPanel"](c))}catch(h){}if(o&&i.preventDefault(),!o&&r&&a.is("."+s.listview+" > li > a")&&!a.is('[rel="external"]')&&!a.is('[target="_blank"]')){n.__valueOrFn(n.opts.onClick.setSelected,a)&&n.setSelected(e(i.target).parent());var u=n.__valueOrFn(n.opts.onClick.preventDefault,a,"#"==d.slice(0,1));u&&i.preventDefault(),n.__valueOrFn(n.opts.onClick.close,a,u)&&n.close()}}),this.trigger("_initAnchors")},_initAddons:function(){var n;for(n in e[t].addons)e[t].addons[n].add.call(this),e[t].addons[n].add=function(){};for(n in e[t].addons)e[t].addons[n].setup.call(this);this.trigger("_initAddons")},_getOriginalMenuId:function(){var e=this.$menu.attr("id");return e&&e.length&&this.conf.clone&&(e=s.umm(e)),e},__api:function(){var n=this,t={};return e.each(this._api,function(e){var i=this;t[i]=function(){var e=n[i].apply(n,arguments);return"undefined"==typeof e?t:e}}),t},__valueOrFn:function(e,n,t){return"function"==typeof e?e.call(n[0]):"undefined"==typeof e&&"undefined"!=typeof t?t:e},__refactorClass:function(e,n,t){return e.filter("."+n).removeClass(n).addClass(s[t])},__findAddBack:function(e,n){return e.find(n).add(e.filter(n))},__filterListItems:function(e){return e.not("."+s.divider).not("."+s.hidden)},__transitionend:function(n,t,i){var s=!1,a=function(i){if("undefined"!=typeof i){if(!e(i.target).is(n))return!1;n.unbind(o.transitionend),n.unbind(o.webkitTransitionEnd)}s||t.call(n[0]),s=!0};n.on(o.transitionend,a),n.on(o.webkitTransitionEnd,a),setTimeout(a,1.1*i)},__getUniqueId:function(){return s.mm(e[t].uniqueId++)}},e.fn[t]=function(i,s){n(),i=e.extend(!0,{},e[t].defaults,i),s=e.extend(!0,{},e[t].configuration,s);var a=e();return this.each(function(){var n=e(this);if(!n.data(t)){var o=new e[t](n,i,s);o.$menu.data(t,o.__api()),a=a.add(o.$menu)}}),a},e[t].i18n=function(){var n={};return function(t){switch(typeof t){case"object":return e.extend(n,t),n;case"string":return n[t]||t;case"undefined":default:return n}}}(),e[t].support={touch:"ontouchstart"in window||navigator.msMaxTouchPoints||!1,csstransitions:function(){if("undefined"!=typeof Modernizr&&"undefined"!=typeof Modernizr.csstransitions)return Modernizr.csstransitions;var e=document.body||document.documentElement,n=e.style,t="transition";if("string"==typeof n[t])return!0;var i=["Moz","webkit","Webkit","Khtml","O","ms"];t=t.charAt(0).toUpperCase()+t.substr(1);for(var s=0;s<i.length;s++)if("string"==typeof n[i[s]+t])return!0;return!1}(),csstransforms:function(){return"undefined"==typeof Modernizr||"undefined"==typeof Modernizr.csstransforms||Modernizr.csstransforms}(),csstransforms3d:function(){return"undefined"==typeof Modernizr||"undefined"==typeof Modernizr.csstransforms3d||Modernizr.csstransforms3d}()};var s,a,o,r}}(jQuery),
 /*
 * jQuery mmenu offCanvas add-on
 * mmenu.frebsite.nl
 *
 * Copyright (c) Fred Heusschen
 */
function(e){var n="mmenu",t="offCanvas";e[n].addons[t]={setup:function(){if(this.opts[t]){var s=this.opts[t],a=this.conf[t];o=e[n].glbl,this._api=e.merge(this._api,["open","close","setPage"]),"top"!=s.position&&"bottom"!=s.position||(s.zposition="front"),"string"!=typeof a.pageSelector&&(a.pageSelector="> "+a.pageNodetype),o.$allMenus=(o.$allMenus||e()).add(this.$menu),this.vars.opened=!1;var r=[i.offcanvas];"left"!=s.position&&r.push(i.mm(s.position)),"back"!=s.zposition&&r.push(i.mm(s.zposition)),this.$menu.addClass(r.join(" ")).parent().removeClass(i.wrapper),e[n].support.csstransforms||this.$menu.addClass(i["no-csstransforms"]),e[n].support.csstransforms3d||this.$menu.addClass(i["no-csstransforms3d"]),this.setPage(o.$page),this._initBlocker(),this["_initWindow_"+t](),this.$menu[a.menuInjectMethod+"To"](a.menuWrapperSelector);var l=window.location.hash;if(l){var d=this._getOriginalMenuId();d&&d==l.slice(1)&&this.open()}}},add:function(){i=e[n]._c,s=e[n]._d,a=e[n]._e,i.add("offcanvas slideout blocking modal background opening blocker page no-csstransforms3d"),s.add("style"),a.add("resize")},clickAnchor:function(e,n){var s=this;if(this.opts[t]){var a=this._getOriginalMenuId();if(a&&e.is('[href="#'+a+'"]')){if(n)return!0;var r=e.closest("."+i.menu);if(r.length){var l=r.data("mmenu");if(l&&l.close)return l.close(),s.__transitionend(r,function(){s.open()},s.conf.transitionDuration),!0}return this.open(),!0}if(o.$page)return a=o.$page.first().attr("id"),a&&e.is('[href="#'+a+'"]')?(this.close(),!0):void 0}}},e[n].defaults[t]={position:"left",zposition:"back",blockUI:!0,moveBackground:!0},e[n].configuration[t]={pageNodetype:"div",pageSelector:null,noPageSelector:[],wrapPageIfNeeded:!0,menuWrapperSelector:"body",menuInjectMethod:"prepend"},e[n].prototype.open=function(){if(!this.vars.opened){var e=this;this._openSetup(),setTimeout(function(){e._openFinish()},this.conf.openingInterval),this.trigger("open")}},e[n].prototype._openSetup=function(){var n=this,r=this.opts[t];this.closeAllOthers(),o.$page.each(function(){e(this).data(s.style,e(this).attr("style")||"")}),o.$wndw.trigger(a.resize+"-"+t,[!0]);var l=[i.opened];r.blockUI&&l.push(i.blocking),"modal"==r.blockUI&&l.push(i.modal),r.moveBackground&&l.push(i.background),"left"!=r.position&&l.push(i.mm(this.opts[t].position)),"back"!=r.zposition&&l.push(i.mm(this.opts[t].zposition)),this.opts.extensions&&l.push(this.opts.extensions),o.$html.addClass(l.join(" ")),setTimeout(function(){n.vars.opened=!0},this.conf.openingInterval),this.$menu.addClass(i.current+" "+i.opened)},e[n].prototype._openFinish=function(){var e=this;this.__transitionend(o.$page.first(),function(){e.trigger("opened")},this.conf.transitionDuration),o.$html.addClass(i.opening),this.trigger("opening")},e[n].prototype.close=function(){if(this.vars.opened){var n=this;this.__transitionend(o.$page.first(),function(){n.$menu.removeClass(i.current+" "+i.opened);var a=[i.opened,i.blocking,i.modal,i.background,i.mm(n.opts[t].position),i.mm(n.opts[t].zposition)];n.opts.extensions&&a.push(n.opts.extensions),o.$html.removeClass(a.join(" ")),o.$page.each(function(){e(this).attr("style",e(this).data(s.style))}),n.vars.opened=!1,n.trigger("closed")},this.conf.transitionDuration),o.$html.removeClass(i.opening),this.trigger("close"),this.trigger("closing")}},e[n].prototype.closeAllOthers=function(){o.$allMenus.not(this.$menu).each(function(){var t=e(this).data(n);t&&t.close&&t.close()})},e[n].prototype.setPage=function(n){var s=this,a=this.conf[t];n&&n.length||(n=o.$body.find(a.pageSelector),a.noPageSelector.length&&(n=n.not(a.noPageSelector.join(", "))),n.length>1&&a.wrapPageIfNeeded&&(n=n.wrapAll("<"+this.conf[t].pageNodetype+" />").parent())),n.each(function(){e(this).attr("id",e(this).attr("id")||s.__getUniqueId())}),n.addClass(i.page+" "+i.slideout),o.$page=n,this.trigger("setPage",n)},e[n].prototype["_initWindow_"+t]=function(){o.$wndw.off(a.keydown+"-"+t).on(a.keydown+"-"+t,function(e){if(o.$html.hasClass(i.opened)&&9==e.keyCode)return e.preventDefault(),!1});var e=0;o.$wndw.off(a.resize+"-"+t).on(a.resize+"-"+t,function(n,t){if(1==o.$page.length&&(t||o.$html.hasClass(i.opened))){var s=o.$wndw.height();(t||s!=e)&&(e=s,o.$page.css("minHeight",s))}})},e[n].prototype._initBlocker=function(){var n=this;this.opts[t].blockUI&&(o.$blck||(o.$blck=e('<div id="'+i.blocker+'" class="'+i.slideout+'" />')),o.$blck.appendTo(o.$body).off(a.touchstart+"-"+t+" "+a.touchmove+"-"+t).on(a.touchstart+"-"+t+" "+a.touchmove+"-"+t,function(e){e.preventDefault(),e.stopPropagation(),o.$blck.trigger(a.mousedown+"-"+t)}).off(a.mousedown+"-"+t).on(a.mousedown+"-"+t,function(e){e.preventDefault(),o.$html.hasClass(i.modal)||(n.closeAllOthers(),n.close())}))};var i,s,a,o}(jQuery),/*

/* jQuery mmenu searchfield add-on
 * mmenu.frebsite.nl
 *
 * Copyright (c) Fred Heusschen
 */
function(e){function n(e){switch(e){case 9:case 16:case 17:case 18:case 37:case 38:case 39:case 40:return!0}return!1}var t="mmenu",i="searchfield";e[t].addons[i]={setup:function(){var l=this,d=this.opts[i],c=this.conf[i];r=e[t].glbl,"boolean"==typeof d&&(d={add:d}),"object"!=typeof d&&(d={}),"boolean"==typeof d.resultsPanel&&(d.resultsPanel={add:d.resultsPanel}),d=this.opts[i]=e.extend(!0,{},e[t].defaults[i],d),c=this.conf[i]=e.extend(!0,{},e[t].configuration[i],c),this.bind("close",function(){this.$menu.find("."+s.search).find("input").blur()}),this.bind("initPanels",function(r){if(d.add){var h;switch(d.addTo){case"panels":h=r;break;default:h=this.$menu.find(d.addTo)}if(h.each(function(){var n=e(this);if(!n.is("."+s.panel)||!n.is("."+s.vertical)){if(!n.children("."+s.search).length){var i=l.__valueOrFn(c.clear,n),a=l.__valueOrFn(c.form,n),r=l.__valueOrFn(c.input,n),h=l.__valueOrFn(c.submit,n),u=e("<"+(a?"form":"div")+' class="'+s.search+'" />'),f=e('<input placeholder="'+e[t].i18n(d.placeholder)+'" type="text" autocomplete="off" />');u.append(f);var p;if(r)for(p in r)f.attr(p,r[p]);if(i&&e('<a class="'+s.btn+" "+s.clear+'" href="#" />').appendTo(u).on(o.click+"-searchfield",function(e){e.preventDefault(),f.val("").trigger(o.keyup+"-searchfield")}),a){for(p in a)u.attr(p,a[p]);h&&!i&&e('<a class="'+s.btn+" "+s.next+'" href="#" />').appendTo(u).on(o.click+"-searchfield",function(e){e.preventDefault(),u.submit()})}n.hasClass(s.search)?n.replaceWith(u):n.prepend(u).addClass(s.hassearch)}if(d.noResults){var v=n.closest("."+s.panel).length;if(v||(n=l.$pnls.children("."+s.panel).first()),!n.children("."+s.noresultsmsg).length){var m=n.children("."+s.listview).first();e('<div class="'+s.noresultsmsg+" "+s.hidden+'" />').append(e[t].i18n(d.noResults))[m.length?"insertAfter":"prependTo"](m.length?m:n)}}}}),d.search){if(d.resultsPanel.add){d.showSubPanels=!1;var u=this.$pnls.children("."+s.resultspanel);u.length||(u=e('<div class="'+s.panel+" "+s.resultspanel+" "+s.hidden+'" />').appendTo(this.$pnls).append('<div class="'+s.navbar+" "+s.hidden+'"><a class="'+s.title+'">'+e[t].i18n(d.resultsPanel.title)+"</a></div>").append('<ul class="'+s.listview+'" />').append(this.$pnls.find("."+s.noresultsmsg).first().clone()),this.initPanels(u))}this.$menu.find("."+s.search).each(function(){var t,r,c=e(this),h=c.closest("."+s.panel).length;h?(t=c.closest("."+s.panel),r=t):(t=e("."+s.panel,l.$menu),r=l.$menu),d.resultsPanel.add&&(t=t.not(u));var f=c.children("input"),p=l.__findAddBack(t,"."+s.listview).children("li"),v=p.filter("."+s.divider),m=l.__filterListItems(p),g="a",b=g+", span",_="",C=function(){var n=f.val().toLowerCase();if(n!=_){if(_=n,d.resultsPanel.add&&u.children("."+s.listview).empty(),t.scrollTop(0),m.add(v).addClass(s.hidden).find("."+s.fullsubopensearch).removeClass(s.fullsubopen+" "+s.fullsubopensearch),m.each(function(){var n=e(this),t=g;(d.showTextItems||d.showSubPanels&&n.find("."+s.next))&&(t=b);var i=n.data(a.searchtext)||n.children(t).text();i.toLowerCase().indexOf(_)>-1&&n.add(n.prevAll("."+s.divider).first()).removeClass(s.hidden)}),d.showSubPanels&&t.each(function(n){var t=e(this);l.__filterListItems(t.find("."+s.listview).children()).each(function(){var n=e(this),t=n.data(a.child);n.removeClass(s.nosubresults),t&&t.find("."+s.listview).children().removeClass(s.hidden)})}),d.resultsPanel.add)if(""===_)this.closeAllPanels(),this.openPanel(this.$pnls.children("."+s.subopened).last());else{var i=e();t.each(function(){var n=l.__filterListItems(e(this).find("."+s.listview).children()).not("."+s.hidden).clone(!0);n.length&&(d.resultsPanel.dividers&&(i=i.add('<li class="'+s.divider+'">'+e(this).children("."+s.navbar).text()+"</li>")),i=i.add(n))}),i.find("."+s.next).remove(),u.children("."+s.listview).append(i),this.openPanel(u)}else e(t.get().reverse()).each(function(n){var t=e(this),i=t.data(a.parent);i&&(l.__filterListItems(t.find("."+s.listview).children()).length?(i.hasClass(s.hidden)&&i.children("."+s.next).not("."+s.fullsubopen).addClass(s.fullsubopen).addClass(s.fullsubopensearch),i.removeClass(s.hidden).removeClass(s.nosubresults).prevAll("."+s.divider).first().removeClass(s.hidden)):h||(t.hasClass(s.opened)&&setTimeout(function(){l.openPanel(i.closest("."+s.panel))},(n+1)*(1.5*l.conf.openingInterval)),i.addClass(s.nosubresults)))});r.find("."+s.noresultsmsg)[m.not("."+s.hidden).length?"addClass":"removeClass"](s.hidden),this.update()}};f.off(o.keyup+"-"+i+" "+o.change+"-"+i).on(o.keyup+"-"+i,function(e){n(e.keyCode)||C.call(l)}).on(o.change+"-"+i,function(e){C.call(l)});var y=c.children("."+s.btn);y.length&&f.on(o.keyup+"-"+i,function(e){y[f.val().length?"removeClass":"addClass"](s.hidden)}),f.trigger(o.keyup+"-"+i)})}}})},add:function(){s=e[t]._c,a=e[t]._d,o=e[t]._e,s.add("clear search hassearch resultspanel noresultsmsg noresults nosubresults fullsubopensearch"),a.add("searchtext"),o.add("change keyup")},clickAnchor:function(e,n){}},e[t].defaults[i]={add:!1,addTo:"panels",placeholder:"Search",noResults:"No results found.",resultsPanel:{add:!1,dividers:!0,title:"Search results"},search:!0,showTextItems:!1,showSubPanels:!0},e[t].configuration[i]={clear:!1,form:!1,input:!1,submit:!1};var s,a,o,r}(jQuery)/*

/*
 * jQuery mmenu fixedElements add-on
 * mmenu.frebsite.nl
 *
 * Copyright (c) Fred Heusschen
 */
!function(s){var i="mmenu",t="fixedElements";s[i].addons[t]={setup:function(){if(this.opts.offCanvas){var n=this.opts[t];this.conf[t];d=s[i].glbl,n=this.opts[t]=s.extend(!0,{},s[i].defaults[t],n);var a=function(s){var i=this.conf.classNames[t].fixed;this.__refactorClass(s.find("."+i),i,"slideout").appendTo(d.$body)};a.call(this,d.$page),this.bind("setPage",a)}},add:function(){n=s[i]._c,a=s[i]._d,e=s[i]._e,n.add("fixed")},clickAnchor:function(s,i){}},s[i].configuration.classNames[t]={fixed:"Fixed"};var n,a,e,d}(jQuery);

/*
 * jQuery mmenu navbar add-on
 * mmenu.frebsite.nl
 *
 * Copyright (c) Fred Heusschen
 */
!function(n){var a="mmenu",t="navbars";n[a].addons[t]={setup:function(){var r=this,s=this.opts[t],c=this.conf[t];if(i=n[a].glbl,"undefined"!=typeof s){s instanceof Array||(s=[s]);var o={};if(s.length){n.each(s,function(i){var l=s[i];"boolean"==typeof l&&l&&(l={}),"object"!=typeof l&&(l={}),"undefined"==typeof l.content&&(l.content=["prev","title"]),l.content instanceof Array||(l.content=[l.content]),l=n.extend(!0,{},r.opts.navbar,l);var d=l.position,h=l.height;"number"!=typeof h&&(h=1),h=Math.min(4,Math.max(1,h)),"bottom"!=d&&(d="top"),o[d]||(o[d]=0),o[d]++;var f=n("<div />").addClass(e.navbar+" "+e.navbar+"-"+d+" "+e.navbar+"-"+d+"-"+o[d]+" "+e.navbar+"-size-"+h);o[d]+=h-1;for(var v=0,u=0,p=l.content.length;u<p;u++){var b=n[a].addons[t][l.content[u]]||!1;b?v+=b.call(r,f,l,c):(b=l.content[u],b instanceof n||(b=n(l.content[u])),f.append(b))}v+=Math.ceil(f.children().not("."+e.btn).length/h),v>1&&f.addClass(e.navbar+"-content-"+v),f.children("."+e.btn).length&&f.addClass(e.hasbtns),f.prependTo(r.$menu)});for(var l in o)r.$menu.addClass(e.hasnavbar+"-"+l+"-"+o[l])}}},add:function(){e=n[a]._c,r=n[a]._d,s=n[a]._e,e.add("close hasbtns")},clickAnchor:function(n,a){}},n[a].configuration[t]={breadcrumbSeparator:"/"},n[a].configuration.classNames[t]={};var e,r,s,i}(jQuery),/*
 * jQuery mmenu navbar add-on breadcrumbs content
 * mmenu.frebsite.nl
 *
 * Copyright (c) Fred Heusschen
 */
function(n){var a="mmenu",t="navbars",e="breadcrumbs";n[a].addons[t][e]=function(t,e,r){var s=n[a]._c,i=n[a]._d;s.add("breadcrumbs separator");var c=n('<span class="'+s.breadcrumbs+'" />').appendTo(t);this.bind("initPanels",function(a){a.removeClass(s.hasnavbar).each(function(){for(var a=[],t=n(this),e=n('<span class="'+s.breadcrumbs+'"></span>'),c=n(this).children().first(),o=!0;c&&c.length;){c.is("."+s.panel)||(c=c.closest("."+s.panel));var l=c.children("."+s.navbar).children("."+s.title).text();a.unshift(o?"<span>"+l+"</span>":'<a href="#'+c.attr("id")+'">'+l+"</a>"),o=!1,c=c.data(i.parent)}e.append(a.join('<span class="'+s.separator+'">'+r.breadcrumbSeparator+"</span>")).appendTo(t.children("."+s.navbar))})});var o=function(){c.html(this.$pnls.children("."+s.current).children("."+s.navbar).children("."+s.breadcrumbs).html())};return this.bind("openPanel",o),this.bind("initPanels",o),0}}(jQuery),/*
 * jQuery mmenu navbar add-on close content
 * mmenu.frebsite.nl
 *
 * Copyright (c) Fred Heusschen
 */
function(n){var a="mmenu",t="navbars",e="close";n[a].addons[t][e]=function(t,e){var r=n[a]._c,s=n[a].glbl,i=n('<a class="'+r.close+" "+r.btn+'" href="#" />').appendTo(t),c=function(n){i.attr("href","#"+n.attr("id"))};return c.call(this,s.$page),this.bind("setPage",c),-1}}(jQuery),/*
 * jQuery mmenu navbar add-on next content
 * mmenu.frebsite.nl
 *
 * Copyright (c) Fred Heusschen
 */
function(n){var a="mmenu",t="navbars",e="next";n[a].addons[t][e]=function(e,r){var s,i,c,o=n[a]._c,l=n('<a class="'+o.next+" "+o.btn+'" href="#" />').appendTo(e),d=function(n){n=n||this.$pnls.children("."+o.current);var a=n.find("."+this.conf.classNames[t].panelNext);s=a.attr("href"),c=a.attr("aria-owns"),i=a.html(),l[s?"attr":"removeAttr"]("href",s),l[c?"attr":"removeAttr"]("aria-owns",c),l[s||i?"removeClass":"addClass"](o.hidden),l.html(i)};return this.bind("openPanel",d),this.bind("initPanels",function(){d.call(this)}),-1},n[a].configuration.classNames[t].panelNext="Next"}(jQuery),/*
 * jQuery mmenu navbar add-on prev content
 * mmenu.frebsite.nl
 *
 * Copyright (c) Fred Heusschen
 */
function(n){var a="mmenu",t="navbars",e="prev";n[a].addons[t][e]=function(e,r){var s=n[a]._c,i=n('<a class="'+s.prev+" "+s.btn+'" href="#" />').appendTo(e);this.bind("initPanels",function(n){n.removeClass(s.hasnavbar).children("."+s.navbar).addClass(s.hidden)});var c,o,l,d=function(n){if(n=n||this.$pnls.children("."+s.current),!n.hasClass(s.vertical)){var a=n.find("."+this.conf.classNames[t].panelPrev);a.length||(a=n.children("."+s.navbar).children("."+s.prev)),c=a.attr("href"),l=a.attr("aria-owns"),o=a.html(),i[c?"attr":"removeAttr"]("href",c),i[l?"attr":"removeAttr"]("aria-owns",l),i[c||o?"removeClass":"addClass"](s.hidden),i.html(o)}};return this.bind("openPanel",d),this.bind("initPanels",function(){d.call(this)}),-1},n[a].configuration.classNames[t].panelPrev="Prev"}(jQuery),/*
 * jQuery mmenu navbar add-on searchfield content
 * mmenu.frebsite.nl
 *
 * Copyright (c) Fred Heusschen
 */
function(n){var a="mmenu",t="navbars",e="searchfield";n[a].addons[t][e]=function(t,e){var r=n[a]._c,s=n('<div class="'+r.search+'" />').appendTo(t);return"object"!=typeof this.opts.searchfield&&(this.opts.searchfield={}),this.opts.searchfield.add=!0,this.opts.searchfield.addTo=s,0}}(jQuery),/*
 * jQuery mmenu navbar add-on title content
 * mmenu.frebsite.nl
 *
 * Copyright (c) Fred Heusschen
 */
function(n){var a="mmenu",t="navbars",e="title";n[a].addons[t][e]=function(e,r){var s,i,c=n[a]._c,o=n('<a class="'+c.title+'" />').appendTo(e),l=function(n){if(n=n||this.$pnls.children("."+c.current),!n.hasClass(c.vertical)){var a=n.find("."+this.conf.classNames[t].panelTitle);a.length||(a=n.children("."+c.navbar).children("."+c.title)),s=a.attr("href"),i=a.html()||r.title,o[s?"attr":"removeAttr"]("href",s),o[s||i?"removeClass":"addClass"](c.hidden),o.html(i)}};return this.bind("openPanel",l),this.bind("initPanels",function(n){l.call(this)}),0},n[a].configuration.classNames[t].panelTitle="Title"}(jQuery);


/* End Menu */

/*============================================================================
  Product form
==============================================================================*/

  // Store pending cart action for retry after 422 error
  var pendingCartRetry = null;

  function ajaxMiniSubmitCart(toggleMiniCart, retryData) {
    $cart = $("#minicart");
    $(".pk_cardloader").show(); //for mini cart loader
    $.ajax({
      url: '/cart.js',
      dataType: 'json',
      type: 'post',
      data: $cart.serialize(),
      success: function (data) {
        // Clear retry data on success
        pendingCartRetry = null;
        refreshMiniCart(data, toggleMiniCart, false);
      },
      error: function(xhr, status, error) {
        console.error('Status:', status);
        console.error('Response:', xhr.responseText);

        // Handle 422 "Cart changed" error - refresh cart to get latest state
        if (xhr.status === 422) {
          console.log('Cart state out of sync (422 error), refreshing cart...');

          // Store retry data if provided (for minus/plus button actions)
          if (retryData) {
            pendingCartRetry = retryData;
          }

          ajaxGetCart(toggleMiniCart);
        } else {
          console.log("ajaxMiniSubmitCart error! : ", error)
        }
      }
    });
  }

 function ajaxGetCart(toggleMiniCart) {
    $.ajax({
      url: '/cart.js',
      dataType: 'json',
      type: 'get',
      success: function (data) {
        refreshMiniCart(data, toggleMiniCart, false);

        // Check if there's a pending retry after cart sync
        if (pendingCartRetry) {
          console.log('Retrying cart action after sync:', pendingCartRetry);
          const retry = pendingCartRetry;
          pendingCartRetry = null; // Clear before retry to prevent loops

          // Find the input for this product and update it
          const $input = $(`#updates_${retry.variantId}`);
          if ($input.length) {
            $input.attr("value", retry.newQuantity);
            $input.val(retry.newQuantity);

            // Submit the cart again with the updated quantity
            setTimeout(function() {
              ajaxMiniSubmitCart(toggleMiniCart);
            }, 100);
          }
        }
      },
      error: function (data) {
        console.error('ajaxMiniSubmitCart error: ', err);
        pendingCartRetry = null; // Clear on error to prevent loops
      }
    });
  }

var productFormListeners = {
  init: function(){
    $(document).on("change", "#minicart input.quantity", function() {
      $(".mm-listview").addClass('miniloader'); //for mini cart loader

      // Prepare retry data for 422 error recovery
      const $quantityInput = $(this);
      const inputId = $quantityInput.attr('id');

      // Defensive check: ensure input has an ID before processing
      if (!inputId) return;

      const variantId = inputId.replace('updates_', '');
      const quantity = parseInt($quantityInput.val());
      const retryData = {
        variantId: variantId,
        newQuantity: quantity
      };

      // Check if quantity is being set to 0 and if it matches the auto-add pair
      if(quantity === 0 && variantId) {
        removeAutoAddPairFromLocalStorage(variantId);
      }

      ajaxMiniSubmitCart(false, retryData);
    });

    $(document).on("click", ".quantity", function(e) {
      e.stopPropagation();
      e.preventDefault();
      return false;
    });

    $(document).on("click", ".minus", function(e) {
      const productId = e.target.closest('.cart_item')?.dataset.productId;
      const productHandle = e.target.closest('.cart_item')?.dataset.productHandle;
      const upsellCollection = $('.upsell-collection');
      const upsellSelector = $(`.upsell-product[data-product-id='${productId}']`);
      const addToCartText = $('.added-to-cart');

      $(".mm-listview").addClass('miniloader'); //for mini cart loader
      const $quantityInput = $(this).next("input");
      var quantity = parseInt($quantityInput.val());
      const inputId = $quantityInput.attr('id');

      // Defensive check: ensure input has an ID before processing
      if (!inputId) return;

      const variantId = inputId.replace('updates_', ''); // Extract variant ID from input ID
      quantity -= 1;

      if(quantity == 0){
        if(sessionStorage.getItem(DISCOUNT_STACK_SESSION_STORAGE_KEY)){
          let currentDiscountStack = JSON.parse(sessionStorage.getItem(DISCOUNT_STACK_SESSION_STORAGE_KEY));
          const newDiscountStack = currentDiscountStack.filter(obj => !obj.hasOwnProperty(productHandle));
          sessionStorage.setItem(DISCOUNT_STACK_SESSION_STORAGE_KEY, JSON.stringify(newDiscountStack));
        }

        // Check if this variant being removed is the auto-add pair
        if(variantId) {
          removeAutoAddPairFromLocalStorage(variantId);
        }
      }





      // bugfix 3/9/2021
      // remove 'upsell-hidden' class names which was introduced inside upsell.js's "add to cart" operation
      let upsellPrduct
      document.querySelectorAll(`.upsell-product`).forEach(el  =>{
        if(el.dataset.productId == productId){
          upsellPrduct = el
        }
      })

      if (quantity === 0) {
        if (upsellPrduct && upsellPrduct.classList.contains('upsell-hidden')){
          upsellPrduct.classList.remove('upsell-hidden')

        }
      }

      $quantityInput.attr("value", quantity);

      // Prepare retry data for 422 error recovery
      const retryData = {
        variantId: variantId,
        newQuantity: quantity
      };

      // check if upsell collection is hidden
      if(upsellCollection.hasClass('hidden')) {
        upsellCollection.slideDown(300, function() {
          $(this)
          .css('display', 'flex')
          .removeClass('hidden');
        });
      }

      // check if upsell collection is hidden
      if(upsellCollection.hasClass('hidden')) {
        upsellCollection.slideDown(300, function() {
          $(this)
          .css('display', 'flex')
          .removeClass('hidden');
        });
      }

      if (quantity == 0) {

        $('.full-ig-progress-bar').addClass('hidden');


        $(this).closest('li.cart_item').slideUp(300);

        setTimeout(ajaxMiniSubmitCart(false, retryData), 500);
        // if the item being deleted is an upsell item
        if(upsellSelector.length) {
          // show the upsell item back in the collections again
          upsellSelector.slideDown(300);
        }
      } else {

        ajaxMiniSubmitCart(false, retryData);
      }

      e.stopPropagation();
      e.preventDefault();
      return false;
    });

    $(document).on("click", ".plus", function(e) {
      $(".mm-listview").addClass('miniloader'); //for mini cart loader
      const $quantityInput = $(this).prev("input");
      var quantity = parseInt($quantityInput.val());
      const variantId = $quantityInput.attr('id').replace('updates_', ''); // Extract variant ID from input ID
      quantity += 1;
      $quantityInput.attr("value", quantity);

      // Prepare retry data for 422 error recovery
      const retryData = {
        variantId: variantId,
        newQuantity: quantity
      };

      ajaxMiniSubmitCart(false, retryData);
      e.stopPropagation();
      e.preventDefault();
      return false;
    });

    $("#cart_form input[type='number']").change(function() {
      $("#cart_form").submit();
    });

    if ($('.tos_agree').length) {
      $('body').on('click', 'input[type="submit"]', function() {
        if($(this).parents('form').find('.tos_agree').length) {
          if ($(this).parents('form').find('.tos_agree').is(':checked')) {
            $(this).submit();
          } else {
            alert("You must agree with the terms and conditions to checkout.");
            return false;
          }
        } else {
          $(this).submit();
        }
      });
    }
  },
  unload: function(){

  }
}

jQuery(document).ready(function() {

	function close_accordion_section() {
		jQuery('.accordion .accordion-section-title').removeClass('active');
		jQuery('.accordion .accordion-section-content').slideUp(300).removeClass('open');
	}

	jQuery('.accordion-section-title').click(function(e) {
		// Grab current anchor value
		var currentAttrValue = jQuery(this).attr('href');

		if(jQuery(e.target).is('.active')) {
			close_accordion_section();
		}else {
			close_accordion_section();

			// Add active class to section title
			jQuery(this).addClass('active');
			// Open up the hidden content panel
			jQuery('.accordion ' + currentAttrValue).slideDown(300).addClass('open');
		}

		e.preventDefault();
	});


  	jQuery('.mega-menu-parent').removeClass('active');

});
/*var video = document.getElementsByTagName('video');
if(typeof(video) != undefined  && $(window).width() <= 767 && $(window).width() > 500){
 // debugger;
    video.addEventListener('touchstart',function(){
            video.play();
    },false);
}
*/


// Start script for okendo page load script for change html

jQuery(document).ready(function(){
   var prevNowPlaying = null;
   $(".mm-listview").addClass('miniloader'); // for upsell minicrat loader
   $(".mm-listview").css('height','100%'); // for upsell minicrat loader

  $(".pk_cardloader").show(); // show loader for add upsell product
  
  const query = new URLSearchParams(window.location.search);
  const url = new URL(window.location.href);
  if(!query.has("showminicart") && !query.get("showminicart")) {
    ajaxGetCart(false);
  } else {
    console.log("loading from customizer!");
  }
    prevNowPlaying = setInterval(function(){ //runs every second

    	if (jQuery('.okeReviews-reviewsAggregate-mod-itm.okeReviews-reviewsAggregate-mod-itm--medAgg.js-or-medAgg').find('div').hasClass('okeReviews-mediaAggregate')) {
            if (jQuery('.wk_okendo_div').find('table').hasClass('okeReviews-attributeRatingsTable')) {
          		return;
            }
          	//debugger;
          	jQuery('.okeReviews-reviewsAggregate-mod-itm.okeReviews-reviewsAggregate-mod-itm--attRtgAv').appendTo(jQuery('.okeReviews-reviewsAggregate-side'));
       		jQuery('.okeReviews-reviewsAggregate-recommends').appendTo(jQuery('.okeReviews-reviewsAggregate-mod'));
          	jQuery('.okeReviews-reviewsAggregate-side').appendTo(jQuery('.wk_okendo_div .okeReviews-reviewsWidget-reviewsAggregate'));

        }

	}, 1000);

});

// End script for okendo page load script for change html


/*****************************************
Click event for OLD add upsell product in cart
*****************************************/
jQuery(document).on('click', '#immibtn', function(){
	var $varid = $("#upsell_select").val(); // get product variant ID
  	$(".mm-listview").addClass('miniloader'); // for upsell minicrat loader
  	$(".pk_cardloader").show(); // show loader for add upsell product
	$.ajax({
      url: '/cart/add.js',
      dataType: 'json',
      type: 'post',
      data: { quantity: 1, id: $varid },
      success: function (data) {

       	ajaxGetCart();
        $(".pk_cardloader").hide(); // hide loader for add upsell product
        $(".mm-listview").removeClass('miniloader'); //for upsell mini cart loader
      }
    });

});
/*********************************************
End Click event for OLD add upsell product in cart
*********************************************/

/*******************************************
script for show and hide product description
*******************************************/
jQuery(document).ready(function(){
    jQuery(".wh_heading").click(function(){
      if(jQuery(this).hasClass('active')){
      	jQuery('.wh_content').hide('fast');
        jQuery(this).removeClass('active');

      }else{
        jQuery('.wh_content').hide('fast');
        jQuery('.wh_heading').removeClass('active');
        jQuery(this).next('.wh_content').show('fast');
        jQuery(this).addClass('active');
      }
    });
});
/***********************************************
End script for show and hide product description
***********************************************/


/*****************************************
home page header section lazyload function
*****************************************/

/*!function(window){

    function loadImage($el, $fn) {
        jQuery($el).attr('src', jQuery($el).attr('data-src'));
        $fn ? $fn() : null;
    }

    function elementInViewport($el) {
	    var $rect = $el.getBoundingClientRect();
     	var image_status = false;
        if($rect.top >= 0 || $rect.bottom >= 0){
          image_status = true;
        }
         debugger;
        return image_status;
       // return ($rect.top >= 0 && $rect.left >= 0 && $rect.top <= (window.innerHeight || document.documentElement.clientHeight)
        //);
    }


        var images = new Array(),
            query = jQuery('img.lozad'),
            processScroll = function() {
            jQuery.each(images, function(i, img) {
                if (elementInViewport(img)) {
                   setTimeout(function(){
                    loadImage(img, function () {
                        //images.splice(i,1);
                    });
                      },1000);

                }
            });
        };

        query.each(function() {
           images.push(this);
        });

       setTimeout(function(){
        processScroll();
      },1000);
        jQuery(window).bind('scroll', processScroll);



}(this);*/
/*********************************************
End home page header section lazyload function
*********************************************/

/*********************************************************************
Start section to change colors of tabs on new wallet collections page
*********************************************************************/
          //handle ridge products tab
		  $('#products_dropdown').hover(

               function () {
                 //on dropdown hover in change the top button to grey
                  $("#products_tab").css({"background-color":"#f3f3f3"});
               }
               ,
                function () {
                  //on dropdown hover out change the top button to white
                   $("#products_tab").css({"background-color":"white"});
                }
            );

             $('#products_tab').hover(
                function () {
                  //on top button hover in change the top button to grey
                   $("#products_tab").css({"background-color":"#f3f3f3"});
                },
                function () {
                  //on top button hover out change the top button to white
                   $("#products_tab").css({"background-color":"white"});
                },
             );


            //handle wallets tab
            $('#wallets_dropdown').hover(

               function () {
                 //on dropdown hover in change the top button to grey
                  $("#wallets_tab").css({"background-color":"#f3f3f3"});
               }
               ,
                function () {
                  //on dropdown hover out change the top button to white
                   $("#wallets_tab").css({"background-color":"white"});
                }
            );

             $('#wallets_tab').hover(
                function () {
                  //on top button hover in change the top button to grey
                   $("#wallets_tab").css({"background-color":"#f3f3f3"});
                },
                function () {
                  //on top button hover out change the top button to white
                   $("#wallets_tab").css({"background-color":"white"});
                },
             );
/******************************************************************
End section to change colors of tabs on new wallet collections page
*******************************************************************/

/*********************************************************************
Start section to close mobile tab on click if it is open
*********************************************************************/
$(document).ready(function(){

	if($( window ).width() <= 767){

		$(document).on('click touch', function(event) {

		if (!$(event.target).parents().addBack().is('.immi_dropdown')) {
			$('.dropdown-content').hide();
			$('.dropbtn').css('background', 'none');
		}

		});

         $('#wallets_dropdown').hide();
       $('#products_dropdown').hide();

        $( "#li_products" ).on("click", function(){

            var $this = $(this);

            var el = $this.find('ul');

            $('#wallets_dropdown').hide();

            if (el.css('display') == 'block') {

                el.css("display", "none");
                $('#products_tab').css('background', 'none');

            } else {

              el.css("display", "block");
              $('#wallets_tab').css('background', 'none');
              $('#products_tab').css('background', '#f3f3f3');

            }

        });

        $( "#li_wallets" ).on("click", function(){

            var $this = $(this);
            var el = $this.find('ul');
            $('#products_dropdown').hide();


        if (el.css('display') == 'block') {

            el.css("display", "none");
            $('#wallets_tab').css('background', 'none');

        }else{

            el.css("display", "block");
            $('#products_tab').css('background', 'none');
            $('#wallets_tab').css('background', '#f3f3f3');

        }

        });

   	}/*else{

		$("#li_wallets, #wallets_dropdown").hover(function(){
			$("#products_dropdown").hide();

			if ($("#wallets_dropdown").css('display') == 'none') {

				$("#wallets_dropdown").show();

			}
		},function(){

			setTimeout(function(){ $("#wallets_dropdown").hide(); }, 300);

		});
		$("#li_products, #products_dropdown").hover(function(){

			$("#wallets_dropdown").hide();

			if ($("#products_dropdown").css('display') == 'none') {

				$("#products_dropdown").show();

		 	}
		},function(){

			setTimeout(function(){ $("#products_dropdown").hide(); }, 300);

		});
	}*/
});
/******************************************************************
End section to close mobile tab on click if it is open
*******************************************************************/


      //add fb event to shop on amazon button on shogun shop-amazon page
       $(".shop-on-amazon").click(function(){

        fbq('track', 'StartTrial');

       });


/******************************************************************
Start feature for adding an item to the cart based on parameters in the URL functionality
*******************************************************************/
/******************************************************************
 End feature for adding an item to the cart based on parameters in the URL functionality
 *******************************************************************/

/******************************************************************
Start feature to remove cavity tray from upsell when it's added to the cart.
 *******************************************************************/

/*
Similar to the feature of adding item to cart based on url,
the interval will keep looking for the pop up button.

The window.location.reload() is necessary so that
cart-upsell.liquid can run correctly - because it depends on the
Free Cavity Tray to be in the cart to run the logic of NOT including the original cavity tray in the upsell.

cart-upsell.liquid will prevent cavity tray from showing up if cavity tray is in cart.
app.js.liquid will refresh the browser so that cart-upsell.liquid sees the free cavity tray in the cart.

On FIRST initial load of the website, the Free Cavity Tray isn't in the cart, so
cart-upsell.liquid doesn't prevent the original cavity tray from showing in the upsell.

*/

var removeTrayTimesRunBtnCapture_mobile_popup = 0;
var removeTraybtnCapture_mobile_popup = setInterval(function () {
  removeTrayTimesRunBtnCapture_mobile_popup++;

  if (removeTrayTimesRunBtnCapture_mobile_popup === 30) {
    clearInterval(removeTraybtnCapture_mobile_popup);
  }

  // 2nd popup buttons
  const noThanksBtn = document.querySelector("#bx-element-1421473-qGMCUcK > button"); // works
  const addMobileXBtn = document.querySelector("#bx-close-inside-1421473 > svg");

  if (noThanksBtn) {
    noThanksBtn.addEventListener("click", function(){
      window.location.reload();
    });
  }

  if (addMobileXBtn) {
    addMobileXBtn.addEventListener("click", function(){
      window.location.reload();
    });
  }
}, 1000);

var removeTrayTimesRunBtnCapture_last_popup = 0;
var removeTraybtnCapture_last_popup = setInterval(function () {
  removeTrayTimesRunBtnCapture_last_popup++;

  if (removeTrayTimesRunBtnCapture_last_popup === 30) {
    clearInterval(removeTraybtnCapture_last_popup);
  }
  // 3rd (last) popup buttons
  const lastPopupContinueShoppingBtn = document.querySelector("#bx-element-1421473-pdEAJP8 > button");
  const lastPopupXBtn = document.querySelector("#bx-close-inside-1421473 > svg");

  if (lastPopupContinueShoppingBtn) {
    lastPopupContinueShoppingBtn.addEventListener("click", function(){
      window.location.reload();
    });
  }

  if (lastPopupXBtn) {
    lastPopupXBtn.addEventListener("click", function(){
      window.location.reload();
    });
  }

}, 1000);

/******************************************************************
End feature to remove cavity tray from upsell when it's added to the cart.
*******************************************************************/
/******************************************************************
Start feature to change notification bar if URL contains source=referral
*******************************************************************/
// if (currentURL.includes("source=referral")) {

//  $('.promo_banner p strong').text('FREE SHIPPING & RETURNS ON ALL WALLETS')

// }
/******************************************************************
End feature to change notification bar if URL contains source=referral
*******************************************************************/

/******************************************************************
Start feature to reload window on sudden resize from mobile to desktop.
Also add flickity resize on window resize to avoid odd warping of carousels.
*******************************************************************/
let prevWidth = 0;
let currentWidth = $(window).width();

$(document).ready(function() {

    prevWidth = $(window).width();

    setTimeout(function () {
      if (currentWidth >= 768) {
    //$('.product_gallery').flickity('resize')
      }
    }, 3000);
});

$(window).resize(function() {

    let screenChange = currentWidth - prevWidth;

    if (screenChange > 1000) {
      window.location.reload();
    }

    prevWidth = currentWidth;

    setTimeout(function () {
    $('.product_gallery').flickity('resize')
    }, 3000);

});
/******************************************************************
End feature to reload window on sudden resize from mobile to desktop.
*******************************************************************/
let leftMenu=$('#leftMenu').mmenu({
  navbar: {
    add: false
  },
  offCanvas: {
    zposition: 'front',
    position: 'left',
    pageSelector: "#content_wrapper"
  },
  "extensions": [
    "theme-white"
  ],
  "navbars": [
    {
      "position": "top",
      "content": [
        `
        <div class="sidemenu_header_container">
          <svg xmlns="http://www.w3.org/2000/svg" width="74" height="22" viewBox="0 0 74 22" fill="none">
            <path d="M32.7851 0.00372314H25.6679V21.3823H32.7851C36.3188 21.3823 38.7015 19.7977 39.6722 16.7973C40.0366 15.6693 40.1863 13.889 40.1863 10.6431C40.1863 7.3972 40.0405 5.73587 39.6722 4.59251C38.7015 1.59215 36.3226 0.00755782 32.7851 0.00755782V0.00372314ZM36.0617 15.5043C35.4939 17.2309 34.2278 18.0021 31.9487 18.0021H29.4088V3.38393H31.9487C34.2278 3.38393 35.4977 4.15512 36.0656 5.88934C36.3035 6.53776 36.4186 8.04945 36.4186 10.6393C36.4186 13.2291 36.3035 14.8559 36.0656 15.5043H36.0617Z" fill="white"/>
            <path d="M42.7498 10.2709C42.7498 13.6396 42.9148 15.7115 43.2639 16.7935C44.2346 19.7938 46.6134 21.3784 50.1509 21.3784H57.2682V8.7746H49.2109L50.8723 12.1548H53.5311V17.9982H50.9912C48.7121 17.9982 47.4422 17.227 46.8743 15.4928C46.6518 14.8866 46.5213 12.9835 46.5213 10.2671C46.5213 7.42021 46.6633 6.45334 46.8743 5.87399C47.4383 4.14744 48.7083 3.38008 50.9874 3.38008H57.2682V-0.00012207H50.1509C46.6173 -0.00012207 44.2346 1.58447 43.2639 4.58483C42.9224 5.63611 42.7498 6.80633 42.7498 10.2671V10.2709Z" fill="white"/>
            <path d="M74.0001 3.38393V0.00372314H61.0049V21.3784H74.0001V17.9982H64.7458V12.1586H71.3489L73.0102 8.77844H64.7458V3.38393H74.0001Z" fill="white"/>
            <path d="M15.2282 21.3785L10.7161 12.6729L10.8005 12.6422C13.2561 11.7828 14.8253 9.64567 14.8944 7.05968V6.87551L14.8982 6.17338C14.8982 2.5975 12.1242 0 8.30663 0H0V21.3785H3.73702V3.3802H3.85597H8.18769C10.0102 3.3802 11.1919 4.47752 11.1919 6.17338V6.87935C11.1919 8.57521 10.014 9.67253 8.18769 9.67253H7.99585L6.59159 12.5271L10.9655 21.3785H15.232H15.2282Z" fill="white"/>
            <path d="M21.8812 5.59775V0.00372314H18.1404V21.3784H21.8812V9.67241H19.8746L21.8812 5.59775Z" fill="white"/>
          </svg>
          <div class="sidemenu__cross" id="sidemenu__close">
          <svg fill="#9a9a9a" width="20px" height="20px" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
              <path d="M0 14.545L1.455 16 8 9.455 14.545 16 16 14.545 9.455 8 16 1.455 14.545 0 8 6.545 1.455 0 0 1.455 6.545 8z" fill-rule="evenodd"/>
          </svg>
          </div>
        </div>
        `
      ]
    },
    {
      "position": "bottom",
      "content": [
        `
        <div class="sidemenu__patents">
          <span>
            © The Ridge 2026 US Patents Issued, No. 10,791,808
          </span>
        </div>
        `
      ]
    }
  ],
});
const mmmenuApi=leftMenu.data('mmenu');
const closeIcon=document.getElementById('sidemenu__close');
if(closeIcon) {
  closeIcon.addEventListener('click',function(){
    mmmenuApi.close();
  });
}

const targetElement = document.querySelector('.sidemenu-container.mm-menu.mm-theme-white.mm-offcanvas.mm-front.mm-hasnavbar-top-1');

const observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    // Check if the mm-current and mm-opened classes are added
    const hasClasses = targetElement.classList.contains('mm-current') && targetElement.classList.contains('mm-opened');

    // If the classes are added, set HTML overflow to hidden
    if (hasClasses) {
      document.documentElement.style.overflow = 'hidden';
    } else {
      // If the classes are not present, reset HTML overflow to its default value
      document.documentElement.style.overflow = '';
    }
    if(!targetElement.classList.contains('mm-opened')) {
      mmmenuApi.close();
      targetElement.style.display = 'none';
    }
  });
});

// Configure and start the observer
const config = { attributes: true, attributeFilter: ['class'] };
if(targetElement) observer.observe(targetElement, config);

$('#minicart').mmenu({
  navbar: {
    add: false
  },
  // configuration
  classNames: {
    nopanel: ""
  },
  offCanvas: {
    zposition: 'front',
    position: 'right',
    pageSelector: "#content_wrapper"
  },
  "extensions": [
    "theme-white"
  ],
  "navbars": [
    {
      "position": "bottom",
      "content": [
        `
        <div class="upsell-checkout">
          <div class="fondue-cashback-module"></div>
          <div class="subtotal">
            <span class="text">
              TOTAL
              <span class="subtotal_adjacent_message">
                (Excluding Sales Tax)
              </span>
            </span>
            <!-- price is populated by upsell.js updateUpsellSubtotal function -->
            <div>
              <span class="price"></span>
              <span class="originalPrice"></span>
              <span class="discount-message"></span>
            </div>
          </div>
          <span class="submit_icnss">
            <input type="submit" class="gtm_checkout_button action_button right minicart_sticky_checkout" value="Checkout" />
          </span>
          <div class="minicart-checkout-message">
            <div id="minicart_message_replace"></div>
          </div>
        </div>
        `
      ]
    }
  ],
});
// minicart initialized sooner to avoid minicart glitching when a page loads
async function fetchMinicartMetafieldMessage() {
  let minicart_checkout_message = "";
  let query = `
    query {
      shop {
        metafield(namespace: "accentuate", key: "minicart_checkout_message") {
          value
        }
      }
    }
  `
  if( THEMEKIT_STOREFRONT_TOKEN === "") {
    console.error("GraphQL Error! storefront_token is not set up correctly in settings_data.json for product archetype to work in minicart!")
    return null;
  }

  // Graphql Storefront API Docs link https://shopify.dev/api/storefront/2022-10/queries/shop
  await $.ajax({
    type: "POST",
    url: GRAPHQL_URL_VERSION,
    headers: graphqlHeadersObj,
    data: query,
    success: function(res) {
      if (res.data.shop.metafield === null) {
        minicart_checkout_message = "";
      } else {
        try {
          // Parse the JSON string and extract the first element from the array
          const parsedValue = JSON.parse(res.data.shop.metafield.value);
          minicart_checkout_message = Array.isArray(parsedValue) ? parsedValue[0] : parsedValue;
        } catch (e) {
          console.error("Error parsing minicart checkout message:", e);
          minicart_checkout_message = "";
        }
      }
    },
    error: function (status) {
      console.log("fetchMinicartCheckoutMessage function failed!!", status);
    },
  });
  // If there is no message, then flex the container. Otherwise, there's a large space at the bottom where the message would be.
  const minicartCheckoutContainer = document.querySelector(".mm-menu>.mm-navbar");
  const upsellContainer = document.querySelector("#mm-1");
  if(minicart_checkout_message != "") {
    upsellContainer.classList.add("minicart-checkout-message");
    minicartCheckoutContainer.classList.add("minicart-checkout-message");
    $("#minicart_message_replace").replaceWith(minicart_checkout_message);
  }
}

if(MINICART_GRAPHQL_PRODUCT_ARCHETYPE_TOGGLE) {
  // This function is purposely initialized AFTER the #minicart.mmenu function to avoid minicart glitches on page load
  fetchMinicartMetafieldMessage()

  /******************************************************************
  START function to stash product archetypes into object when user
  visits a PDP so that it's faster when user add product to cart
  **NOTE** Try to keep this function last in app.js since it can load
  after everything else. So add any new code ABOVE this comment.
  *******************************************************************/
  storeGraphqlFetchedDataOnLoad();
}



if (window.innerWidth < 768) {
    let checkIfJTBExistsAtAll = $('.ridge-jtbPersonalize__container').length;
    let checkIfJTBExistsDisplayNone = $('.ridge-jtbPersonalize__container').css('display') === 'none';

      if (checkIfJTBExistsAtAll == 0 || checkIfJTBExistsDisplayNone == true) {
        $('.vu_add_to_cart, .add_to_cart').css('margin-top', '10px')
      }

 $('.productSelector__options').click(function(){
   console.log('test test test test test ')
     if (checkIfJTBExistsAtAll == 0 || checkIfJTBExistsDisplayNone == true) {
    $('.vu_add_to_cart, .add_to_cart').css('margin-top', '10px')
    }
  })
}





// Method 1: Create and append a style element
function injectCSS() {
    const css = `
        #AddToCartMOB {
            transform: translateY(25px);
        }
        
        .mob_addtocart_btn {
            height: 120px !important;
        }
    `;
    
    const style = document.createElement('style');
    style.type = 'text/css';
    style.innerHTML = css;
    document.head.appendChild(style);
}

// Method 2: Using insertRule (more performant for single rules)
function injectCSSWithInsertRule() {
    const style = document.createElement('style');
    document.head.appendChild(style);
    const sheet = style.sheet;
    
    sheet.insertRule('#AddToCartMOB { transform: translateY(25px); }', 0);
    sheet.insertRule('.mob_addtocart_btn { height: 120px !important; }', 1);
}

// Method 3: Check if styles already exist to avoid duplicates
function injectCSSOnce() {
    // Check if our custom styles are already injected
    if (!document.getElementById('custom-mobile-cart-styles')) {
        const css = `
            #AddToCartMOB {
                transform: translateY(25px);
            }
            
            .mob_addtocart_btn {
                height: 120px !important;
            }
        `;
        
        const style = document.createElement('style');
        style.id = 'custom-mobile-cart-styles';
        style.type = 'text/css';
        style.innerHTML = css;
        document.head.appendChild(style);
        
       // console.log('Custom mobile cart styles injected');
    } else {
       // console.log('Custom mobile cart styles already exist');
    }
}





function whichBrowser() {
if (isFirefox()) {
return "Firefox";
} else if (isEdge()) {
return "Edge";
} else if (isIE()) {
return "Internet Explorer";
} else if (isOpera()) {
return "Opera";
} else if (isVivaldi()) {
return "Vivalid";
} else if (isChrome()) {
  // Execute the injection
injectCSSOnce();
// Alternative: Wait for DOM to be ready if needed
// document.addEventListener('DOMContentLoaded', injectCSSOnce);
return "Chrome";
} else if (isSafari()) {
return "Safari";
} else {
return "Unknown";
}
}

function agentHas(keyword) {
return navigator.userAgent.toLowerCase().search(keyword.toLowerCase()) > -1;
}

function isIE() {
return !!document.documentMode;
}

function isSafari() {
return (!!window.ApplePaySetupFeature || !!window.safari) && agentHas("Safari") && !agentHas("Chrome") && !agentHas("CriOS");
}

function isChrome() {
return agentHas("CriOS") || agentHas("Chrome") || !!window.chrome;
}

function isFirefox() {
return agentHas("Firefox") || agentHas("FxiOS") || agentHas("Focus");
}

function isEdge() {
return agentHas("Edg");
}

function isOpera() {
return agentHas("OPR");
}

function isVivaldi() {
return agentHas("Vivaldi");
}

whichBrowser()



function addCustomCSS() {
  
  const progressBars = document.querySelectorAll('.ig-progress-bar');
  
  if (progressBars.length === 0) {
    
    if (!document.getElementById('ig-progress-bar-custom-styles')) {
      
      const styleElement = document.createElement('style');
      styleElement.id = 'ig-progress-bar-custom-styles';
      
      
      styleElement.textContent = `
        #mm-2 > ul > li.added-to-cart {
          display: flex !important;
        }
        
        .empty-ig-progress-bar, .full-ig-progress-bar {
          display: none;
        }
      `;
      
      
      document.head.appendChild(styleElement);
      
    //  console.log('Custom CSS added for .ig-progress-bar elements');
    }
  }
}


setTimeout(addCustomCSS, 6000);




function addToCartWithDiscount(variantId, quantity, discount) {
  let promise = Promise.resolve();
  
  // Step 1: Add item to cart if variantId exists
  if (variantId) {
    promise = fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        items: [{
          id: variantId,
          quantity: quantity
        }]
      })
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Failed to add item to cart');
      }
      return response.json();
    })
    .then(data => {
     // console.log('Item added to cart:', data);
    });
  }
  
  // Step 2: Apply discount if discount exists
  if (discount) {
    promise = promise.then(() => {
      return fetch(`/discount/${discount}`);
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Failed to apply discount');
      }
      console.log('Discount applied successfully');
    });
  }
  
  // Step 3: Always refresh mini cart at the end
  promise.then(() => {
    return fetch('/cart.js');
  })
  .then(response => response.json())
  .then(cart => {
    refreshMiniCart(cart, false, true);
  })
  .catch(error => {
    console.error('Error:', error);
  });
}

// Usage with sessionStorage, URL check, and run-once flag:
if (window.location.href.includes('product') && 
    (sessionStorage.getItem('6rlp_item_to_add') || sessionStorage.getItem('6rlp_discount_to_add')) &&
    !sessionStorage.getItem('6rlp_already_added')) {
  
  // Set flag BEFORE running function to prevent race conditions
  sessionStorage.setItem('6rlp_already_added', 'true');
  
  addToCartWithDiscount(
    sessionStorage.getItem('6rlp_item_to_add'), 
    1, 
    sessionStorage.getItem('6rlp_discount_to_add')
  );
}

